import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ExamService} from "./exam.service";
import {Router} from "@angular/router";
import {LoginService} from "../login/login.service";
import {HeaderService} from "../header/header.service";
import {FeeManagementService} from "../feesmanage/feesmanage.service";
import {Offcanvas} from "../form.offcanvas";
import {FormValidator} from "../form.validator";
import {DatePipe} from "@angular/common";
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
//import {Http, Response} from "@angular/http";
import {ScriptLoader} from "../script-loader";
import { firstValueFrom } from 'rxjs';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BrandService } from '../brand/brand.service';

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var customToastr: any;
declare var materialadmin: any;
declare var momentJs: any;
declare var moment: any;
declare var window: any;
declare var document: any;


@Component({
  selector: 'app-exam',
  templateUrl: './exam.component.html',
  styleUrls: [
    './../../assets/css/theme-default/bootstrap.css',
    './../../assets/css/theme-default/materialadmin.css',
    './../../assets/css/theme-default/font-awesome.min.css',
    './../../assets/css/theme-default/material-design-iconic-font.min.css',
    /*'./../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
    './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
    './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
    './exam.component.css',
    './../../css/timepicker.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [LoginService,HeaderService,ExamService,FeeManagementService,Offcanvas,FormValidator,DatePipe,ScriptLoader]
})
export class ExamComponent implements OnInit {
  schoolName="";
    getSchoolName(){
      this.examService.getSchoolDetailsService(this.academicInfo.current_academic,this.getAuthToken)
        .subscribe(
          (data: any) => {
            let school = "Radiant Central Children Academy";
            this.schoolName = school.split(' ').join('+');
          }
        );
    }
  callUrl(){
      this.csvURL = "https://s3-us-west-2.amazonaws.com/bluewingsml/"+this.schoolName+"/Prediction.csv";
      this.csvURL1 = "https://s3-us-west-2.amazonaws.com/bluewingsml/"+this.schoolName+"/Total_Model.csv";
    }

  academicInfo = {
    current_academic:'',
    current_academic_state:'',
    current_tab:'EXAM_MANAGEMENT',
    year:'',
    academicList:[]
  };


  type: 'line';
    private langChangeSubscription: any;
  data: any;
  options: any;
  csvURL: string = 'https://s3-us-west-2.amazonaws.com/bluewingsml/'+this.schoolName+'/Prediction.csv';
  csvURL1: string= 'https://s3-us-west-2.amazonaws.com/bluewingsml/'+this.schoolName+'/Total_Model.csv';
  csvData: any[] = [];
  precsvData: any[] = [];
  lines = [];
  data1= [];
  preddata = [];
  value = [];
  name = [];
  section = [];
  gender = [];
  year = [];
  tarr = [];
  grade = [];
  year2014=[];
  year2015=[];
  year2016=[];
  year2017=[];
  prelines = [];
  predata = [];
  prevalue = [];
  prename = [];
  presection = [];
  pregender = [];
  preyear = [];
  pretarr = [];
  pregrade = [];
  preyear2014=[];
  preyear2015=[];
  preyear2016=[];
  preyear2017=[];
  graphCount2014 = {
    count:0,count1:0,count2:0,count3:0,count4:0
  };
  graphCount2015 = {
    count:0,count1:0,count2:0,count3:0,count4:0
  };
  graphCount2016 = {
    count:0,count1:0,count2:0,count3:0,count4:0
  };
  graphCountPredict = {
    count:0,count1:0,count2:0,count3:0,count4:0
  };


  brand = this.brandService.brand;
  constructor(private examService: ExamService,private feeService:FeeManagementService, private loginservice: LoginService, private router: Router, private offcanvas: Offcanvas, private  formValidator: FormValidator, public datepipe: DatePipe, private http: HttpClient, private scriptLoader:ScriptLoader, private translate: TranslateService, private brandService: BrandService) {
    this.options = {
      responsive: true,
      maintainAspectRatio: false
    };
  }

  getAuthToken = localStorage.getItem('usertoken');
  getSchoolId = localStorage.getItem('schoolinfo');
  getAcademicId = localStorage.getItem('academicInfo');
  sectionArray = ['A','B','C','D','E','F','G'];
  createPattern = {patternName:"",patternDesc:"",totalMarks:"",totalSection:null,
    sections:[]
  };
  classStandardList = [];
  examConfig = {
    examName:"",reportName:"",status:"",IsScholasticType:"",examStartDate:"",examEndDate:"",classListArray:[]
  };
  allClass = false;
  examConfigMainPage = true;
  classDetailForExam = false;
  examCategoryName = "";
  evaluationType = "MARKS";
  examCategoryListArray = [];
  examCatStatus = true;
  examCatDataStatus = false;
  totalExamCount = 0;
  totalExamCategoryCount = 0;
  categoryForExamList = [];
  sectionStatus = false;
  sectionUse = false;
  examList = [];
  examDuration;
  examStartTime = '07:00 AM';
  /*Complete Exam*/
  completedExamScheduleList = [];
  completedStatus = false;
  completedDataStatus = false;
  completedListDataTable = false;
  /*Upcoming Exam*/
  upcomingExamScheduleList = [];
  upcomingStatus = false;
  upcomingDataStatus = false;
  upcomingListDataTable = false;
  /*Current Date Exam*/
  currentExamScheduleList = [];
  currentStatus = false;
  currentDataStatus = false;
  currentListDataTable = false;
  /*Others*/
  selectedExamCategoryId;
  selectedCategoryName = "";
  selectedExamType = "";
  categoryIdForDeleteCategory;
  examStatus = false;
  examDataStatus = false;
  examListDataTable = false;
  classDetailList = [];
  examName = "";
  examType = "";
  classStatus = false;
  classDataStatus = false;
  classData = false;
  selectedClassName = "";
  sectionListOfClass = [];
  selectedExamId;
  selectedClassStdId;
  selectedExamStartDate;
  selectedExamEndDate;
  subjectListArray = [];
  subjectErrorMsg = ""
  examsDate;
  review = false;
  loginMode = "";
  resultPublishTypePercent = true;
  resultPublishTypeMarks = true;
  isGenerateReport = false;

  /*Data Table Creation */
  destroyDataTable(table){
    $('#'+table).DataTable().destroy();
  }
 initializeDataTable(table) {
  const self = this;
  setTimeout(function () {
    self.translate.get([
      'dataTables.emptyTable',
      'dataTables.lengthMenu',
      'dataTables.search',
      'dataTables.info',
      'dataTables.infoEmpty',
      'dataTables.infoFiltered',
      'dataTables.zeroRecords',
      'dataTables.paginate.first',
      'dataTables.paginate.previous',
      'dataTables.paginate.next',
      'dataTables.paginate.last'
    ]).subscribe(translations => {
      $('#' + table).DataTable({
        order: [[0, 'asc']],
        language: {
          emptyTable: translations['dataTables.emptyTable'],
          lengthMenu: translations['dataTables.lengthMenu'],
          search: `<i class="fa fa-search"></i> ${translations['dataTables.search']}`,
          info: translations['dataTables.info'],
          infoEmpty: translations['dataTables.infoEmpty'],
          infoFiltered: translations['dataTables.infoFiltered'],
          zeroRecords: translations['dataTables.zeroRecords'],
          paginate: {
            first: translations['dataTables.paginate.first'],
            previous: `<i class="fa fa-angle-left"></i> ${translations['dataTables.paginate.previous']}`,
            next: `${translations['dataTables.paginate.next']} <i class="fa fa-angle-right"></i>`,
            last: translations['dataTables.paginate.last']
          }
        }
      });
    });
    // self.scriptInit(); // Uncomment if needed
  }, 500);
}


 initializeDataTableOrder(table) {
  const self = this;
  setTimeout(function () {
    self.translate.get([
      'dataTables.emptyTable',
      'dataTables.lengthMenu',
      'dataTables.search',
      'dataTables.info',
      'dataTables.infoEmpty',
      'dataTables.infoFiltered',
      'dataTables.zeroRecords',
      'dataTables.paginate.first',
      'dataTables.paginate.previous',
      'dataTables.paginate.next',
      'dataTables.paginate.last'
    ]).subscribe(translations => {
      $('#' + table).DataTable({
        order: [],
        language: {
          emptyTable: translations['dataTables.emptyTable'],
          lengthMenu: translations['dataTables.lengthMenu'],
          search: `<i class="fa fa-search"></i> ${translations['dataTables.search']}`,
          info: translations['dataTables.info'],
          infoEmpty: translations['dataTables.infoEmpty'],
          infoFiltered: translations['dataTables.infoFiltered'],
          zeroRecords: translations['dataTables.zeroRecords'],
          paginate: {
            first: translations['dataTables.paginate.first'],
            previous: `<i class="fa fa-angle-left"></i> ${translations['dataTables.paginate.previous']}`,
            next: `${translations['dataTables.paginate.next']} <i class="fa fa-angle-right"></i>`,
            last: translations['dataTables.paginate.last']
          }
        }
      });
    });
    // this.scriptInit(); // Uncomment if needed
  }, 500);
}

initializeDataTableWithOutPaging(table) {
  const self = this;
  setTimeout(function () {
    self.translate.get([
      'dataTables.emptyTable',
      'dataTables.lengthMenu',
      'dataTables.search',
      'dataTables.info',
      'dataTables.infoEmpty',
      'dataTables.infoFiltered',
      'dataTables.zeroRecords',
      'dataTables.paginate.first',
      'dataTables.paginate.previous',
      'dataTables.paginate.next',
      'dataTables.paginate.last'
    ]).subscribe(translations => {
      $('#' + table).DataTable({
        "order": [],
        "paging": false,
        "bSort": false,
        language: {
          emptyTable: translations['dataTables.emptyTable'],
          lengthMenu: translations['dataTables.lengthMenu'],
          search: `<i class="fa fa-search"></i> ${translations['dataTables.search']}`,
          info: translations['dataTables.info'],
          infoEmpty: translations['dataTables.infoEmpty'],
          infoFiltered: translations['dataTables.infoFiltered'],
          zeroRecords: translations['dataTables.zeroRecords'],
          paginate: {
            first: translations['dataTables.paginate.first'],
            previous: `<i class="fa fa-angle-left"></i> ${translations['dataTables.paginate.previous']}`,
            next: `${translations['dataTables.paginate.next']} <i class="fa fa-angle-right"></i>`,
            last: translations['dataTables.paginate.last']
          }
        }
      });
    });
    //this.scriptInit();
  }, 500);
}


  countOfExamAndCategory(){
    this.examService.countOfExamAndCategoryService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.totalExamCount = data[0].TotalExam;
          this.totalExamCategoryCount = data[0].TotalExamCategory;
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  examCategoryList(){
    this.examCategoryListArray = [];
    this.destroyDataTable('allCategoryTable');
    this.examService.examCategoryListService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.examCategoryListArray = data;
          this.initializeDataTableOrder('allCategoryTable');
          this.examCatStatus = false;
          if(this.examCategoryListArray.length == 0){
            this.examCatDataStatus = true;
          }
          else {
            this.examCatDataStatus = false;
          }
        },
        async error => {
          this.examCatStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError'));
           customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  async createExamCategory(){
    var boardList = [];
    for(var i=0; i<this.examBoardArray.length; i++){
      if(this.examBoardArray[i].select == true){
        boardList.push({boardId:this.examBoardArray[i].pkSchoolExamBoardId})
      }
    }
    if(!this.formValidator.validateIsDataForNumber(this.examCategoryName)){
      const pleaseEnterExamCategoryNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterExamCategoryName')); 
      customToastr(pleaseEnterExamCategoryNameTranslation, 'error');
      return;
    }
    if(boardList.length == 0){
      const pleaseSelectAtleastOneExamBoardTranslation = await firstValueFrom(this.translate.get('pleaseSelectAtleastOneExamBoard')); 
      customToastr(pleaseSelectAtleastOneExamBoardTranslation, 'error');
      return;
    }
    var examCategoryData = {
      examCategoryName:this.examCategoryName,
      boardListArray:boardList,
      current_academic:this.academicInfo.current_academic
    };
     $("#createCatButton").attr("disabled", true);
     this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#createCatButton").text(translatedText); });
     $("#cancelCatButton").attr("disabled", true);
    this.examService.createExamCategoryService(examCategoryData, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#createCatButton").attr("disabled", false);
          this.translate.get('create').subscribe((translatedText: string) => { $("#createCatButton").text(translatedText); });
          $("#cancelCatButton").attr("disabled", false);
          if(data.status == true){
            const examCategorySuccessfullyCreatedTranslation = await firstValueFrom(this.translate.get('examCategorySuccessfullyCreated')); 
            customToastr(examCategorySuccessfullyCreatedTranslation, 'success');
            $("#cancelCatButton").trigger("click");
            this.examCategoryList();
            this.countOfExamAndCategory();
          }
          else if(data.status == false){
            const examCategoryNameAlreadyExitsPleaseEnterOtherNameTranslation = await firstValueFrom(this.translate.get('examCategoryNameAlreadyExitsPleaseEnterOtherName')); 
            customToastr(examCategoryNameAlreadyExitsPleaseEnterOtherNameTranslation, 'error');
          }
          else {
           const examCategoryNotCreatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('examCategoryNotCreatedPleaseTryAgain')); 
           customToastr(examCategoryNotCreatedPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          $("#createCatButton").attr("disabled", false);
          this.translate.get('create').subscribe((translatedText: string) => { $("#createCatButton").text(translatedText); });
          $("#cancelCatButton").attr("disabled", false);
          const internalServerErrorPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('internalServerErrorPleaseTryAgain')); 
          customToastr(internalServerErrorPleaseTryAgainTranslation, 'error');
        }
      );
  }
  clearCreateCatData(){
    this.examCategoryName = "";
    this.evaluationType = "MARKS";
    this.getExamBoardNameList();
  }

  updateExamCategory(cat){
    this.selectedExamCategoryId = cat.pkExamCategoryId;
    this.selectedCategoryName = cat.examCategoryName;
    this.selectedExamType = cat.EvaluationType;
  }
  updateSelectedExamCategory(){
    $("#updateExamCat").attr("disabled", true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#updateExamCat").text(translatedText); });
    $("#cancelUpdateExamCategory").attr("disabled", true);
    this.examService.updateExamCategoryService(this.selectedExamCategoryId, this.selectedCategoryName,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#updateExamCat").attr("disabled", false);
          this.translate.get('update').subscribe((translatedText: string) => { $("#updateExamCat").text(translatedText); });
          $("#cancelUpdateExamCategory").attr("disabled", false);
          if(data[0].isSuccess == 1){
            const examCategorySuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('examCategorySuccessfullyUpdated')); 
            customToastr(examCategorySuccessfullyUpdatedTranslation, 'success');
            $("#cancelUpdateExamCategory").trigger("click");
            this.examCategoryList();
          }
          else if(data[0].isSuccess == 0){
            const examCategoryNameAlreadyExitsPleaseEnterOtherNameTranslation = await firstValueFrom(this.translate.get('examCategoryNameAlreadyExitsPleaseEnterOtherName')); 
            customToastr(examCategoryNameAlreadyExitsPleaseEnterOtherNameTranslation, 'error');
          }
          else {
            const examCategoryNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('examCategoryNotUpdatedPleaseTryAgain')); 
            customToastr(examCategoryNotUpdatedPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          $("#updateExamCat").attr("disabled", false);
          this.translate.get('update').subscribe((translatedText: string) => { $("#updateExamCat").text(translatedText); });
          $("#cancelUpdateExamCategory").attr("disabled", false);
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  deleteExamCategory(categoryId){
    this.categoryIdForDeleteCategory = categoryId;
  }
  deleteSelectedExamCategory(){
    $("#deleteCatButton").attr("disabled", true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#deleteCatButton").text(translatedText); });
    $("#cancelDeleteCatButton").attr("disabled", true);
    this.examService.deleteExamCategoryService(this.categoryIdForDeleteCategory,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#deleteCatButton").attr("disabled", false);
          this.translate.get('confirm').subscribe((translatedText: string) => { $("#deleteCatButton").text(translatedText); });
          $("#cancelDeleteCatButton").attr("disabled", false);
          if(data.status == true){
            const examCategorySuccessfullyDeletedTranslation = await firstValueFrom(this.translate.get('examCategorySuccessfullyDeleted')); 
            customToastr(examCategorySuccessfullyDeletedTranslation, 'success');
            $("#cancelDeleteCatButton").trigger("click");
            this.examCategoryList();
            this.countOfExamAndCategory();
          }
          else {
            const examCategoryNotDeletedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('examCategoryNotDeletedPleaseTryAgain')); 
            customToastr(examCategoryNotDeletedPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          $("#deleteCatButton").attr("disabled", false);
          this.translate.get('confirm').subscribe((translatedText: string) => { $("#deleteCatButton").text(translatedText); });
          $("#cancelDeleteCatButton").attr("disabled", false);
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  patternDataChange(){
    this.createPattern.sections = [];
    if(this.createPattern.totalSection > 0){
      for (var i=0; i<this.createPattern.totalSection; i++){
        this.createPattern.sections.push({
          sectionName:"",sectionDesc:"",sectionMarks:"",totalQuestion:null,splitSecMarks:false,questionList:[]
        });
      }
    }
  }
  questionDataChange(sectionList,index) {
    this.createPattern.sections[index].questionList = [];
    if (sectionList.totalQuestion > 0) {
      for (var j = 0; j < sectionList.totalQuestion; j++) {
        var f = j+1;
        this.createPattern.sections[index].questionList.push({
          questionNum:f,questionDesc:"",questionMarks:""
        });
      }
    }
  }
  splitMarks(sec,check){
      for(var i=0; i<sec.questionList.length; i++){
        if (check == true){
          sec.questionList[i].questionMarks = (sec.sectionMarks/sec.totalQuestion);
        }
        else {
          sec.questionList[i].questionMarks = "";
        }
    }
  }

  fetchRequireDetails(){
    $("#examName").css({
      'border-color':'gainsboro'
    });
    this.fetchClassStandardList();
    this.categoryListForExam();
    this.getExamBoardNameList();
    this.fetchExamBoardClassList();
    this.fetchScholasticConfigurationList();
    this.allClass = false;
    $("#startDate").val('');
    $("#endDate").val('');
    this.examConfig = {
      examName:"",reportName:"",status:"",IsScholasticType:"",examStartDate:"",examEndDate:"",classListArray:[]
    };
  }
  examBoardClassList = [];
  fetchExamBoardClassList(){
    this.examBoardClassList = [];
    this.examService.fetchExamBoardClassListService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.examBoardClassList = data;
          var h = this;
          setTimeout(function () {
            for(var i=0; i<h.examBoardClassList.length; i++){
              $("#boardClass"+h.examBoardClassList[i].SchoolExamBoardId).hide();
            }
          },5)
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  classListStatus = false;
  checkingForClasses(board){
    var status = $("#boardId"+board.pkSchoolExamBoardId).prop("checked");
    if(status){
      this.classListStatus = true;
      $("#boardClass"+board.pkSchoolExamBoardId).show();
    }
    else {
      this.classListStatus = false;
      $("#boardClass"+board.pkSchoolExamBoardId).hide();
    }
  }
  checkingForClassesUpdate(board){
    var status = $("#boardIdForUpdate"+board.pkSchoolExamBoardId).prop("checked");
    if(status){
      this.classListStatus = true;
      $("#boardClassForUpdate"+board.pkSchoolExamBoardId).show();
    }
    else {
      this.classListStatus = false;
      $("#boardClassForUpdate"+board.pkSchoolExamBoardId).hide();
    }
  }
  examClassStdList = [];
  selectedExamIdForGetResult;
  examListByBoard = [];
  selectedExamBoardIdForResult;
  ExamListByBoard = false;
  selectExamByBoard(boardId){
    this.ExamIdForSelectedBoard = 0;
    this.selectedExamIdForClass = 0;
    this.examListByBoard = [];
    this.ExamListByBoard = false;
    this.classListByExam = false;
    this.classListDataStatus = false;
    this.examResultStatus = true;
    this.examResultDataStatus = false;
    this.sectionListByClass = false;
    this.sectionListDataStatus = false;
    this.destroyDataTable('boardExamListTable');
    this.selectedExamBoardIdForResult = boardId;
    if(boardId ==0){
      this.examResultStatus = false;
      return;
    }
    this.examService.getExamListByExamBoardService(boardId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.examResultStatus = false;
          this.examListByBoard = data;
          if(this.examListByBoard.length == 0){
            //const thereAreNoAnyExamInSelectedBoardTranslation = await firstValueFrom(this.translate.get('thereAreNoAnyExamInSelectedBoard')); customToastr(thereAreNoAnyExamInSelectedBoardTranslation, 'error');
            this.examResultDataStatus = true;
          }
          else {
            this.ExamListByBoard = true;
            this.initializeDataTableOrder('boardExamListTable');
          }
        },
        async error =>{
          this.examResultStatus = false;
          this.examResultDataStatus = false;
          this.ExamListByBoard = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  classListByExam = false;
  classListDataStatus = false;
  selectClassStandard(examId){
    this.examClassStdList = [];
    this.ExamListByBoard = false;
    this.classListByExam = false;
    this.examResultStatus = true;
    this.examResultDataStatus = false;
    this.sectionListByClass = false;
    this.classListDataStatus = false;
    this.sectionListDataStatus = false;
    this.selectedExamIdForGetResult = examId;
    this.destroyDataTable('classListTable');
    if(examId == 0){
      return;
    }
    this.examService.getClassStandardByExamService(examId,this.selectedExamBoardIdForResult,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.examResultStatus = false;
          this.examClassStdList = data;
          if(this.examClassStdList.length == 0){
            //const thereAreNoAnyClassesInSelectedExamTranslation = await firstValueFrom(this.translate.get('thereAreNoAnyClassesInSelectedExam')); customToastr(thereAreNoAnyClassesInSelectedExamTranslation, 'error');
            this.classListDataStatus = true;
          }
          else {  
            this.classListByExam = true;
            this.initializeDataTable('classListTable');
          }
        },
        async error => {
          this.examResultStatus = false;
          this.classListDataStatus = false;
          this.classListByExam = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  fetchClassStandardList(){
    this.classStandardList = [];
    this.examService.fetchClassStandardListService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.classStandardList = data.schoolStandards;
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
          }
      );
  }
  getSelectedClassSectionList = [];
  getClassSectionId=0;
  getClassSectionByClassStd(classStdId){
    this.getSelectedClassSectionList = [];
    this.getClassSectionId = 0;
    if(classStdId == 0){
      return;
    }
    this.examService.getClassSectionListService(classStdId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.getSelectedClassSectionList = data;
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  selectAllClass(classDetails){
    var isSel = $("#selectAllClass"+classDetails[0].fkSchoolExamBoardId).prop("checked");
    for(var j=0; j<classDetails.length; j++){
      classDetails[j].select =isSel;
    }
  }
  selectAllClassForUpdate(classDetails){
    var isSel = $("#selectAllClassForUpdate"+classDetails[0].fkSchoolExamBoardId).prop("checked");
    for(var j=0; j<classDetails.length; j++){
      classDetails[j].classStatus =isSel;
    }
  }
  selectAllClassList = false;
  selectAllClass_v2(){
    var isSel = $("#selectAllClass_v2").prop("checked");
    this.selectedExamClassList.forEach(function (st) {
      st.classStatus=isSel;
    });
  }
  checkingSelect(classDetails){
    var selectList = [];
    for(var i=0; i<classDetails.length; i++){
      if(classDetails[i].select == true){
        selectList.push({classStd: classDetails[i].fkClassStandardId})
      }
    }
    if(classDetails.length == selectList.length){
      $("#selectAllClass"+classDetails[0].fkSchoolExamBoardId).attr("checked",true);
    }
    else {
      $("#selectAllClass"+classDetails[0].fkSchoolExamBoardId).attr("checked",false);
    }
  }
  checkingSelectForUpdate(classDetails){
    var selectList = [];
    for(var i=0; i<classDetails.length; i++){
      if(classDetails[i].classStatus == true){
        selectList.push({classStd: classDetails[i].fkClassStandardId})
      }
    }
    if(classDetails.length == selectList.length){
      $("#selectAllClassForUpdate"+classDetails[0].fkSchoolExamBoardId).attr("checked",true);
    }
    else {
      $("#selectAllClassForUpdate"+classDetails[0].fkSchoolExamBoardId).attr("checked",false);
    }
  }
  checkingSelect_v2(){
    var selectList = [];
    for(var i=0; i<this.selectedExamClassList.length; i++){
      if(this.selectedExamClassList[i].classStatus == true){
        selectList.push({classStd: this.selectedExamClassList[i].pkClassStandardsId})
      }
    }
    if(this.selectedExamClassList.length == selectList.length){
      this.selectAllClassList = true;
    }
    else {
      this.selectAllClassList = false;
    }
  }
  categoryListForExam(){
    this.categoryForExamList = [];
    this.examService.categoryListForExamService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.categoryForExamList = data;
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  async configExam(examBoardClassList){
    $("#examName").css({
      'border-color':'gainsboro'
    });
    this.examConfig.examStartDate = $('#startDate').val();
    var d = this.examConfig.examStartDate.split("/");
    this.examConfig.examStartDate = d[2]+"-"+d[1]+"-"+d[0];
    this.examConfig.examEndDate = $('#endDate').val();
    var e = this.examConfig.examEndDate.split("/");
    this.examConfig.examEndDate = e[2]+"-"+e[1]+"-"+e[0];
    this.examConfig.classListArray = [];
    for(var i=0; i<this.examBoardArray.length; i++){
      if(this.examBoardArray[i].select == true){
        var classStatus = false;
        for(var j=0; j<examBoardClassList.length; j++){
          if(this.examBoardArray[i].pkSchoolExamBoardId == examBoardClassList[j].SchoolExamBoardId){
            for(var k=0; k<examBoardClassList[j].classList.length; k++){
              if(examBoardClassList[j].classList[k].select == true){
                classStatus = true;
                this.examConfig.classListArray.push({BoardId: this.examBoardArray[i].pkSchoolExamBoardId,ClassStandardId:examBoardClassList[j].classList[k].fkClassStandardId})
              }
            }
            if(classStatus == false){
              const pleaseProvideAtleastOneClassInSelectedBoardTranslation = await firstValueFrom(this.translate.get('pleaseProvideAtleastOneClassInSelectedBoard')); 
              customToastr(pleaseProvideAtleastOneClassInSelectedBoardTranslation, 'error');
              return;
            }
          }


        }
      }
    }
    /*for(var m=0; m<this.scholasticConfiguartionList.length; m++){
      if(this.scholasticConfiguartionList[m].select == true){
        this.examConfig.scholasticList.push({scholasticConfigurationId:this.scholasticConfiguartionList[m].pkScholasticConfigurationId})
      }
    }*/
    const validateExamName = this.formValidator.validateFieldName(this.examConfig.examName,"Exam ")
    const validateReportName = this.formValidator.validateFieldName(this.examConfig.reportName,"Report ")
    if(validateExamName) {
      customToastr(validateExamName,'error');
      return 
    }else if(validateReportName) {
      customToastr(validateReportName,'error');
      return 
    }
    if(!this.formValidator.validateIsData(this.examConfig.status)){
      const pleaseChooseExamTypeTranslation = await firstValueFrom(this.translate.get('pleaseChooseExamType')); 
      customToastr(pleaseChooseExamTypeTranslation, 'error');
      return;
    }
    if(!this.formValidator.validateIsData(this.examConfig.IsScholasticType)){
      const pleaseProvideScholasticIncludingOrNotTranslation = await firstValueFrom(this.translate.get('pleaseProvideScholasticIncludingOrNot')); 
      customToastr(pleaseProvideScholasticIncludingOrNotTranslation, 'error');
      return;
    }
    if (!this.formValidator.isValidDate(this.examConfig.examStartDate)){
      const pleaseEnterValidExamStartDateTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidExamStartDate')); 
      customToastr(pleaseEnterValidExamStartDateTranslation, 'error');
      return;
    }
   /* else if(new Date(this.examConfig.examStartDate) <= new Date()) {
      const examStartDateShouldBeGreaterThenCurrentDateTranslation = await firstValueFrom(this.translate.get('examStartDateShouldBeGreaterThenCurrentDate')); customToastr(examStartDateShouldBeGreaterThenCurrentDateTranslation, 'error');
      return;
    }*/
    if (!this.formValidator.isValidDate(this.examConfig.examEndDate)){
      const pleaseEnterValidExamEndDateTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidExamEndDate')); 
      customToastr(pleaseEnterValidExamEndDateTranslation, 'error');
      return;
    }
    else if(new Date(this.examConfig.examEndDate) < new Date(this.examConfig.examStartDate)) {
      const examEndDateShouldBeEqualToOrGreaterThenExamStartDateTranslation = await firstValueFrom(this.translate.get('examEndDateShouldBeEqualToOrGreaterThenExamStartDate')); 
      customToastr(examEndDateShouldBeEqualToOrGreaterThenExamStartDateTranslation, 'error');
      return;
    }
    if(this.examConfig.classListArray.length == 0){
      const pleaseProvideAtleastOneClassTranslation = await firstValueFrom(this.translate.get('pleaseProvideAtleastOneClass')); 
      customToastr(pleaseProvideAtleastOneClassTranslation, 'error');
      return;
    }
    $("#configButton").attr("disabled",true);
    $("#cancelconfig").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#configButton").text(translatedText); });
 
    this.examService.createExamConfigService(this.examConfig,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#configButton").attr("disabled",false);
          $("#cancelconfig").attr("disabled",false);
          this.translate.get('configure').subscribe((translatedText: string) => { $("#configButton").text(translatedText); });
          if (data.status){
            const examScheduleCreatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('examScheduleCreatedSuccessfully')); 
            customToastr(examScheduleCreatedSuccessfullyTranslation, 'success');
            $("#cancelconfig").trigger("click");
            this.examListConfiguration();
          }
          else if(data.ExamDetails && data.ExamDetails.ExamStatus == 'EXAM_ALREADY_EXIST_BY_GIVEN_NAME'){
            $("#examName").css({
              'border-color':'red'
            });
            const examNameIsAlreadyExistPleaseEnterOtherExamNameTranslation = await firstValueFrom(this.translate.get('examNameIsAlreadyExistPleaseEnterOtherExamName')); 
            customToastr(examNameIsAlreadyExistPleaseEnterOtherExamNameTranslation, 'error');
          }
          else {
            const examScheduleIsNotCreatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('examScheduleIsNotCreatedPleaseTryAgain')); 
            customToastr(examScheduleIsNotCreatedPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          $("#configButton").attr("disabled",false);
          $("#cancelconfig").attr("disabled",false);
          this.translate.get('configure').subscribe((translatedText: string) => { $("#configButton").text(translatedText); });
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  examListConfiguration(){
    this.examStatus = true;
    this.examDataStatus = false;
    this.examListDataTable = false;
    this.examList = [];
    this.destroyDataTable('examListTable');
    this.examService.examListConfigurationService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.examStatus = false;
          this.examList = data;
          if(this.examList.length > 0){
            this.examListDataTable = true;
            this.examDataStatus = false;
          }
          else {
            this.examDataStatus = true;
            this.examListDataTable = false;
          }
          this.initializeDataTableOrder('examListTable');
        },
        async error => {
          this.examStatus = false;
          this.examDataStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  configExamEndDate="";
  configExamStartDate = "";
  selectedClassExamId;
  examCategoryId;
  selectedExamIsScholasticType = "";
  examPublishStatus = "";
  examDetailForClass(examData){
    this.examConfigMainPage = false;
    this.classDetailForExam = true;
    this.examName = examData.ExamName;
    this.examType = examData.ExamStatus;
    this.examPublishStatus = examData.PublishStatus;
    this.selectedExamIsScholasticType = examData.IsScholasticType;
    this.examCategoryId = examData.fkExamCategoryId;
    this.configExamStartDate = examData.ExamStartDate;
    this.configExamEndDate = examData.ExamEndDate;
    this.selectedExamStrDate = this.configExamStartDate;
    var estDate = this.datepipe.transform(this.configExamStartDate, 'EEE MMM d, y');
    var eedDate = this.datepipe.transform(this.configExamEndDate, 'EEE MMM d, y');
    /*if(new Date(estDate) <= new Date()){
      $("#updateStartDate").attr("disabled",true);
    }*/
    $("#updateStartDate").val(estDate);
    $("#updateEndDate").val(eedDate);
    this.selectedExamEdDate = this.configExamEndDate;
    this.classStatus = true;
    this.classDataStatus = false;
    this.classData = false;
    this.classDetailList = [];
    this.selectedClassExamId = examData.pkExamId;
    this.destroyDataTable('classDetailTable');
    this.examService.examClassDetailsService(this.selectedClassExamId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.classStatus = false;
          this.classDetailList = data;
          if(this.classDetailList.length > 0){
            this.classDataStatus = false;
            this.classData = true;
          }
          else {
            this.classDataStatus = true;
            this.classData = false;
          }
          this.initializeDataTable('classDetailTable');
        },
        async error => {
          this.classDataStatus = false;
          this.classData = false;
          this.classStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  examBoardList = [];
  selectedExamCategory = "";
  catList(cat){
    this.selectedExamCategory = cat.examCategoryName;
    this.examCategoryId = cat.pkExamCategoryId;
    this.getExamBoardByExamCategory();
  }
  getExamBoardByExamCategory(){
    this.examBoardList = [];
    this.examService.getExamBoardByCategoryService(this.examCategoryId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.examBoardList = data;
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  toggleClickForExam(){
    this.examConfigMainPage = true;
    this.classDetailForExam = false;
    this.examListConfiguration();
  }
  examOverAllStatus="";
  selectedBoardName = "";
  selectedExamBoardId;
  selectedClassScholasticList = [];
  classSubjectExam(classDetail){
    this.getExamBoardByExamCategory();
    this.marksBifurcationList();
    this.includeScholastic = "";
    this.offcanvas.handleOffcanvasOpen('#offcanvasClassSubjectExam');
    $('#examTime').timepicker({
      timeFormat: 'h:i A',
      startTime: '07:00 AM',
      step:5
    });
    this.review = false;
    this.examStartTime = "07:00 AM";
    this.examDuration = "";
    this.maxMarks = "";
    this.passMarks = "";
    this.sectionUse = false;
    this.sectionStatus = false;
    this.selectedClassName = classDetail.ClassStandard;
    this.selectedBoardName = classDetail.BoardName;
    this.selectedExamBoardId = classDetail.pkSchoolExamBoardId;
    this.sectionListOfClass = [];
    this.selectedExamId = classDetail.fkExamId;
    this.selectedClassStdId = classDetail.pkClassStandardsId;
    this.examsDate = classDetail.ExamStartDate;
    this.examOverAllStatus = classDetail.OverAllStatus;
    this.selectedExamStartDate = this.datepipe.transform(classDetail.ExamStartDate, 'EEE MMM d, y');
    this.selectedExamEndDate = this.datepipe.transform(classDetail.ExamEndDate, 'EEE MMM d, y');
    /*Section List*/
    this.selectedClassScholasticList = [];
    this.sectionListOfClass = [];
    this.examService.getClassSectionService(this.selectedClassStdId,this.selectedExamBoardId,this.selectedExamId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.sectionListOfClass = data.sectionList;
          this.selectedClassScholasticList = data.scholasticList;
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
    /*Subject List*/
    this.examService.getSubjectByClassStandardService(classDetail.pkClassStandardsId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          var h = this;
          if(!data.message){
          this.subjectListArray = data;
          var classExamStartDate,classExamDate;
          var classExam = this.selectedExamStartDate;
          classExamStartDate = this.datepipe.transform(classExam, 'dd/MM/yyyy');
          var d = classExamStartDate.split("/");
          classExamDate = d[2]+"-"+this.getProperDate(d[1])+"-"+this.getProperDate(d[0])+"T"+"00:00:00";
          this.getExamScheduleOfClass(this.selectedClassStdId,this.selectedExamId,this.selectedExamBoardId);
          // setTimeout(function () {
            $('.examStartTime').timepicker({
              timeFormat: 'h:i A',
              defaultTime:'07:00 AM',
              step:5
            });
            $('.examEndTime').timepicker({
              timeFormat: 'h:i A',
              defaultTime:'07:00 AM',
              step:5
            });
              for(var i=0; i<h.subjectListArray.length; i++){
                //if (this.subjectListArray[i].pkScheduleId)
                var examDate = h.datepipe.transform(classExamDate, 'EEE MMM d, y');
                $("#examDate"+h.subjectListArray[i].subjectId).val(examDate);
                classExamDate = new Date((new Date(h.examsDate)).getTime() + (60*60*24*1000));
                h.examsDate = classExamDate;
                classExamDate = classExamDate.getFullYear()+"-"+(h.getProperDate(classExamDate.getMonth()+ 1))+"-"+h.getProperDate(classExamDate.getDate())+"T"+"00:00:00";
                $("#startTime"+h.subjectListArray[i].subjectId).val('07:00 AM');
                $("#examDate"+h.subjectListArray[i].subjectId).attr('data-date-start-date', h.selectedExamStartDate);
                $("#examDate"+h.subjectListArray[i].subjectId).attr('data-date-end-date', h.selectedExamEndDate);
                $("#examDate"+h.subjectListArray[i].subjectId).datepicker({
                  autoclose:true,
                  startDate: this.configExamStartDate,
                  endDate: this.configExamEndDate,
                  format: 'D M dd, yyyy'
                })
              }
            }else{
              h.subjectListArray = []
              h.subjectErrorMsg = data.message
            }
           
          // },500);
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  changeExamDate(event: any): void {
    const inputElement = event.target;
    
    let startDate = new Date(this.configExamStartDate);
    let endDate = new Date(this.configExamEndDate);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);
    const previousValue = $(inputElement).val();
    if (!$(inputElement).data("datepicker")) {
        $(inputElement).datepicker({
            autoclose: true,
            startDate: startDate, 
            endDate: endDate,    
            format: 'D M dd, yyyy',
            beforeShowDay: function(date) {
                return {
                    enabled: date.getTime() >= startDate.getTime() && date.getTime() <= endDate.getTime()
                };
            }
        });

        $(inputElement).on("changeDate", function (e) {
            const newValue = e.format(); 
            $(inputElement).val(newValue);
        });

        $(inputElement).on("hide", function () {
            if (!$(inputElement).val()) {
                $(inputElement).val(previousValue);
            }
        });
    }
    $(inputElement).datepicker("show");
}

  classExamDurationData(){
    this.examDuration = $("#exam-duration").val().replace(/[^0-9\.]/g,'');
    var examTime = $('#examTime').val();
    var convertTime = moment(examTime, ["h:mm A"]).format("HH:mm");
    for(var i=0; i<this.subjectListArray.length; i++){
      $("#duration"+this.subjectListArray[i].subjectId).val(this.examDuration);
      if(this.formValidator.validateIsDataForNumber(examTime)){
        var examDurationInt = parseInt(this.examDuration);
        if(this.examDuration.trim() != '' && isNaN(examDurationInt) == false && examDurationInt >= 10){
          var time = convertTime.split(':');
          var m = momentJs();
          m.hours(time[0]);
          m.minutes(time[1]);
          m.minutes(m.minutes() + examDurationInt);
          $('#endTime'+this.subjectListArray[i].subjectId).val(m.format('h:mm A'))
        }
      }

    }
  }
  maxMarks;
  maximumMarksData(){
    this.maxMarks = $("#maxMarks").val().replace(/[^0-9\.]/g,'');
    for(let i=0; i<this.subjectListArray.length; i++){
      $("#marks"+this.subjectListArray[i].subjectId).val(this.maxMarks);
    }
    if(this.maxMarks){
      if(this.minMarksPercentForSchedule >0){
        let passMarks = this.minMarksPercentForSchedule*this.maxMarks/100;
        $("#passMarks").val(passMarks);
        this.passingMarksData();
      }
    }
  }
  passMarks;
  async passingMarksData(){
    this.passMarks = $("#passMarks").val().replace(/[^0-9\.]/g,'');
    if(this.passMarks){
      if(this.passMarks == 0){
        const pleaseEnterValidMinimumPassingMarksTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidMinimumPassingMarks')); 
        customToastr(pleaseEnterValidMinimumPassingMarksTranslation, 'error');
        return;
      }
    }
    for(let i=0; i<this.subjectListArray.length; i++){
      $("#passMarks"+this.subjectListArray[i].subjectId).val(this.passMarks);
    }
  }
  classExamStartTimeData(){
    for(var i=0; i<this.subjectListArray.length; i++){
      $("#startTime"+this.subjectListArray[i].subjectId).val(this.examStartTime);
    }
  }

  sectionData(){
    if (this.sectionUse == true){
      this.sectionStatus = true;
    }
    else {
      this.sectionStatus = false;
    }
  }
  viewMarksBifurcation = false;
  maxMarksPercentForSchedule = 0;
  minMarksPercentForSchedule = 0;
  viewBifurcation(bifurcationId){
    for(var i=0; i<this.subjectListArray.length; i++){
      this.subjectListArray[i].marksBifurcation = bifurcationId;
    }
    if(bifurcationId == 'NULL'){
      this.viewMarksBifurcation = false;
      $("#passMarks").attr('disabled',false);
      $("#maxMarks").attr('disabled',false);
      return;
    }
    else {
      this.viewMarksBifurcation = true;
    }
    let bifurcationData = [];
    this.examService.marksBifurcationDetailsByIdService(bifurcationId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          bifurcationData = data;
          let minMarks = 0;
          let maxMarks = 0;
          for(let j=0; j<bifurcationData.length; j++){
            if(bifurcationData[j].MinPassMarks){
              minMarks += bifurcationData[j].MinPassMarks;
            }
            if(bifurcationData[j].BifurcationMarksOrPercentage){
              maxMarks += bifurcationData[j].BifurcationMarksOrPercentage;
            }
          }
          if(bifurcationData.length > 0){
            if(bifurcationData[0].BifurcationType == 'MARKS'){
              if(minMarks > 0){
                $("#passMarks").val(minMarks);
                $("#passMarks").attr('disabled',true);
                this.passingMarksData();
                this.minMarksPercentForSchedule = 0;
              }
              else {
                $("#passMarks").val("");
                $("#passMarks").attr('disabled',false);
                this.passingMarksData();
                this.minMarksPercentForSchedule = $("#passMarks").val("");
              }
              if(maxMarks > 0){
                $("#maxMarks").val(maxMarks);
                $("#maxMarks").attr('disabled',true);
                this.maximumMarksData();
                this.minMarksPercentForSchedule = 0;
              }
              else {
                $("#maxMarks").val("");
                $("#maxMarks").attr('disabled',false);
                this.maximumMarksData();
              }
            }
            else {
              this.maxMarksPercentForSchedule = maxMarks;
              this.minMarksPercentForSchedule = minMarks;
              $("#passMarks").attr('disabled',false);
              $("#maxMarks").attr('disabled',false);
              $("#maxMarks").val("");
              this.maximumMarksData();
              $("#passMarks").val("");
              this.passingMarksData();
            }
          }
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  minPassPercent = 0;
  checkBifurcationData(marksData){
    if(!marksData.marksBifurcation){
      $("#passMarks"+marksData.subjectId).attr('disabled',false);
      $("#marks"+marksData.subjectId).attr('disabled',false);
      return;
    }
    let bifurcationData = [];
    this.examService.marksBifurcationDetailsByIdService(marksData.marksBifurcation,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          bifurcationData = data;
          let minMarks = 0;
          let maxMarks = 0;
          for(let j=0; j<bifurcationData.length; j++){
            if(bifurcationData[j].MinPassMarks){
              minMarks += bifurcationData[j].MinPassMarks;
            }
            if(bifurcationData[j].BifurcationMarksOrPercentage){
              maxMarks += bifurcationData[j].BifurcationMarksOrPercentage;
            }
          }
          if(bifurcationData.length > 0){
            if(bifurcationData[0].BifurcationType == 'MARKS'){
              if(minMarks > 0){
                $("#passMarks"+marksData.subjectId).val(minMarks);
                $("#passMarks"+marksData.subjectId).attr('disabled',true);
                this.minPassPercent = 0;
              }
              if(maxMarks > 0){
                $("#marks"+marksData.subjectId).val(maxMarks);
                $("#marks"+marksData.subjectId).attr('disabled',true);
                this.minPassPercent = 0;
              }
            }
            else {
              this.minPassPercent = minMarks;
              $("#passMarks"+marksData.subjectId).attr('disabled',false);
              $("#marks"+marksData.subjectId).attr('disabled',false);
              let maxData = $("#marks"+marksData.subjectId).val();
              if(maxData){
                if(this.minPassPercent > 0){
                  let passData = maxData * this.minPassPercent/100;
                  $("#passMarks"+marksData.subjectId).val(passData);
                }
              }
            }
          }
        },
        error =>{

        }
      );
  }
  checkMaxMarks(marksData){
    let maxData = $("#marks"+marksData.subjectId).val();
    if(maxData){
      if(this.minPassPercent >0){
        let passMarks = this.minPassPercent*maxData/100;
        $("#passMarks"+marksData.subjectId).val(passMarks);
      }
    }
  }
  selectedBoardId = "0";
  includeScholastic = "NO";
  selectAllSubject = false;

  selectSubject(){
    /*if($("#selectSubject").prop('checked') == true){
      this.selectAllSubject = true;
    }
    else {
      this.selectAllSubject = false;
    }*/
    if(this.selectAllSubject == true){
      for(let i=0; i<this.subjectListArray.length; i++){
        this.subjectListArray[i].select = true;
      }
    }
    else {
      for(let j=0; j<this.subjectListArray.length; j++){
        this.subjectListArray[j].select = false;
      }
    }
  }

 async scheduleExamsByClass(examStatus){
    if(this.result_availability.length > 0){
      let result = false;
      for(let i=0; i<this.result_availability.length; i++){
        if(this.result_availability[i].result_available){
          result = true;
          const studentMarksAreAlreadyEnteredYouCanTRescheduleItIfYouWantToReschedulePleaseDeleteStudentsEnteredMarksFirstFromResultManagementTabTranslation = await firstValueFrom(this.translate.get('studentMarksAreAlreadyEnteredYouCanTRescheduleItIfYouWantToReschedulePleaseDeleteStudentsEnteredMarksFirstFromResultManagementTab')); 
          customToastr(studentMarksAreAlreadyEnteredYouCanTRescheduleItIfYouWantToReschedulePleaseDeleteStudentsEnteredMarksFirstFromResultManagementTabTranslation, 'error');
          return;
        }
      }
      if(!result){
        this.createExamOfClass(examStatus);
      }
    }
    else {
      this.createExamOfClass(examStatus);
    }
  }

  updateSectionStatus(sec: any, event: Event) {
    sec.sectionStatus = (event.target as HTMLInputElement).checked ? 1 : 0;
}

  async createExamOfClass(examStatus) {
    let sectionList = [];
    let addScholasticList = [];
    let removeScholasticList = [];
    let subjectDetailForExam = [];
    let removeScheduledSubject = [];
    for (let i = 0; i < this.sectionListOfClass.length; i++) {
      if (this.sectionListOfClass[i].sectionStatus == true) {
        sectionList.push({classId: this.sectionListOfClass[i].fkClassId});
      }
    }

    if (!this.formValidator.validateIsDataForNumber(this.examDuration)) {
      const pleaseProvideExamDurationTranslation = await firstValueFrom(this.translate.get('pleaseProvideExamDuration'));
       customToastr(pleaseProvideExamDurationTranslation, 'error');
      return;
    }
    if (!this.formValidator.validateIsDataForNumber($('#examTime').val())) {
      const pleaseProvideExamStartTimeTranslation = await firstValueFrom(this.translate.get('pleaseProvideExamStartTime')); 
      customToastr(pleaseProvideExamStartTimeTranslation, 'error');
      return;
    }
    if (!this.formValidator.validateIsDataForNumber(this.maxMarks)) {
      const pleaseProvideMaximumMarksTranslation = await firstValueFrom(this.translate.get('pleaseProvideMaximumMarks'));
      customToastr(pleaseProvideMaximumMarksTranslation, 'error');
      return;
    }
    if (!this.formValidator.validateIsDataForNumber(this.passMarks)) {
      const pleaseProvidePassingMarksTranslation = await firstValueFrom(this.translate.get('pleaseProvidePassingMarks')); 
      customToastr(pleaseProvidePassingMarksTranslation, 'error');
      return;
    }
    if (sectionList.length == 0) {
      const pleaseSelectAtLeastOneSectionTranslation = await firstValueFrom(this.translate.get('pleaseSelectAtLeastOneSection')); 
      customToastr(pleaseSelectAtLeastOneSectionTranslation, 'error');
      return;
    }
    if (this.selectedExamIsScholasticType == 'YES' && !this.formValidator.validateIsDataForNumber(this.includeScholastic)) {
      const pleaseProvideScholasticIncludeOrNotTranslation = await firstValueFrom(this.translate.get('pleaseProvideScholasticIncludeOrNot')); 
      customToastr(pleaseProvideScholasticIncludeOrNotTranslation, 'error');
      return;
    }

    for (let j = 0; j < this.subjectListArray.length; j++) {
      if (this.subjectListArray[j].select == true) {
        var maximumMarks = $("#marks" + this.subjectListArray[j].subjectId).val();
        var passMarks = $("#passMarks" + this.subjectListArray[j].subjectId).val();
        var selectedSubjectId = $("#sub" + this.subjectListArray[j].subjectId).text();
        if (!this.formValidator.validateIsDataForNumber(selectedSubjectId)) {
          const pleaseSelectASubjectTranslation = await firstValueFrom(this.translate.get('pleaseSelectASubject')); 
          customToastr(pleaseSelectASubjectTranslation, 'error');
          return;
        }
        if (!this.formValidator.validateIsDataForNumber(maximumMarks)) {
          const pleaseEnterSelectedSubjectMaximumMarksTranslation = await firstValueFrom(this.translate.get('pleaseEnterSelectedSubjectMaximumMarks')); 
          customToastr(pleaseEnterSelectedSubjectMaximumMarksTranslation, 'error');
          return;
        }
        if (!this.formValidator.validateIsDataForNumber(passMarks)) {
          const pleaseEnterSelectedSubjectPassingMarksTranslation = await firstValueFrom(this.translate.get('pleaseEnterSelectedSubjectPassingMarks')); 
          customToastr(pleaseEnterSelectedSubjectPassingMarksTranslation, 'error');
          return;
        }
        var examDate = $("#examDate" + this.subjectListArray[j].subjectId).val();
        if(!this.formValidator.validateIsDataForNumber(examDate)){
          const pleaseProvideExamDateInSelectedSubjectTranslation = await firstValueFrom(this.translate.get('pleaseProvideExamDateInSelectedSubject')); 
          customToastr(pleaseProvideExamDateInSelectedSubjectTranslation, 'error');
          return;
        }
        var examStartTime = $("#startTime" + this.subjectListArray[j].subjectId).val();
        var convertedStartTime = moment(examStartTime, ["h:mm A"]);
        var examEndTime = $("#endTime" + this.subjectListArray[j].subjectId).val();
        var convertedEndTime = moment(examEndTime, ["h:mm A"]);
        if (!this.formValidator.validateIsDataForNumber(examStartTime)) {
          const pleaseProvideSelectedSubjectExamTimeTranslation = await firstValueFrom(this.translate.get('pleaseProvideSelectedSubjectExamTime')); 
          customToastr(pleaseProvideSelectedSubjectExamTimeTranslation, 'error');
          return;
        }
        var date = this.datepipe.transform(examDate, "yyyy-MM-dd");
        var datem = moment(date);
        var datemn = datem.clone();
        datem.hours(convertedStartTime.hours());
        datem.minutes(convertedStartTime.minutes());
        var startDateTime = datem.format();
        datemn.hours(convertedEndTime.hours());
        datemn.minutes(convertedEndTime.minutes());
        var endDateTime = datemn.format();
        let bifurcationId;
        bifurcationId = $('#bifurcation' + this.subjectListArray[j].subjectId).val();
        if (!bifurcationId) {
          bifurcationId = null;
        }
        subjectDetailForExam.push({
          subjectId: selectedSubjectId,
          StartDateTime: startDateTime, EndDateTime: endDateTime, MaxMarks: maximumMarks, MinMarks: passMarks,
          ExamId: this.selectedExamId, marksBifurcationId: bifurcationId, isScholasticType: this.includeScholastic
        })
      }
      else {
        let scheduleId = $("#schedule"+this.subjectListArray[j].subjectId).text();
        let scheduledSubjectId = $("#sub"+this.subjectListArray[j].subjectId).text();
        if(scheduleId){
          removeScheduledSubject.push({
            subjectId: scheduledSubjectId
          });
        }
      }
    }
    for(let y=0; y<sectionList.length; y++){
      for(let z=0; z<this.selectedClassScholasticList.length; z++){
        if(sectionList[y].classId == this.selectedClassScholasticList[z].fkClassId){
          if(this.selectedExamIsScholasticType == 'YES' && this.includeScholastic == 'YES' && this.selectedClassScholasticList[z].pkExamScholasticId == null){
            addScholasticList.push({classId:sectionList[y].classId,scholasticConfigId:this.selectedClassScholasticList[z].fkScholasticConfigurationId})
          }
          else if (this.selectedExamIsScholasticType == 'YES' && this.includeScholastic == 'NO' && this.selectedClassScholasticList[z].pkExamScholasticId){
            removeScholasticList.push({classId:sectionList[y].classId,scholasticConfigId:this.selectedClassScholasticList[z].fkScholasticConfigurationId})
          }
        } 
      }
    }
    let status = "";
    if(this.review && !examStatus){
      status = 'REVIEW EXAM CALENDER';
    }
    else if(!this.review && examStatus){
      const pleaseReviewFirstTranslation = await firstValueFrom(this.translate.get('pleaseReviewFirst')); 
      customToastr(pleaseReviewFirstTranslation, 'error');
      return;
    }
    else if(this.review && examStatus){
      status = 'EXAM CALENDER PUBLISHED';
    }
    else {
      status = 'EXAM CALENDER SCHEDULED';
    }
    let examScheduleData = {
      classList:sectionList,
      examSchedule:subjectDetailForExam,
      ExamId:this.selectedExamId,
      classStandardId:this.selectedClassStdId,
      examStatus:status,
      ExamBoardId:this.selectedExamBoardId,
      addScholasticList:addScholasticList,
      removeScholasticList:removeScholasticList,
      removeScheduledSubject:removeScheduledSubject
    };
    if(examScheduleData.examSchedule.length == 0){
      const pleaseSelectAtLeastOneSubjectToScheduleExamTranslation = await firstValueFrom(this.translate.get('pleaseSelectAtLeastOneSubjectToScheduleExam')); 
      customToastr(pleaseSelectAtLeastOneSubjectToScheduleExamTranslation, 'error');
      return;
    }
    let examData = {
      ExamName: this.examName,
      ExamStatus:this.examType,
      pkExamId:this.selectedExamId,
      ExamStartDate:this.configExamStartDate,
      ExamEndDate:this.configExamEndDate,
      IsScholasticType:this.selectedExamIsScholasticType
    };
    $("#cancelExamSchedule").attr("disabled", true);
    $("#publishExamSchedule").attr("disabled", true);
    $("#saveExamSchedule").attr("disabled", true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#saveExamSchedule").text(translatedText); });
    this.examService.createExamScheduleService(examScheduleData,this.academicInfo.current_academic, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#cancelExamSchedule").attr("disabled", false);
          $("#publishExamSchedule").attr("disabled", false);
          $("#saveExamSchedule").attr("disabled", false);
          this.translate.get('save').subscribe((translatedText: string) => { $("#saveExamSchedule").text(translatedText); });
          
          if(data.status == true){
            const examScheduledSuccessfullyTranslation = await firstValueFrom(this.translate.get('examScheduledSuccessfully')); 
            customToastr(examScheduledSuccessfullyTranslation, 'success');
            $("#cancelExamSchedule").trigger("click");
            this.examDetailForClass(examData);
          }
          else {
            const examNotScheduledPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('examNotScheduledPleaseTryAgain')); 
            customToastr(examNotScheduledPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          $("#cancelExamSchedule").attr("disabled", false);
          $("#publishExamSchedule").attr("disabled", false);
          $("#saveExamSchedule").attr("disabled", false);
          this.translate.get('save').subscribe((translatedText: string) => { $("#saveExamSchedule").text(translatedText); });
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  checkSubjectSelection(){
    let subjectList = [];
    for (let i = 0; i<this.subjectListArray.length; i++){
      if (this.subjectListArray[i].select){
        subjectList.push(this.subjectListArray[i].subjectId);
      }
    }
    if(subjectList.length == this.subjectListArray.length){
      this.selectAllSubject = true;
    }
    else {
      this.selectAllSubject = false;
    }
  }

  getProperDate(num){
    num = parseInt(num);
    if(num < 10){
      return "0"+num
    }
    else {
      return num
    }

  }
  selectedExamStatus="";
  getMarksBifurcationId;
  result_availability = [];
  getExamScheduleOfClass(classStandardId,ExamId,ExamBoardId){
    var examDetails = [];
    var examStatus = [];
    let scholasticData = [];
    this.result_availability = [];
    var h = this;
    this.examService.getExamScheduleByClassService(classStandardId,ExamId,ExamBoardId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          examDetails = data.ExamDetails;
          for(let z=0; z<examDetails.length; z++){
            this.result_availability.push({result_available:examDetails[z].result_available})
          }
          this.result_availability = examDetails;
          examStatus = data.ClassStatus;
          scholasticData = data.scholasticStatus;
          let selectedSubject = [];
          this.viewMarksBifurcation = true;
          // setTimeout(function () {
            if(examDetails.length > 0){
              h.includeScholastic = examDetails[0].IsScholasticType;
              for(var i=0; i<examDetails.length; i++){
                if(examDetails[i].pkExamScheduleId){
                  for (let j=0; j<h.subjectListArray.length; j++){
                    if(examDetails[i].fkSubjectId == h.subjectListArray[j].subjectId){
                      h.subjectListArray[j].select = true;
                    }
                  }
                  //$("#subjectSelect"+examDetails[i].fkSubjectId).prop('checked',true);
                  selectedSubject.push(examDetails[i].fkSubjectId);
                }
                $("#sub"+examDetails[i].fkSubjectId).val(examDetails[i].fkSubjectId);
                $("#schedule"+examDetails[i].fkSubjectId).text(examDetails[i].pkExamScheduleId);
                $("#marks"+examDetails[i].fkSubjectId).val(examDetails[i].MaxMarks);
                $("#passMarks"+examDetails[i].fkSubjectId).val(examDetails[i].MinMarks);
                $("#bifurcation"+examDetails[i].fkSubjectId).val(examDetails[i].fkMarksBifurcationId);
                var momentStartTime = moment(examDetails[i].StartTimeDateInCurrent);
                var startTime = momentStartTime.format('h:mm A');
                var momentEndTime = moment(examDetails[i].EndTimeDateInCurrent);
                var endTime = momentEndTime.format('h:mm A');
                $("#startTime"+examDetails[i].fkSubjectId).val(startTime);
                $("#endTime"+examDetails[i].fkSubjectId).val(endTime);
                var momentExamDate = moment(examDetails[i].StartTimeDateInCurrent);
                var examDate = momentExamDate.format('ddd MMM DD, YYYY');
                $("#examDate"+examDetails[i].fkSubjectId).val(examDate);
                h.selectedExamStatus = examDetails[i].OverAllStatus;
                var now = moment(examDetails[i].examEndTime);
                var end = moment(examDetails[i].examStartTime);
                var duration = moment.duration(now.diff(end));
                var examDuration = duration.asMinutes();
                $("#duration"+examDetails[i].fkSubjectId).val(examDuration);
                h.sectionListOfClass = examStatus;
                h.selectedClassScholasticList = scholasticData;
              }
              if (selectedSubject.length == h.subjectListArray.length){
                h.selectAllSubject = true;
                //$("#selectSubject").prop('checked',true);
              }
              else {
                h.selectAllSubject = false;
                //$("#selectSubject").prop('checked',false);
              }
              var momentStTime = moment(examDetails[0].StartTimeDateInCurrent);
              h.examStartTime = momentStartTime.format('h:mm A');
              //h.examStartTime = h.datepipe.transform(examDetails[0].examStartTime, 'jm');
              var startExam = moment(examDetails[0].examEndTime);
              var endExam = moment(examDetails[0].examStartTime);
              var durationExam = moment.duration(now.diff(end));
              h.examDuration = durationExam.asMinutes();
              h.maxMarks = examDetails[0].MaxMarks;
              h.passMarks = examDetails[0].MinMarks;
              h.selectedBoardId = examDetails[0].fkSchoolExamBoardId;
              h.getMarksBifurcationId = examDetails[0].fkMarksBifurcationId;
              if(h.selectedExamStatus == 'REVIEW EXAM CALENDER' || h.selectedExamStatus == 'EXAM CALENDER PUBLISHED'){
                h.review = true;
              }
              else {
                h.review = false;
              }
            }

          // },500)
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }


  getCurrentDateExamSchedule(){
    this.currentExamScheduleList = [];
    this.currentStatus = true;
    this.currentDataStatus = false;
    this.currentListDataTable = false;
    this.destroyDataTable('currentExamScheduleTable');
    this.examService.getCurrentDateExamScheduleService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.currentStatus = false;
          this.currentExamScheduleList = data;
          if(this.currentExamScheduleList.length > 0){
            this.currentListDataTable = true;
            this.currentDataStatus = false;
            this.initializeDataTable('currentExamScheduleTable');
          }
          else {
            this.currentListDataTable = false;
            this.currentDataStatus = true;
          }
        },
        async error => {
          this.currentStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  selectedClassStandardId = 0;
  async getUpcomingDateExamSchedule(){
    if(this.selectedClassStandardId == 0){
      const pleaseProvideClassFirstTranslation = await firstValueFrom(this.translate.get('pleaseProvideClassFirst')); 
      customToastr(pleaseProvideClassFirstTranslation, 'error');
      return;
    }
    this.upcomingExamScheduleList = [];
    this.upcomingStatus = true;
    this.upcomingDataStatus = false;
    this.upcomingListDataTable = false;
    this.destroyDataTable('upcomingExamScheduleTable');
    this.examService.getUpcomingDateExamScheduleService(this.selectedClassStandardId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.upcomingStatus = false;
          this.upcomingExamScheduleList = data;
          if(this.upcomingExamScheduleList.length > 0){
            this.upcomingListDataTable = true;
            this.upcomingDataStatus = false;
            this.initializeDataTableOrder('upcomingExamScheduleTable');
          }
          else {
            this.upcomingListDataTable = false;
            this.upcomingDataStatus = true;
          }
        },
        async error => {
          this.upcomingStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  selectClassStdIdOfComplete= 0;
  async getCompletedExamSchedule(){
    if(this.selectClassStdIdOfComplete == 0){
      const pleaseProvideClassFirstTranslation = await firstValueFrom(this.translate.get('pleaseProvideClassFirst')); 
      customToastr(pleaseProvideClassFirstTranslation, 'error');
      return;
    }
    this.completedExamScheduleList = [];
    this.completedStatus = true;
    this.completedDataStatus = false;
    this.completedListDataTable = false;
    this.destroyDataTable('completedExamScheduleTable');
    this.examService.getCompletedExamScheduleService(this.selectClassStdIdOfComplete,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.completedStatus = false;
          this.completedExamScheduleList = data;
          if(this.completedExamScheduleList.length > 0){
            this.completedListDataTable = true;
            this.completedDataStatus = false;
            this.initializeDataTableOrder('completedExamScheduleTable');
          }
          else {
            this.completedListDataTable = false;
            this.completedDataStatus = true;
          }
        },
        async error => {
          this.completedStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  selectedExamClassList = [];
  getClassStdListForExam(ExamId){
    this.selectAllClassList = false;
    this.selectedExamClassList = [];
    this.examService.getClassStdForExamService(ExamId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.selectedExamClassList = data;
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  selectedExamStrDate;
  selectedExamEdDate;
  async addMoreClassInExam(){
    var classListArray = [];
    var classListForAdd = [];
    var classListForRemove = [];
    var ExamStDate = $("#updateStartDate").val();
    var ExamEdDate = $("#updateEndDate").val();
    if (!ExamStDate){
      const pleaseEnterValidExamStartDateTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidExamStartDate')); 
      customToastr(pleaseEnterValidExamStartDateTranslation, 'error');
      return;
    }
    if (!ExamEdDate){
      const pleaseEnterValidExamEndDateTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidExamEndDate')); 
      customToastr(pleaseEnterValidExamEndDateTranslation, 'error');
      return;
    }
    var stDate = this.datepipe.transform(ExamStDate, "yyyy-MM-dd");
    var edDate = this.datepipe.transform(ExamEdDate, "yyyy-MM-dd");
    for(var i=0; i<this.examBoardByExamIdList.length; i++){
      if(this.examBoardByExamIdList[i].boardStatus == true){
        var classStatus = false;
        for(var j=0; j<this.classListForExam.length; j++){
          if(this.examBoardByExamIdList[i].pkSchoolExamBoardId == this.classListForExam[j].SchoolExamBoardId){
            for(var k=0; k<this.classListForExam[j].classList.length; k++){
              if(this.classListForExam[j].classList[k].classStatus == true){
                classStatus = true;
              }
              if(this.classListForExam[j].classList[k].classStatus == true && this.classListForExam[j].classList[k].pkExamClassConfigId == null){
                classListForAdd.push({BoardId: this.examBoardByExamIdList[i].pkSchoolExamBoardId,ClassStandardId:this.classListForExam[j].classList[k].fkClassStandardId})
              }
              else if(this.classListForExam[j].classList[k].classStatus == false && this.classListForExam[j].classList[k].pkExamClassConfigId != null){
                classListForRemove.push({BoardId: this.examBoardByExamIdList[i].pkSchoolExamBoardId,ClassStandardId:this.classListForExam[j].classList[k].fkClassStandardId})
              }
            }
            if(classStatus == false){
              const pleaseProvideAtleastOneClassInSelectedBoardTranslation = await firstValueFrom(this.translate.get('pleaseProvideAtleastOneClassInSelectedBoard')); 
              customToastr(pleaseProvideAtleastOneClassInSelectedBoardTranslation, 'error');
              return;
            }
          }


        }
      }
      else {
        for(var l=0; l<this.classListForExam.length; l++){
          if(this.examBoardByExamIdList[i].pkSchoolExamBoardId == this.classListForExam[l].SchoolExamBoardId){
            for(var m=0; m<this.classListForExam[l].classList.length; m++){
              if( this.classListForExam[l].classList[m].pkExamClassConfigId != null){
                classListForRemove.push({BoardId: this.examBoardByExamIdList[i].pkSchoolExamBoardId,ClassStandardId:this.classListForExam[l].classList[m].fkClassStandardId})
              }
            }
          }
        }
      }
    }
    var addScholasticList = [];
    var removeScholasticList = [];
    for(var x=0; x<this.scholasticListForUpdateExam.length; x++){
      if(this.scholasticListForUpdateExam[x].scholStatus && !this.scholasticListForUpdateExam[x].pkExamScholasticId){
        addScholasticList.push({scholasticConfigurationId:this.scholasticListForUpdateExam[x].pkScholasticConfigurationId})
      }
      else if(!this.scholasticListForUpdateExam[x].scholStatus && this.scholasticListForUpdateExam[x].pkExamScholasticId){
        removeScholasticList.push({scholasticConfigurationId:this.scholasticListForUpdateExam[x].pkScholasticConfigurationId})
      }
    }
    if (!this.formValidator.isValidDate(stDate)){
      const pleaseEnterValidExamStartDateTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidExamStartDate')); 
      customToastr(pleaseEnterValidExamStartDateTranslation, 'error');
      return;
    }
    if (!this.formValidator.isValidDate(edDate)){
      const pleaseEnterValidExamEndDateTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidExamEndDate')); 
      customToastr(pleaseEnterValidExamEndDateTranslation, 'error');
      return;
    }
    if(new Date(edDate) <= new Date(stDate)) {
      const examEndDateShouldBeGreaterThenStartDateTranslation = await firstValueFrom(this.translate.get('examEndDateShouldBeGreaterThenStartDate')); 
      customToastr(examEndDateShouldBeGreaterThenStartDateTranslation, 'error');
      return;
    }
    var addOrRemoveClassExam = {
      addClassListArray:classListForAdd,
      removeClassListArray:classListForRemove,
      ExamId:this.selectedClassExamId,
      examStartDate:stDate,
      examEndDate:edDate,
      addScholasticList:addScholasticList,
      removeScholasticList:removeScholasticList
    };
    var examData = {
      ExamName: this.examName,
      ExamStatus:this.examType,
      pkExamId:this.selectedClassExamId,
      ExamStartDate:this.configExamStartDate,
      ExamEndDate:this.configExamEndDate,
      IsScholasticType:this.selectedExamIsScholasticType
    };
    $("#configButton-v2").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#configButton-v2").text(translatedText); });
    $("#cancelconfig-v2").attr("disabled",true);
    this.examService.addAndRemoveClassFromExamService(addOrRemoveClassExam,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#configButton-v2").attr("disabled",false);
          this.translate.get('update').subscribe((translatedText: string) => { $("#configButton-v2").text(translatedText); });
          $("#cancelconfig-v2").attr("disabled",false);
          if(data.status == true){
            const examUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('examUpdatedSuccessfully')); 
            customToastr(examUpdatedSuccessfullyTranslation, 'success');
            $("#cancelconfig-v2").trigger("click");
            this.examDetailForClass(examData);
            this.examListConfiguration();
          }
          else {
            const examNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('examNotUpdatedPleaseTryAgain')); 
            customToastr(examNotUpdatedPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          $("#configButton-v2").attr("disabled",false);
          this.translate.get('update').subscribe((translatedText: string) => { $("#configButton-v2").text(translatedText); });
          $("#cancelconfig-v2").attr("disabled",false);
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }


  textWrappingForName(name){
    if(!name){
      return name;
    }
    else if(name.length > 15){
      return $.trim(name).substring(0,15)+"..."
    }else{
      return name;
    }
  }
  textWrappingForSubject(name){
    if(!name){
      return name;
    }
    else if(name.length > 10){
      return $.trim(name).substring(0,10)+"..."
    }else{
      return name;
    }
  }
  textWrappingForTabMenu(name){
    if(!name){
      return name;
    }
    else if(name.length > 20){
      return $.trim(name).substring(0,20)+"..."
    }else{
      return name;
    }
  }
  textWrappingForSectionName(name){
    if(!name){
      return name;
    }
    else if(name.length > 9){
      return $.trim(name).substring(0,7)+"..."
    }else{
      return name;
    }
  }

  selectedExamIdForResult;
  selectedClassIdForResult;
  selectedSubjectIdForResult;
  selectedClassExamResult: any;
  examScheduleId;
  studentListResultBySubject = [];
  studentResult = false;
  studentResultStatus = false;
  selectedSubjExamBoardId;
  studentMarksBifurcation = [];
  checkMarksBifurcation;
  subjectListByExamClass = [];
  scholasticListByExamClass = [];
  getSubjectAndScholasticListByExamClass(comp){
    this.subjectListByExamClass = [];
    this.scholasticListByExamClass = [];
    this.offcanvas.handleOffcanvasOpen('#offcanvasExamResult');
    this.selectedClassExamResult = comp;
    this.selectedExamIdForResult = comp.fkExamId;
    this.selectedClassIdForResult = comp.fkClassId;
    this.selectedSubjExamBoardId = comp.pkSchoolExamBoardId;
    this.examService.getSubjectAndScholasticListByClassService(comp.fkExamId,comp.fkClassId,comp.pkSchoolExamBoardId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.subjectListByExamClass = data.subjectList;
          this.scholasticListByExamClass = data.scholasticList;
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  getDataForOverAllMarks: any;
  viewAllMarksOfStudent(data){
    this.getDataForOverAllMarks = data;
    var ExamScheduleId = data.pkExamScheduleId;
    this.subjectListByExamClass = [];
    this.scholasticListByExamClass = [];
    this.offcanvas.handleOffcanvasOpen('#showStudentMarksByClass');
    this.selectedClassExamResult = data;
    this.selectedExamIdForResult = data.pkExamId;
    this.selectedClassIdForResult = data.classId;
    this.selectedSubjExamBoardId = this.selectedExamBoardIdForResult;
    this.examService.getSubjectAndScholasticListByClassService(data.pkExamId,data.classId,this.selectedExamBoardIdForResult,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.subjectListByExamClass = data.subjectList;
          this.scholasticListByExamClass = data.scholasticList;
          this.resultDeclare(this.subjectListByExamClass[0].subjectId,this.subjectListByExamClass[0].pkExamScheduleId,this.subjectListByExamClass[0].subject,this.subjectListByExamClass[0].editableSubject);
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  closeViewButton(){
    $("#closeViewResult").trigger("click");
  }
  checkDate(ExamDate){
    return new Date(ExamDate) > new Date();
  }
  selectedField = "";
  resultPublishStatus = false;
  marksBifurcationData = [];
  editableExamSubject = false;
  semesterMarksAvailability = false;
  marksEnteredStatus = false;
  resultDeclare(subjectId,ExamScheduledId,subject,editableSubject){
    this.editableExamSubject = editableSubject;
    this.scholasticEntryStatus = false;
    this.subjectEntryStatus = true;
    this.coScholasticData = false;
    this.studentScholResult = false;
    this.marksEnteredStatus = false;
    this.studentListResultBySubject = [];
    this.studentMarksBifurcation = [];
    this.marksBifurcationData = [];
    this.studentResult = false;
    this.studentResultStatus = true;
    this.selectedSubjectIdForResult = subjectId;
    this.examScheduleId = ExamScheduledId;
    this.selectedField = subject;
    $(".subject").removeClass('subject');
    $("#subject"+subjectId).addClass("subject");
    $("#subjectShow"+subjectId).addClass("subject");
    $("#enterStatus"+subjectId).addClass("subject");
    $("#enterStatusShow"+subjectId).addClass("subject");
    this.getExamGradeConfigByExamBoard(this.selectedSubjExamBoardId);
    this.getExamBoardEvaluationType(this.selectedSubjExamBoardId);
    this.destroyDataTable('studentsResultTable');
    this.destroyDataTable('showStudentMarksTable');
    var data = {
      classId:this.selectedClassIdForResult,
      ExamId:this.selectedExamIdForResult,
      subjectId:this.selectedSubjectIdForResult,
      ExamScheduleId:this.examScheduleId
    };
    this.examService.getStudentResultsBySubjectService(data,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.studentResult = true;
          this.studentResultStatus = false;

          this.studentListResultBySubject = data.marks_details;
          this.semesterMarksAvailability = data.semester_marks_status;
          let stats = this.studentListResultBySubject[0].otherMarks[0].PublishResultStatus;
          this.marksEnteredStatus = this.studentListResultBySubject[0].otherMarks[0].marksEntered;
          if(stats == 'PUBLISHED'){
            this.resultPublishStatus = true;
          }
          else {
            this.resultPublishStatus = false;
          }
          this.studentMarksBifurcation = this.studentListResultBySubject[0].otherMarks;
          this.checkMarksBifurcation = this.studentListResultBySubject[0].otherMarks[0].fkMarksBifurcationId;
          var bifurcationType = this.studentListResultBySubject[0].otherMarks[0].BifurcationType;
          var h = this;
          if(this.checkMarksBifurcation){
            this.examService.marksBifurcationDetailsByIdService(this.checkMarksBifurcation,this.academicInfo.current_academic,this.getAuthToken)
              .subscribe(
                (data: any) =>{
                  var bifurcationDetailArray = data;
                  this.marksBifurcationData = data;
                  if(bifurcationType == 'PERCENTAGE'){
                    for(var k=0; k<bifurcationDetailArray.length; k++){
                      for(var m=0; m<this.studentListResultBySubject.length; m++){
                        var marksPercentage = (bifurcationDetailArray[k].BifurcationMarksOrPercentage * this.studentListResultBySubject[m].MaxMarks / 100);
                        $("#MarksHead"+bifurcationDetailArray[k].pkMarksBifurcationConfigurationId).text(marksPercentage);
                        $("#MarksHeader"+bifurcationDetailArray[k].pkMarksBifurcationConfigurationId).text(marksPercentage);
                      }
                    }
                  }
                  else {
                    for(var n=0; n<bifurcationDetailArray.length; n++){
                      $("#MarksHead"+bifurcationDetailArray[n].pkMarksBifurcationConfigurationId).text(bifurcationDetailArray[n].BifurcationMarksOrPercentage);
                      $("#MarksHeader"+bifurcationDetailArray[n].pkMarksBifurcationConfigurationId).text(bifurcationDetailArray[n].BifurcationMarksOrPercentage);
                    }
                  }
                },
                error =>{

                }
              );
            setTimeout(function () {
              for(var x=0; x<h.studentListResultBySubject.length; x++){
                var studentMarks = 0;
                for(var y=0; y<h.studentListResultBySubject[x].otherMarks.length; y++){
                  studentMarks += parseInt(h.studentListResultBySubject[x].otherMarks[y].Marks);
                  if(h.studentListResultBySubject[x].studentExamAttendance == 'ABSENT'){
                    h.studentListResultBySubject[x].otherMarks[y].Marks = null;
                  }
                }
                if(!h.studentListResultBySubject[x].ResultStatus){
                  if(h.studentListResultBySubject[x].studentExamAttendance == 'PRESENT' && h.studentListResultBySubject[x].MinMarks <= studentMarks && studentMarks != null){
                    h.studentListResultBySubject[x].ResultStatus = 'PASS';
                  }
                  else if(h.studentListResultBySubject[x].studentExamAttendance == 'PRESENT' && h.studentListResultBySubject[x].MinMarks > studentMarks && studentMarks != null){
                    h.studentListResultBySubject[x].ResultStatus = 'FAIL';
                  }
                  else if(h.studentListResultBySubject[x].studentExamAttendance == 'ABSENT'){
                    h.studentListResultBySubject[x].ResultStatus = 'ABSENT';
                  }
                  else if(h.studentListResultBySubject[x].studentExamAttendance == 'PRESENT' && ( studentMarks == null)){
                    h.studentListResultBySubject[x].ResultStatus = '';
                  }
                }
                if(studentMarks){
                  $("#AggregateMarks"+h.studentListResultBySubject[x].studentId).text(studentMarks);
                  $(".totalMarks"+h.studentListResultBySubject[x].studentId).text(studentMarks);
                  let percent = (studentMarks * 100)/h.studentListResultBySubject[x].MaxMarks;
                  $("#percentage"+h.studentListResultBySubject[x].studentId).text(Math.round(percent));
                  $("#totalPercent"+h.studentListResultBySubject[x].studentId).text(Math.round(percent)+'%');
                  $("#percent_sign"+h.studentListResultBySubject[x].studentId).text('%');
                }
                if (h.studentListResultBySubject[x].Grade == null){
                  let resultPercentage = (studentMarks * 100)/h.studentListResultBySubject[x].MaxMarks;
                  if(studentMarks){
                    for(let z=0; z<h.gradeSystemArray.length; z++){
                      if(resultPercentage >= h.gradeSystemArray[z].MinMarks && resultPercentage <= h.gradeSystemArray[z].MaxMarks){
                        h.studentListResultBySubject[x].Grade = h.gradeSystemArray[z].Grade;
                      }
                    }
                  }
                }
              }
              setTimeout(function () {
                h.initializeDataTableWithOutPaging('studentsResultTable');
                //h.initializeDataTable('showStudentMarksTable');
                h.initializeDataTableOrder('showStudentMarksTable');
              },50)
            },5)
          }
          else {
            setTimeout(function () {
              for(var i=0; i<h.studentListResultBySubject.length; i++){
                if(!h.studentListResultBySubject[i].ResultStatus){
                  if(h.studentListResultBySubject[i].studentExamAttendance == 'PRESENT' && h.studentListResultBySubject[i].MinMarks <= h.studentListResultBySubject[i].Marks && h.studentListResultBySubject[i].Marks != null){
                    h.studentListResultBySubject[i].ResultStatus = 'PASS'
                  }
                  else if(h.studentListResultBySubject[i].studentExamAttendance == 'PRESENT' && h.studentListResultBySubject[i].MinMarks > h.studentListResultBySubject[i].Marks && h.studentListResultBySubject[i].Marks != null){
                    h.studentListResultBySubject[i].ResultStatus = 'FAIL'
                  }
                  else if(h.studentListResultBySubject[i].studentExamAttendance == 'ABSENT'){
                    h.studentListResultBySubject[i].ResultStatus = 'ABSENT'
                  }
                  else if(h.studentListResultBySubject[i].studentExamAttendance == 'PRESENT' && (h.studentListResultBySubject[i].Marks == '' || h.studentListResultBySubject[i].Marks == null)){
                    h.studentListResultBySubject[i].ResultStatus = '';
                  }
                }
                var percentage = (h.studentListResultBySubject[i].Marks * 100)/h.studentListResultBySubject[i].MaxMarks;
                $("#totalPercent"+h.studentListResultBySubject[i].studentId).text(Math.round(percentage)+'%');
                $("#percentage"+h.studentListResultBySubject[i].studentId).text(Math.round(percentage)+'%');
                if(h.studentListResultBySubject[i].Marks){
                  for(var j=0; j<h.gradeSystemArray.length; j++){
                    if(percentage >= h.gradeSystemArray[j].MinMarks && percentage <= h.gradeSystemArray[j].MaxMarks){
                      h.studentListResultBySubject[i].Grade = h.gradeSystemArray[j].Grade;
                    }
                  }
                }
              }
              setTimeout(function () {
                h.initializeDataTableWithOutPaging('studentsResultTable');
                //h.initializeDataTable('showStudentMarksTable');
                h.initializeDataTableOrder('showStudentMarksTable');
              },5)
            },5);
          }

        },
        async error => {
          this.studentResult = false;
          this.studentResultStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  gradeSystemArray = [];
  getExamGradeConfigByExamBoard(boardId){
    this.gradeSystemArray = [];
    this.examService.getExamGradeSystemByExamBoardService(boardId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.gradeSystemArray = data;
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  getEvalType: any;
  checkEvaluationType="";
  getExamBoardEvaluationType(boardId){
    this.examService.getExamBoardEvaluationTypeService(boardId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.getEvalType = data[0];
          this.checkEvaluationType = data[0].EvaluationType;
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  resultSubjectPercentage;
  getSubjectCountInClass(classId,ExamId,ExamBoardId){
    this.examService.getTotalCountOfSubjectInResultAndSubjectService(classId,ExamId,ExamBoardId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          var totalSubjectInClass = data.TotalSubject[0].TotalSubject;
          var totalResultSubjectOfClass = data.ResultSubject[0].TotalResultSubject;
          this.resultSubjectPercentage = (totalResultSubjectOfClass * 100)/totalSubjectInClass;
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  configGrade = [{minMarks:"",maxMarks:"",grade:"",gradePoint:""}];

  addRowInConfigResult(){
    this.createPattern.sections = [];
      for (var i=0; i<1; i++){
        this.configGrade.push({
          minMarks:"",maxMarks:"",grade:"",gradePoint:""
        });
      }
  }
  removeRowConfigResult() {
    for (var i=0; i<1; i++){
      this.configGrade.splice(this.configGrade.indexOf({
        minMarks:"",maxMarks:"",grade:"",gradePoint:""
      }),1);
    }
  }
  boardName:"";
  async resultConfigData(){
    if(!this.formValidator.validateIsDataForNumber(this.boardName)){
      const pleaseEnterBoardNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterBoardName')); 
      customToastr(pleaseEnterBoardNameTranslation, 'error');
      return;
    }
    for(var i=0; i<this.configGrade.length; i++){
      if(!this.formValidator.validateIsDataForNumber(this.configGrade[i].minMarks)){
        const pleaseEnterMinimumMarksTranslation = await firstValueFrom(this.translate.get('pleaseEnterMinimumMarks')); 
        customToastr(pleaseEnterMinimumMarksTranslation, 'error');
        return;
      }
      if(!this.formValidator.validateIsDataForNumber(this.configGrade[i].maxMarks)){
        const pleaseEnterMaximumMarksTranslation = await firstValueFrom(this.translate.get('pleaseEnterMaximumMarks')); 
        customToastr(pleaseEnterMaximumMarksTranslation, 'error');
        return;
      }
      if(!this.formValidator.validateIsDataForNumber(this.configGrade[i].grade)){
        const pleaseEnterGradeNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterGradeName')); 
        customToastr(pleaseEnterGradeNameTranslation, 'error');
        return;
      }
      if(!this.formValidator.validateIsDataForNumber(this.configGrade[i].gradePoint)){
        const pleaseEnterGradePointTranslation = await firstValueFrom(this.translate.get('pleaseEnterGradePoint')); 
        customToastr(pleaseEnterGradePointTranslation, 'error');
        return;
      }
    }
    var gradeSystemData = {
      BoardName:this.boardName,
      gradeArray:this.configGrade
    };
    $("#configGradeButton").attr("disabled", true);
    $("#configGradeCloseButton").attr("disabled", true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#configGradeButton").text(translatedText); });
    this.examService.createGradingSystemConfigService(gradeSystemData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#configGradeButton").attr("disabled", false);
          $("#configGradeCloseButton").attr("disabled", false);
          this.translate.get('configure').subscribe((translatedText: string) => { $("#configGradeButton").text(translatedText); });
          if(data.status == true){
            const gradingSystemConfigurationCreatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('gradingSystemConfigurationCreatedSuccessfully')); 
            customToastr(gradingSystemConfigurationCreatedSuccessfullyTranslation, 'success');
            $("#configGradeCloseButton").trigger("click");
          }
          else if(data.status == false){
           const examBoardNameAlreadyExistPleaseEnterOtherNameTranslation = await firstValueFrom(this.translate.get('examBoardNameAlreadyExistPleaseEnterOtherName')); 
           customToastr(examBoardNameAlreadyExistPleaseEnterOtherNameTranslation, 'error');
          }
          else {
            const gradingSystemConfigurationNotCreatedSuccessfullyPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('gradingSystemConfigurationNotCreatedSuccessfullyPleaseTryAgain')); 
            customToastr(gradingSystemConfigurationNotCreatedSuccessfullyPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          $("#configGradeButton").attr("disabled", false);
          $("#configGradeCloseButton").attr("disabled", false);
          this.translate.get('configure').subscribe((translatedText: string) => { $("#configGradeButton").text(translatedText); });
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  async compareBifurcationMarks(stData,markData){
    markData.Marks = markData.Marks.replace(/[^0-9\.]/g,'');
    var totalMarks = $("#MarksHead"+markData.pkMarksBifurcationConfigurationId).text();
    if(markData.Marks > parseInt(totalMarks)){
      const marksShouldBeLessThenOrEqualToMaximumMarksTranslation = await firstValueFrom(this.translate.get('marksShouldBeLessThenOrEqualToMaximumMarks')); 
      customToastr(marksShouldBeLessThenOrEqualToMaximumMarksTranslation, 'error');
      markData.Marks = "";
      return;
    }
    var getTotalMarks = 0;
    for(let i=0; i<stData.otherMarks.length; i++){
      if(stData.otherMarks[i].Marks){
        getTotalMarks = parseInt(stData.otherMarks[i].Marks) + getTotalMarks;
      }
    }
    $("#AggregateMarks"+stData.studentId).text(getTotalMarks);
    let percentage = (getTotalMarks * 100)/stData.MaxMarks;
    $("#percentage"+stData.studentId).text(Math.round(percentage));
    $("#percent_sign"+stData.studentId).text('%');
    if(this.checkEvaluationType != 'MARKS'){
      for(let k=0; k<this.gradeSystemArray.length; k++){
        if(Math.round(percentage) >= this.gradeSystemArray[k].MinMarks && Math.round(percentage) <= this.gradeSystemArray[k].MaxMarks){
          stData.Grade = this.gradeSystemArray[k].Grade;
        }
      }
    }
    let a = 'PASS';
    let criteriaArray = [];
    for(let j = 0; j<stData.otherMarks.length; j++){
      criteriaArray.push(stData.otherMarks[j].PassCriteria);
      if(stData.otherMarks[j].PassCriteria){
        if (stData.otherMarks[j].Marks < stData.otherMarks[j].MinPassMarks){
          a = 'FAIL';
        }
      }
    }
    if(stData.MinMarks > getTotalMarks){
      a = 'FAIL';
    }
    let newArray = [];
    $.each(criteriaArray, function(i, el){
      if($.inArray(el, newArray) === -1) newArray.push(el);
    });
    if(newArray.length == 1){
      if(newArray[0] == 0){
        if(stData.MinMarks > getTotalMarks){
          a = 'FAIL';
        }
      }
    }
    stData.ResultStatus = a;
  }

  async compareMarks(data){
    data.Marks = data.Marks.replace(/[^0-9\.]/g,'');
    if (data.Marks > data.MaxMarks){
      const marksShouldBeLessOrEqualToTotalMarksTranslation = await firstValueFrom(this.translate.get('marksShouldBeLessOrEqualToTotalMarks')); 
      customToastr(marksShouldBeLessOrEqualToTotalMarksTranslation, 'error');
      data.Marks = "";
      return;
    }
    else if(data.MinMarks > parseInt(data.Marks)){
      data.ResultStatus = 'FAIL';
    }
    else {
      data.ResultStatus = 'PASS';
    }
    var percentage = (data.Marks * 100)/data.MaxMarks;
    $("#percentage"+data.studentId).text(Math.round(percentage));
    $("#percent_sign"+data.studentId).text('%');
    if(this.checkEvaluationType != 'MARKS'){
      for(var i=0; i<this.gradeSystemArray.length; i++){
        if(Math.round(percentage) >= this.gradeSystemArray[i].MinMarks && Math.round(percentage) <= this.gradeSystemArray[i].MaxMarks){
          data.Grade = this.gradeSystemArray[i].Grade;
        }
      }
    }
  }
  absentStudent(data){
    data.ResultStatus = 'ABSENT';
    data.Marks = null;
    data.Grade = null;
    $("#AggregateMarks"+data.studentId).text("");
    $("#percentage"+data.studentId).text("");
    $("#percent_sign"+data.studentId).text("");
    for(var i=0; i<data.otherMarks.length; i++){
      data.otherMarks[i].Marks = null;
    }
  }
  presentStudent(data){
    if(data.Marks){
      if(data.MinMarks > data.Marks){
        data.ResultStatus = 'FAIL';
      }
      else {
        data.ResultStatus = 'PASS';
      }
    }
    else {
      data.ResultStatus = '';
    }
    for(var i=0; i<data.otherMarks.length; i++){
      data.otherMarks[i].Marks = '';
    }
  }
  closeOffcanvasResult(){
    $("#closeStudentResultOffcanvas").trigger("click");
  }
  enterStudentResult(editableSubject){
    var marksForBifurcationForUpdate = [];
    var studentResultListForInsert = [];
    let studentMarks = 0;
    let grade = null;
    if(this.checkMarksBifurcation){
      for(var j=0; j<this.studentListResultBySubject.length; j++){
        for(var k=0; k<this.studentListResultBySubject[j].otherMarks.length; k++){
          if(this.studentListResultBySubject[j].studentExamAttendance == 'ABSENT'){
            studentMarks = null;
          }
          else {
            studentMarks = $("#MarksBifurcation"+this.studentListResultBySubject[j].studentId+'_'+this.studentListResultBySubject[j].otherMarks[k].pkMarksBifurcationConfigurationId).val();
            /*if(!this.formValidator.validateIsDataForNumber(studentMarks)){
              const pleaseEnterMarksTranslation = await firstValueFrom(this.translate.get('pleaseEnterMarks')); 
              customToastr(pleaseEnterMarksTranslation, 'error');
              return;
            }*/
          }
          if(this.checkEvaluationType != 'MARKS'){
            grade = this.studentListResultBySubject[j].Grade;
          }
          else {
            grade = null;
          }
          let total_percent = $("#percentage"+this.studentListResultBySubject[j].studentId).text();
          if(this.studentListResultBySubject[j].pkExamResultId == null){
            studentResultListForInsert.push({pkExamResultId:this.studentListResultBySubject[j].pkExamResultId,studentId:this.studentListResultBySubject[j].studentId,
              marksBifurcationId:this.studentListResultBySubject[j].otherMarks[k].fkMarksBifurcationId,
              marksBifurcationConfigId:this.studentListResultBySubject[j].otherMarks[k].pkMarksBifurcationConfigurationId,
              Marks:studentMarks,studentExamAttendance:this.studentListResultBySubject[j].studentExamAttendance,
              ResultStatus:this.studentListResultBySubject[j].ResultStatus,percentage:total_percent,
		          Remark: this.studentListResultBySubject[j].Remark,Grade:grade
            })
          }
          else {
            marksForBifurcationForUpdate.push({pkExamResultId:this.studentListResultBySubject[j].otherMarks[k].pkExamResultId,studentId:this.studentListResultBySubject[j].studentId,
              marksBifurcationId:this.studentListResultBySubject[j].otherMarks[k].fkMarksBifurcationId,
              marksBifurcationConfigId:this.studentListResultBySubject[j].otherMarks[k].pkMarksBifurcationConfigurationId,
              Marks:studentMarks,studentExamAttendance:this.studentListResultBySubject[j].studentExamAttendance,
              ResultStatus:this.studentListResultBySubject[j].ResultStatus,percentage:total_percent,
		          Remark: this.studentListResultBySubject[j].Remark,Grade:grade
            })
          }
        }
      }
    }
    else {
      var stMarks = null;
      for(var j=0; j<this.studentListResultBySubject.length; j++){
        for(var k=0; k<this.studentListResultBySubject[j].otherMarks.length; k++){
          if(this.studentListResultBySubject[j].studentExamAttendance == 'ABSENT'){
            stMarks = null;
          }
          else {
            stMarks = this.studentListResultBySubject[j].Marks;
            /*if(!this.formValidator.validateIsDataForNumber(stMarks)){
              const pleaseEnterMarksTranslation = await firstValueFrom(this.translate.get('pleaseEnterMarks')); 
              customToastr(pleaseEnterMarksTranslation, 'error');
              return;
            }*/
          }
          if(this.checkEvaluationType != 'MARKS'){
            grade = this.studentListResultBySubject[j].Grade;
          }
          else {
            grade = null;
          }
          let total_per = $("#percentage"+this.studentListResultBySubject[j].studentId).text();
          if(this.studentListResultBySubject[j].pkExamResultId == null){
            studentResultListForInsert.push({pkExamResultId:this.studentListResultBySubject[j].pkExamResultId,studentId:this.studentListResultBySubject[j].studentId,marksBifurcationConfigId:null,marksBifurcationId:null,
              Marks:stMarks,studentExamAttendance:this.studentListResultBySubject[j].studentExamAttendance,
              ResultStatus:this.studentListResultBySubject[j].ResultStatus,percentage:total_per,
		          Remark: this.studentListResultBySubject[j].Remark,Grade:grade
            })
          }
          else {
            marksForBifurcationForUpdate.push({pkExamResultId:this.studentListResultBySubject[j].pkExamResultId,studentId:this.studentListResultBySubject[j].studentId,marksBifurcationConfigId:null,marksBifurcationId:null,
              Marks:stMarks,studentExamAttendance:this.studentListResultBySubject[j].studentExamAttendance,
              ResultStatus:this.studentListResultBySubject[j].ResultStatus,percentage:total_per,
		          Remark: this.studentListResultBySubject[j].Remark,Grade:grade
            })
          }
        }
      }
    }
    var examResultData = {
      studentResultListForInsert:studentResultListForInsert,
      studentResultListForUpdate:marksForBifurcationForUpdate,
      classId:this.selectedClassIdForResult,
      ExamId:this.selectedExamIdForResult,
      scheduledId:this.examScheduleId
    };
    $("#saveExamResultButton").attr("disabled", true);
    $("#cancelExamResultButton").attr("disabled", true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#saveExamResultButton").text(translatedText); });
    this.examService.createOrUpdateExamResultBySubjectService(examResultData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#saveExamResultButton").attr("disabled", false);
          $("#cancelExamResultButton").attr("disabled", false);
          this.translate.get('save').subscribe((translatedText: string) => { $("#saveExamResultButton").text(translatedText); });
          if(data.status == true){
            const examResultSuccessfullySavedTranslation = await firstValueFrom(this.translate.get('examResultSuccessfullySaved')); 
            customToastr(examResultSuccessfullySavedTranslation, 'success');
            for(let m=0; m<this.subjectListByExamClass.length; m++){
              if(this.subjectListByExamClass[m].subjectId == this.selectedSubjectIdForResult){
                this.subjectListByExamClass[m].subjectResultStatus = true;
              }
            }
            this.resultDeclare(this.selectedSubjectIdForResult,this.examScheduleId,this.selectedField,editableSubject);
          }
          else {
            const examResultNotSavedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('examResultNotSavedPleaseTryAgain')); 
            customToastr(examResultNotSavedPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          $("#saveExamResultButton").attr("disabled", false);
          $("#cancelExamResultButton").attr("disabled", false);
          this.translate.get('save').subscribe((translatedText: string) => { $("#saveExamResultButton").text(translatedText); });
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  getClassSectionList = [];
  selectClassSectionId = 0;
  sectionListByClass = false;
  sectionListDataStatus = false;
  ExamIdForSelectedBoard = 0;
  scholasticListByExam = [];
  selectClassSection(getExamId){
    this.ExamIdForSelectedBoard = getExamId;
    this.getClassSectionList = [];
    this.scholasticListByExam = [];
    this.selectClassSectionId = 0;
    this.ExamListByBoard = false;
    this.classListByExam = false;
    this.examResultStatus = true;
    this.examResultDataStatus = false;
    this.sectionListByClass = false;
    this.classListDataStatus = false;
    this.sectionListDataStatus = false;
    this.selectedExamIdForGetResult = getExamId;
    this.destroyDataTable('sectionListTable');
      this.examService.getClassSectionByExamAndBoardService(getExamId,this.selectedExamBoardIdForResult,this.academicInfo.current_academic,this.getAuthToken)
        .subscribe(
          (data: any) => {
            this.examResultStatus = false;
            this.getClassSectionList = data.sectionList;
            if(this.getClassSectionList.length == 0){
              this.sectionListDataStatus = true;
            }
            else {
              this.sectionListByClass = true;
              this.initializeDataTable('sectionListTable');
            }
          },
          async error => {
            this.examResultStatus = false;
            this.sectionListDataStatus = false;
            this.sectionListByClass = false;
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          }
        );

  }
  examResultListArray = [];
  selectedClassSubjectList = [];
  examResultStatus = false;
  examResultDataStatus = false;
  examResultListStatus = false;
  examScheduleList = [];
  examResultBySectionStatus = false;
  resultListDataStatus = false;
  selectedExamClassId;
  classNumber = "";
  selectedClassExamName = "";
  getExamResultOfClassSection(classDetails){
      this.marksType = true;
      this.gradeType = false;
    this.selectClassSectionId = classDetails.classId;
    this.classNumber = classDetails.classNumber+" "+classDetails.classDivision;
    this.selectedClassExamName = classDetails.ExamName;
    this.examResultListArray = [];
    this.selectedClassSubjectList = [];
    this.examScheduleList = [];
    this.examResultBySectionStatus = true;
    this.examResultDataStatus = false;
    this.examResultListStatus = false;
    this.resultListDataStatus = false;
    this.getSubjectCountInClass(this.selectClassSectionId,this.selectedExamIdForGetResult,this.selectedExamBoardIdForResult);
    this.getExamGradeConfigByExamBoard(this.selectedExamBoardIdForResult);
    this.getExamBoardEvaluationType(this.selectedExamBoardIdForResult);
    this.examService.getStudentResultListService(this.selectClassSectionId,this.selectedExamIdForGetResult,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.examResultBySectionStatus = false;
          this.examResultDataStatus = false;
          this.examResultListStatus = false;
          this.examResultListArray = data.resultDetailsBySection;
          this.selectedClassSubjectList = data.subjectList;
          if(this.examResultListArray.length == 0){
            this.resultListDataStatus = true;
            //this.examResultListStatus = false;
          }
          else {
            this.examResultDataStatus = false;
            this.examResultListStatus = true;
          }
          this.selectedExamClassId = this.examResultListArray[0].otherDetails[0].classId;
          for(let k=0; k<this.examResultListArray[0].otherDetails.length; k++){
            this.examScheduleList.push({examScheduleId:this.examResultListArray[0].otherDetails[k].pkExamScheduleId})
          }
          var h=this;
          setTimeout(function () {
            for(var i=0; i<h.examResultListArray.length; i++){
              var totMarks = 0;
              var studentMarks = 0;
              let studentPercentCalculation = 0;
              for(var j=0; j<h.examResultListArray[i].otherDetails.length; j++){
                var totalMarks = h.examResultListArray[i].otherDetails[j].MaxMarks;
                totMarks = h.examResultListArray[i].otherDetails[j].MaxMarks + totMarks;
                studentMarks += h.examResultListArray[i].otherDetails[j].Marks;
                if(h.examResultListArray[i].otherDetails[j].Marks != null){
                  var percentage = (h.examResultListArray[i].otherDetails[j].Marks * 100)/totalMarks;
                  studentPercentCalculation += Math.round(percentage);
                  if(h.checkEvaluationType != 'MARKS'){
                    for(let m=0; m<h.gradeSystemArray.length; m++){
                      if(Math.round(percentage) >= h.gradeSystemArray[m].MinMarks && Math.round(percentage) <= h.gradeSystemArray[m].MaxMarks){
                        $("#Marks_"+h.examResultListArray[i].studentId+'_'+h.examResultListArray[i].otherDetails[j].fkSubjectId).text(h.examResultListArray[i].otherDetails[j].Marks);
                        $("#Grade_"+h.examResultListArray[i].studentId+'_'+h.examResultListArray[i].otherDetails[j].fkSubjectId).text(h.gradeSystemArray[m].Grade);
                      }
                    }
                  }
                  else {
                    $("#Marks_"+h.examResultListArray[i].studentId+'_'+h.examResultListArray[i].otherDetails[j].fkSubjectId).text(h.examResultListArray[i].otherDetails[j].Marks);
                  }
                }
                else if(h.examResultListArray[i].otherDetails[j].Marks == null && h.examResultListArray[i].otherDetails[j].studentExamAttendance == 'ABSENT'){
                  $("#Marks_"+h.examResultListArray[i].studentId+'_'+h.examResultListArray[i].otherDetails[j].fkSubjectId).text('ABSENT');
                  $("#Grade_"+h.examResultListArray[i].studentId+'_'+h.examResultListArray[i].otherDetails[j].fkSubjectId).text('ABSENT');
                }

              }
              let total_percent = h.selectedClassSubjectList.length*100;
              $("#overAllMarks"+h.examResultListArray[i].studentId).text(totMarks);
              $("#student_total_percent"+h.examResultListArray[i].studentId).text(Math.round(total_percent));
              $("#studentMarks_"+h.examResultListArray[i].studentId).text(studentMarks);
              var totalPercentage = (studentMarks * 100)/totMarks;
              $("#studentMarksPercentage_"+h.examResultListArray[i].studentId).text(totalPercentage.toFixed(2)+" "+"%");
              if(h.checkEvaluationType != 'MARKS'){
                for(let k=0; k<h.gradeSystemArray.length; k++){
                  if(Math.round(totalPercentage) >= h.gradeSystemArray[k].MinMarks && Math.round(totalPercentage) <= h.gradeSystemArray[k].MaxMarks){
                    $("#studentGrade_"+h.examResultListArray[i].studentId).text(h.gradeSystemArray[k].Grade);
                  }
                }
              }
            }
          },100);

        },
        async error => {
          this.examResultBySectionStatus = false;
          this.examResultDataStatus = false;
          this.examResultListStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  marksType = true;
  gradeType = false;
  checkMarksAndGrade(status){
    if(status == true){
      this.marksType = true;
      this.gradeType = false;
    }
    else {
      this.marksType = false;
      this.gradeType = true;
    }
    var h=this;
    setTimeout(function () {
      for(var i=0; i<h.examResultListArray.length; i++){
        var totMarks = 0;
        var studentMarks = 0;
        for(var j=0; j<h.examResultListArray[i].otherDetails.length; j++){
          var totalMarks = h.examResultListArray[i].otherDetails[j].MaxMarks;
          totMarks = h.examResultListArray[i].otherDetails[j].MaxMarks + totMarks;
          studentMarks += h.examResultListArray[i].otherDetails[j].Marks;
          if(h.examResultListArray[i].otherDetails[j].Marks != null){
            var percentage = (h.examResultListArray[i].otherDetails[j].Marks * 100)/totalMarks;
            if(h.checkEvaluationType != 'MARKS'){
              for(let m=0; m<h.gradeSystemArray.length; m++){
                if(Math.round(percentage) >= h.gradeSystemArray[m].MinMarks && Math.round(percentage) <= h.gradeSystemArray[m].MaxMarks){
                  $("#Marks_"+h.examResultListArray[i].studentId+'_'+h.examResultListArray[i].otherDetails[j].fkSubjectId).text(h.examResultListArray[i].otherDetails[j].Marks);
                  $("#Grade_"+h.examResultListArray[i].studentId+'_'+h.examResultListArray[i].otherDetails[j].fkSubjectId).text(h.gradeSystemArray[m].Grade);
                }
              }
            }
            else {
              $("#Marks_"+h.examResultListArray[i].studentId+'_'+h.examResultListArray[i].otherDetails[j].fkSubjectId).text(h.examResultListArray[i].otherDetails[j].Marks);
            }
          }
          else if(h.examResultListArray[i].otherDetails[j].Marks == null && h.examResultListArray[i].otherDetails[j].studentExamAttendance == 'ABSENT'){
            $("#Marks_"+h.examResultListArray[i].studentId+'_'+h.examResultListArray[i].otherDetails[j].fkSubjectId).text('ABSENT');
            $("#Grade_"+h.examResultListArray[i].studentId+'_'+h.examResultListArray[i].otherDetails[j].fkSubjectId).text('ABSENT');
          }

        }
        let total_percent = h.selectedClassSubjectList.length*100;
        $("#overAllMarks"+h.examResultListArray[i].studentId).text(totMarks);
        $("#student_total_percent"+h.examResultListArray[i].studentId).text(Math.round(total_percent));
        $("#studentMarks_"+h.examResultListArray[i].studentId).text(studentMarks);
        var totalPercentage = (studentMarks * 100)/totMarks;
        $("#studentMarksPercentage_"+h.examResultListArray[i].studentId).text(totalPercentage.toFixed(2)+" "+"%");
        $("#student_total_MarksPercentage_"+h.examResultListArray[i].studentId).text(totalPercentage.toFixed(2)+" "+"%");
        if(h.checkEvaluationType != 'MARKS'){
          for(let k=0; k<h.gradeSystemArray.length; k++){
            if(Math.round(totalPercentage) >= h.gradeSystemArray[k].MinMarks && Math.round(totalPercentage) <= h.gradeSystemArray[k].MaxMarks){
              $("#studentGrade_"+h.examResultListArray[i].studentId).text(h.gradeSystemArray[k].Grade);
            }
          }
        }
      }
    },100);
  }

  async publishExamResultByClassSection(data,status){
    if(data.pkExamResultStatusId){
      const resultAlreadyPublishedTranslation = await firstValueFrom(this.translate.get('resultAlreadyPublished')); 
      customToastr(resultAlreadyPublishedTranslation, 'error');
      return;
    }
    if(status == true){
      for(var i=0; i<this.examResultListArray.length; i++){
        for(var j=0; j<this.examResultListArray[i].otherDetails.length; j++){
          var marks = $("#Marks_"+this.examResultListArray[i].studentId+'_'+this.examResultListArray[i].otherDetails[j].fkSubjectId).text();
          if(marks == '--'){
            const pleaseEnterResultsFirstTranslation = await firstValueFrom(this.translate.get('pleaseEnterResultsFirst')); 
            customToastr(pleaseEnterResultsFirstTranslation, 'error');
            return;
          }
        }
      }
    }

    var publishData = {
      classId:data.classId,
      ExamId:this.selectedExamIdForGetResult
      //ExamSchedule:this.examScheduleList
    }
    $("#publishButton").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#publishButton").text(translatedText); });
    this.examService.publishExamResultService(publishData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#publishButton").attr("disabled",false);
          this.translate.get('publishResult').subscribe((translatedText: string) => { $("#publishButton").text(translatedText); });
          if(data.student_result && data.message == 'RESULT_PUBLISHED'){
            const resultPublishedSuccessfullyTranslation = await firstValueFrom(this.translate.get('resultPublishedSuccessfully')); 
            customToastr(resultPublishedSuccessfullyTranslation, 'success');
            this.selectClassSection(this.selectedExamIdForGetResult);
          }
          else if(!data.student_result && data.message == 'ALL_STUDENT_MARKS_NOT_ENTERED'){
            const marksOfAllStudentIsNotEnteredPleaseEnterTheMarksFirstThenYouWillBeAbleToPublishResultTranslation = await firstValueFrom(this.translate.get('marksOfAllStudentIsNotEnteredPleaseEnterTheMarksFirstThenYouWillBeAbleToPublishResult')); 
            customToastr(marksOfAllStudentIsNotEnteredPleaseEnterTheMarksFirstThenYouWillBeAbleToPublishResultTranslation, 'error');
          }
          else {
           const resultNotPublishedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('resultNotPublishedPleaseTryAgain')); 
           customToastr(resultNotPublishedPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          $("#publishButton").attr("disabled",false);
          this.translate.get('publishResult').subscribe((translatedText: string) => { $("#publishButton").text(translatedText); });
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  async getClassListByExamId(data){
    if(data.PublishClassPercent == 100){
      const resultAlreadyPublishedTranslation = await firstValueFrom(this.translate.get('resultAlreadyPublished')); 
      customToastr(resultAlreadyPublishedTranslation, 'error');
      return;
    }
    let ExamId = data.pkExamId;
    this.translate.get('publishing').subscribe((translatedText: string) => {
        $("#publishText"+ExamId).text(translatedText);
    });
    $("#publishKey"+ExamId).removeClass('hide');
    this.examService.getClassIdListByExamIdService(this.selectedExamBoardIdForResult,ExamId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          var classList = data.classList;
          this.publishExamByExamId(classList,ExamId);
        },
        async error =>{
          this.translate.get('PUBLISH').subscribe((translatedText: string) => {
              $("#publishText"+ExamId).text(translatedText);
          });
          $("#publishKey"+ExamId).addClass('hide');
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  publishExamByExamId(classList,ExamId){
    var getClassList = [];
    for(var i=0; i<classList.length; i++){
      getClassList.push({classId:classList[i].fkClassId})
    }
    var publishData = {
      classList:getClassList,
      ExamId:ExamId
    }
    this.examService.publishExamResultByExamService(publishData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          this.translate.get('PUBLISH').subscribe((translatedText: string) => {
              $("#publishText"+ExamId).text(translatedText);
          });
          $("#publishKey"+ExamId).addClass('hide');
          if(data.student_result){
            const resultPublishedSuccessfullyTranslation = await firstValueFrom(this.translate.get('resultPublishedSuccessfully')); 
            customToastr(resultPublishedSuccessfullyTranslation, 'success');
            this.selectExamByBoard(this.selectedExamBoardIdForResult);
          }
          else if(!data.student_result){
           const marksOfAllStudentIsNotEnteredPleaseEnterTheMarksFirstThenYouWillBeAbleToPublishResultTranslation = await firstValueFrom(this.translate.get('marksOfAllStudentIsNotEnteredPleaseEnterTheMarksFirstThenYouWillBeAbleToPublishResult')); 
           customToastr(marksOfAllStudentIsNotEnteredPleaseEnterTheMarksFirstThenYouWillBeAbleToPublishResultTranslation, 'error');
          }
          else {
            const resultNotPublishedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('resultNotPublishedPleaseTryAgain')); 
            customToastr(resultNotPublishedPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          this.translate.get('PUBLISH').subscribe((translatedText: string) => {
              $("#publishText"+ExamId).text(translatedText);
          });
          $("#publishKey"+ExamId).addClass('hide');
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  examBoardArray = [];
  getExamBoardNameList(){
    this.examBoardArray = [];
    this.examService.getExamBoardListService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data:any) => {
          this.examBoardArray = data;
          this.selectExamByBoard(this.examBoardArray[0].pkSchoolExamBoardId);
          this.fetchResultPublishLevel();
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  examBoardByExamIdList = [];
  getSchoolExamBoardByExam(){
    this.examBoardByExamIdList = [];
    this.examService.getSchoolExamBoardByExamService(this.selectedClassExamId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.examBoardByExamIdList = data;
          this.getClassListByExam();
          //this.getScholasticConfigListForUpdateExam();
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  scholasticListForUpdateExam = [];
  getScholasticConfigListForUpdateExam(){
    this.scholasticListForUpdateExam = [];
    this.examService.getScholasticConfigListForUpdateExamService(this.selectedClassExamId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.scholasticListForUpdateExam = data;
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  classListForExam = [];
  getClassListByExam(){
    this.classListForExam = [];
    this.examService.getClassListByExamService(this.selectedClassExamId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.classListForExam = data;
          var h = this;
          setTimeout(function () {
            for(var i=0; i<h.examBoardByExamIdList.length; i++){
              if(h.examBoardByExamIdList[i].boardStatus){
                $("#boardClassForUpdate"+h.examBoardByExamIdList[i].pkSchoolExamBoardId).show();
              }
              else {
                $("#boardClassForUpdate"+h.examBoardByExamIdList[i].pkSchoolExamBoardId).hide();
              }
            }
          },5);

        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  /*REPORT CARD START*/
  reportCardOffcanvas(){
    this.offcanvas.handleOffcanvasOpen('#createScholasticConfig');
    this.fetchScholasticList();
    this.getAllSubject();
    this.reportData = {
      categoryName:"",language:"NO",subjectList:[],subCategory:[{sectionName:"",Evaluation:"MARKS",ScholasticId:"",configReportCard:[{subSection:""}]}]
    };
  }
  reportData = {
    categoryName:"",language:"NO",subjectList:[],subCategory:[{sectionName:"",Evaluation:"MARKS",ScholasticId:"",configReportCard:[{subSection:""}]}]
  };
  reportDataChange(){
    this.reportData.subCategory.push({
      sectionName:"",Evaluation:"MARKS",ScholasticId:"",configReportCard:[{subSection:""}]
    });
  }
  reportDataRemove(i){
    this.reportData.subCategory.splice(i,1);
  }
  viewGrade = false;
  getScholasticGradeId;
  scholasticGardeOpen(data){
    if(data == 'AddNewGrade'){
      $("#ConfigGradeSystemPopup").modal("show");
      this.viewGrade = false;
      this.gradeSystemForReportCard = {
        scholasticName:"",selectedSectionData:[{minMarks:"",maxMarks:"",grade:"",Remarks:""}]
      };
    }
    else {
      this.getScholasticGradeId = data;
      this.viewGrade = true;
    }
  }
  //configReportCard=[{subSection:""}];
  addRowInConfigReportCard(data){
        data.configReportCard.push({
          subSection:""
        });
  }
  removeRowConfigReportCard(data) {
    data.configReportCard.splice(data.configReportCard.indexOf({
      subSection:""
    }),1);
  }
  async configureScholasticConfig(){
    this.reportData.subjectList = [];
    if(!this.formValidator.validateIsDataForNumber(this.reportData.categoryName)){
      const pleaseEnterScholasticCategoryNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterScholasticCategoryName')); 
      customToastr(pleaseEnterScholasticCategoryNameTranslation, 'error');
      return;
    }
    for(var k=0; k<this.allSubjectList.length; k++){
      if(this.allSubjectList[k].select == true){
        this.reportData.subjectList.push({subjectId:this.allSubjectList[k].subjectId})
      }
    }
    if(this.reportData.language == 'YES'){
      if(this.reportData.subjectList.length == 0){
        const pleaseSelectAtleastOneSubjectTranslation = await firstValueFrom(this.translate.get('pleaseSelectAtleastOneSubject')); 
        customToastr(pleaseSelectAtleastOneSubjectTranslation, 'error');
        return;
      }
    }
    else {
      this.reportData.subjectList = [];
    }
    for(var i=0; i<this.reportData.subCategory.length; i++){
      if(!this.formValidator.validateIsDataForNumber(this.reportData.subCategory[i].sectionName)){
        const pleaseEnterScholasticSkillNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterScholasticSkillName')); 
        customToastr(pleaseEnterScholasticSkillNameTranslation, 'error');
        return;
      }
      if(this.reportData.subCategory[i].Evaluation == 'GRADE'){
        if(!this.formValidator.validateIsDataForNumber(this.reportData.subCategory[i].ScholasticId)){
          const pleaseProvideScholasticGradeConfigTranslation = await firstValueFrom(this.translate.get('pleaseProvideScholasticGradeConfig')); 
          customToastr(pleaseProvideScholasticGradeConfigTranslation, 'error');
          return;
        }
        if(this.reportData.subCategory[i].ScholasticId == 'AddNewGrade'){
          const pleaseCheckManuallySelectedScholasticGradeConfigTranslation = await firstValueFrom(this.translate.get('pleaseCheckManuallySelectedScholasticGradeConfig')); 
          customToastr(pleaseCheckManuallySelectedScholasticGradeConfigTranslation, 'error');
          return;
        }
      }
      else {
        this.reportData.subCategory[i].ScholasticId = null;
      }
      for(var j=0; j<this.reportData.subCategory[i].configReportCard.length; j++){
        if(!this.formValidator.validateIsDataForNumber(this.reportData.subCategory[i].configReportCard[j].subSection)){
          const pleaseEnterSubSkillNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterSubSkillName')); 
          customToastr(pleaseEnterSubSkillNameTranslation, 'error');
          return;
        }
      }
    }

    $("#addScholConfigButton").attr("disabled",true);
    $("#closeScholConfigPopup").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#addScholConfigButton").text(translatedText); });
    this.examService.createScholasticConfigurationService(this.reportData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#addScholConfigButton").attr("disabled",false);
          $("#closeScholConfigPopup").attr("disabled",false);
          this.translate.get('configure').subscribe((translatedText: string) => { $("#addScholConfigButton").text(translatedText); });
          if(data.status == true){
            const scholasticConfigurationCreatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('scholasticConfigurationCreatedSuccessfully')); 
            customToastr(scholasticConfigurationCreatedSuccessfullyTranslation, 'success');
            this.fetchScholasticConfigurationList();
            $("#closeScholConfigPopup").trigger("click");
          }
          else {
            const scholasticConfigurationNotCreatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('scholasticConfigurationNotCreatedPleaseTryAgain')); 
            customToastr(scholasticConfigurationNotCreatedPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          $("#addScholConfigButton").attr("disabled",false);
          $("#closeScholConfigPopup").attr("disabled",false);
          this.translate.get('configure').subscribe((translatedText: string) => { $("#addScholConfigButton").text(translatedText); });
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  studentStatus = false;
  studentDataStatus = false;
  studentListDataTable = false;
  studentList = [];
  selectedExamIdForClass = 0;
  classListArray = [];
  classListForReportStatus = false;
  classListForReportDataStatus = false;
  classListDataTable = false;
  selectedExamBoard = 0;
  async getClassListByExamAndBoard(){
    if(this.selectedExamIdForClass == 0){
      const pleaseSelectBoardAndExamTranslation = await firstValueFrom(this.translate.get('pleaseSelectBoardAndExam')); 
      customToastr(pleaseSelectBoardAndExamTranslation, 'error');
      return;
    }
    this.classListForReportStatus = true;
    this.classListForReportDataStatus = false;
    this.classListDataTable = false;
    this.classListArray = [];
    this.destroyDataTable('classListTable');
    this.examService.getPublishedExamClassListService(this.selectedExamIdForClass,this.selectedExamBoard,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.classListForReportStatus = false;
          this.classListArray = data;
          if(this.classListArray.length > 0){
            this.classListForReportDataStatus = false;
            this.classListDataTable = true;
            this.initializeDataTable('classListTable');
          }
          else {
            this.classListForReportDataStatus = true;
            this.classListDataTable = false;
          }
        },
        async error =>{
          this.classListForReportStatus = false;
          this.classListForReportDataStatus = false;
          this.classListDataTable = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  getClassAndSectionNameForExam = "";
  getExamNameForExam = "";
  selectedClassIdForReportCard;
  classListForExamReport = true;
  IsScholasticTypeExam = "";
  getExamIdForReportCard = null;
  classNumberForExam = null;
  classDivision = null;
  examCommence = "";
  getStudentListByClassSection(data){
    this.IsScholasticTypeExam = data.IsScholasticType;
    this.showStudentList = true;
    this.classListForExamReport = false;
    this.selectedClassIdForReportCard = data.classId;
    this.getClassAndSectionNameForExam = data.classNumber+' - '+data.classDivision;
    this.classNumberForExam = data.classNumber;
    this.classDivision = data.classDivision;
    this.getExamNameForExam = data.ReportCardExamName;
    this.getExamIdForReportCard = data.pkExamId;
    this.examCommence = data.commence;
    this.studentList = [];
    this.destroyDataTable('studentListTable');
    this.studentStatus = true;
    this.studentDataStatus = false;
    this.studentListDataTable = false;
    this.examService.studentListForReportCardService(data.classId,data.pkExamId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.studentStatus = false;
          this.studentList = data;
          if(this.studentList.length == 0){
            this.studentDataStatus = true;
            this.studentListDataTable = false;
          }
          else {
            this.studentDataStatus = false;
            this.studentListDataTable = true;
            this.initializeDataTableOrder('studentListTable');
          }
        },
        async error =>{
          this.studentStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  /*REPORT CARD END*/
  /*EXAM SETTING PART START*/
  gradeSystemForReportCard = {
    scholasticName:"",selectedSectionData:[{minMarks:"",maxMarks:"",grade:"",Remarks:""}]
  };
  clearDataForScholasticGrade(){
    this.gradeSystemForReportCard = {
      scholasticName:"",selectedSectionData:[{minMarks:"",maxMarks:"",grade:"",Remarks:""}]
    };
  }
  addRowInConfigReportGrade(){
    this.gradeSystemForReportCard.selectedSectionData.push({
      minMarks:"",maxMarks:"",grade:"",Remarks:""
    });
  }
  removeRowConfigReportGrade(i) {
    this.gradeSystemForReportCard.selectedSectionData.splice(i,1);
  }
  async configGradeForReport(){
    if(!this.formValidator.validateIsDataForNumber(this.gradeSystemForReportCard.scholasticName)){
      const pleaseEnterScholasticNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterScholasticName')); 
      customToastr(pleaseEnterScholasticNameTranslation, 'error');
      return;
    }
    for(var i=0; i<this.gradeSystemForReportCard.selectedSectionData.length; i++){
      if(!this.formValidator.validateIsDataForNumber(this.gradeSystemForReportCard.selectedSectionData[i].grade)){
        const pleaseEnterScholasticGradeTranslation = await firstValueFrom(this.translate.get('pleaseEnterScholasticGrade')); 
        customToastr(pleaseEnterScholasticGradeTranslation, 'error');
        return;
      }
    }
    $("#configScholasticGradeButton").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#configScholasticGradeButton").text(translatedText); });
    $("#configScholasticGradeCloseButton").attr("disabled",true);
    this.examService.createScholasticGradeService(this.gradeSystemForReportCard,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#configScholasticGradeButton").attr("disabled",false);
          this.translate.get('configure').subscribe((translatedText: string) => { $("#configScholasticGradeButton").text(translatedText); });
          $("#configScholasticGradeCloseButton").attr("disabled",false);
          if(data.status){
            const scholasticGradeConfigureSuccessfullyTranslation = await firstValueFrom(this.translate.get('scholasticGradeConfigureSuccessfully')); 
            customToastr(scholasticGradeConfigureSuccessfullyTranslation, 'success');
            $("#configScholasticGradeCloseButton").trigger("click");
            this.fetchScholasticList();
          }
          else if(data.status == false){
            const scholasticNameAlreadyExistPleaseEnterOtherNameTranslation = await firstValueFrom(this.translate.get('scholasticNameAlreadyExistPleaseEnterOtherName')); 
            customToastr(scholasticNameAlreadyExistPleaseEnterOtherNameTranslation, 'error');
          }
          else {
            const scholasticGradeNotConfiguredPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('scholasticGradeNotConfiguredPleaseTryAgain')); 
            customToastr(scholasticGradeNotConfiguredPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          $("#configScholasticGradeButton").attr("disabled",false);
          this.translate.get('configure').subscribe((translatedText: string) => { $("#configScholasticGradeButton").text(translatedText); });
          $("#configScholasticGradeCloseButton").attr("disabled",false);
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  scholasticStatus = false;
  scholasticDataStatus = false;
  scholasticListDataTable = false;
  scholasticList = [];
  fetchScholasticList(){
    this.scholasticList = [];
    this.destroyDataTable('scholasticListTable');
    this.scholasticStatus = true;
    this.scholasticDataStatus = false;
    this.scholasticListDataTable = false;
    this.examService.fetchScholasticListService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.scholasticStatus = false;
          this.scholasticList = data;
          if(this.scholasticList.length == 0){
            this.scholasticDataStatus = true;
            this.scholasticListDataTable = false;
          }
          else {
            this.scholasticDataStatus = false;
            this.scholasticListDataTable = true;
            this.initializeDataTableOrder('scholasticListTable');
          }
        },
        async error => {
          this.scholasticStatus = false;
          this.scholasticDataStatus = false;
          this.scholasticListDataTable = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  scholasticGradeConfigData = [];
  scholasticName = "";
  getScholasticGradeConfig(scholasticNameId){
    this.scholasticGradeConfigData = [];
    this.examService.getScholasticGradeConfigService(scholasticNameId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.scholasticGradeConfigData = data;
          this.scholasticName = this.scholasticGradeConfigData[0].ScholasticName;
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  addRowInUpdateScholasticGrade(){
    this.scholasticGradeConfigData.push({
      MinMarks:"",MaxMarks:"",Grade:"",Remarks:""
    });
  }
  removeRowUpdateScholasticGrade(i) {
    this.scholasticGradeConfigData.splice(i,1);
  }
  updateScholasticGradeConfig(){
  }
  scholasticConfiguartionList = [];
  scholStatus = false;
  scholDataStatus = false;
  scholListDataStatus = false;
  fetchScholasticConfigurationList(){
    this.scholStatus = true;
    this.scholDataStatus = false;
    this.scholListDataStatus = false;
    this.scholasticConfiguartionList = [];
    this.destroyDataTable('ScholasticConfigListTable');
    this.examService.fetchScholasticConfigListService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.scholStatus = false;
          this.scholasticConfiguartionList = data;
          if(this.scholasticConfiguartionList.length == 0){
            this.scholDataStatus = true;
            this.scholListDataStatus = false;
          }
          else {
            this.scholDataStatus = false;
            this.scholListDataStatus = true;
            this.initializeDataTableOrder('ScholasticConfigListTable');
            this.scholasticClassLink(this.scholasticConfiguartionList[0]);
          }
        },
        async error =>{
          this.scholStatus = false;
          this.scholDataStatus = false;
          this.scholListDataStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  scholasticConfigName = "";
  selectedScholasticConfigId;
  deleteScholasticConfig(data){
    this.selectedScholasticConfigId = data.pkScholasticConfigurationId;
    this.scholasticConfigName = data.ScholasticConfigurationName;
  }
  deleteSelectedScholasticConfig(){
    $("#deleteScholButton").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#deleteScholButton").text(translatedText); });
    $("#cancelDeleteScholButton").attr("disabled",true);
    this.examService.removeScholasticConfigurationService(this.selectedScholasticConfigId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#deleteScholButton").attr("disabled",false);
          this.translate.get('confirm').subscribe((translatedText: string) => { $("#deleteScholButton").text(translatedText); });
          $("#cancelDeleteScholButton").attr("disabled",false);
          if(data.status == true){
            const scholasticConfigurationDeletedSuccessfullyTranslation = await firstValueFrom(this.translate.get('scholasticConfigurationDeletedSuccessfully')); 
            customToastr(scholasticConfigurationDeletedSuccessfullyTranslation, 'success');
            $("#cancelDeleteScholButton").trigger("click");
            this.fetchScholasticConfigurationList();
          }
          else {
            const scholasticConfigurationNotDeletedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('scholasticConfigurationNotDeletedPleaseTryAgain')); 
            customToastr(scholasticConfigurationNotDeletedPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          $("#deleteScholButton").attr("disabled",false);
          this.translate.get('confirm').subscribe((translatedText: string) => { $("#deleteScholButton").text(translatedText); });
          $("#cancelDeleteScholButton").attr("disabled",false);
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  selectedScholasticNameId;
  selectedScholasticGradeName = "";
  deleteScholasticGradeAndNameConfig(data){
    this.selectedScholasticNameId= data.pkScholasticGradeNameId;
    this.selectedScholasticGradeName = data.ScholasticName
  }
  deleteScholasticGradeConfig(){
    $("#deleteScholGradeButton").attr("disabled",true);
    $("#cancelDeleteScholGradeButton").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#deleteScholGradeButton").text(translatedText); });
    this.examService.removeScholasticGradeConfigService(this.selectedScholasticNameId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          $("#deleteScholGradeButton").attr("disabled",false);
          $("#cancelDeleteScholGradeButton").attr("disabled",false);
          this.translate.get('confirm').subscribe((translatedText: string) => { $("#deleteScholGradeButton").text(translatedText); });
          if(data.status == true){
            const scholasticGradeSystemDeletedSuccessfullyTranslation = await firstValueFrom(this.translate.get('scholasticGradeSystemDeletedSuccessfully')); 
            customToastr(scholasticGradeSystemDeletedSuccessfullyTranslation, 'success');
            $("#cancelDeleteScholGradeButton").trigger("click");
            this.fetchScholasticList();
          }
          else {
            const scholasticGradeSystemNotDeletedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('scholasticGradeSystemNotDeletedPleaseTryAgain')); 
            customToastr(scholasticGradeSystemNotDeletedPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          $("#deleteScholGradeButton").attr("disabled",false);
          $("#cancelDeleteScholGradeButton").attr("disabled",false);
          this.translate.get('confirm').subscribe((translatedText: string) => { $("#deleteScholGradeButton").text(translatedText); });
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  coScholasticListArray = [];
  subCosList = [];
  studentClassStdId = null;
  studentExamPosition = null;
  principalStudentRemarks = null;
  studentOffcanvasReportCard(studentData){
    this.totalStudentInClass = this.studentList.length;
    this.studentExamPosition = studentData.position;
    this.classTeacherRemarks = studentData.TeacherRemarks;
    this.principalStudentRemarks = studentData.PrincipalRemarks;
    let studentId = studentData.studentId;
    this.studentClassStdId = studentData.fkClassStandardsId;
    this.offcanvas.handleOffcanvasOpen('#studentReportCard');
    this.fetchReportCardSettings();
    this.getStudentDetailByStudentId(studentId);
    this.getSchoolDetail();
    this.studentDetailForReportCard(studentId);
    this.getExamGradeConfigByExamBoard(this.selectedExamBoardIdForResult);
    if(this.IsScholasticTypeExam == 'YES'){
      this.getStudentScholasticConfigDetail(studentId);
    }
  }
  studentScholasticDetails = [];
  getStudentScholasticConfigDetail(studentId){
    let scholasticData = {
      classId:this.selectedClassIdForReportCard,
      ExamId:this.selectedExamIdForClass,
      studentId:studentId,
      ExamBoardId:this.selectedExamBoard
    };
    this.examService.fetchAllScholasticConfigDetailsService(scholasticData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.studentScholasticDetails = data;
          this.subCosList = [];
          let subjectId = [];
          let coScholasticList = {};
          let scholasticId = [];
          let co_scholasticId = [];
          for(let i = 0; i<this.studentScholasticDetails.length; i++){
            if(this.studentScholasticDetails[i].IsLanguage == 'YES'){
              for(let j = 0; j<this.studentScholasticDetails[i].scholastic.length; j++){

                for(let k = 0; k<this.studentScholasticDetails[i].scholastic[j].co_Scholastic.length; k++){
                  if(scholasticId.indexOf(this.studentScholasticDetails[i].scholastic[j].co_ScholasticConfigurationId) == -1){
                    scholasticId.push(this.studentScholasticDetails[i].scholastic[j].co_ScholasticConfigurationId);
                    if(!coScholasticList[this.studentScholasticDetails[i].scholastic[j].co_ScholasticConfigurationId]){
                      coScholasticList[this.studentScholasticDetails[i].scholastic[j].co_ScholasticConfigurationId] = {co_scolastic:this.studentScholasticDetails[i].scholastic[j],skils:[]};
                    }
                  }
                  if(co_scholasticId.indexOf(this.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].pkScholasticSkillsId) == -1){
                    co_scholasticId.push(this.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].pkScholasticSkillsId);
                    coScholasticList[this.studentScholasticDetails[i].scholastic[j].co_ScholasticConfigurationId].skils.push(this.studentScholasticDetails[i].scholastic[j].co_Scholastic[k])
                  }
                  if(subjectId.indexOf(this.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].subjectId)== -1){
                    this.subCosList.push({subjectName:this.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].subject,
                      subjectId:this.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].subjectId
                    });
                    subjectId.push(this.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].subjectId)
                  }
                }
              }
            }
          }
          for (let key in coScholasticList){
            this.coScholasticListArray.push(coScholasticList[key])
          }
          let h = this;
          setTimeout(function () {
            for(let i=0; i<h.studentScholasticDetails.length; i++){
              for(let j=0; j<h.studentScholasticDetails[i].scholastic.length; j++){
                for(let k=0; k<h.studentScholasticDetails[i].scholastic[j].co_Scholastic.length; k++){
                  if(h.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].EvaluationType == 'GRADE'){
                    $("#studentSubCosGrade"+h.studentScholasticDetails[i].scholasticConfigurationId+h.studentScholasticDetails[i].scholastic[j].co_ScholasticConfigurationId+h.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].pkScholasticSkillsId+h.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].subjectId).text(h.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].Grade)
                    $("#studentPreSubCosGrade"+h.studentScholasticDetails[i].scholasticConfigurationId+h.studentScholasticDetails[i].scholastic[j].co_ScholasticConfigurationId+h.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].pkScholasticSkillsId+h.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].subjectId).text(h.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].Grade)
                  }
                  else {
                    $("#studentSubCosGrade"+h.studentScholasticDetails[i].scholasticConfigurationId+h.studentScholasticDetails[i].scholastic[j].co_ScholasticConfigurationId+h.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].pkScholasticSkillsId+h.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].subjectId).text(h.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].ScholasticMarksOrGrade)
                    $("#studentPreSubCosGrade"+h.studentScholasticDetails[i].scholasticConfigurationId+h.studentScholasticDetails[i].scholastic[j].co_ScholasticConfigurationId+h.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].pkScholasticSkillsId+h.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].subjectId).text(h.studentScholasticDetails[i].scholastic[j].co_Scholastic[k].ScholasticMarksOrGrade)
                  }
                }
              }
            }
          },5)
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  changeSubLength(name){
    if(!name){
      return name;
    }
    else if(name.length > 3){
      return $.trim(name).substring(0,3)
    }else{
      return name;
    }
  }
  selectedScholasticDetail: any;
  subjectInScholastic = [];
  selectedScholasticConfigDetails(scholasticId){
    this.subjectInScholastic = [];
    this.examService.fetchScholasticConfigDetailByIdService(scholasticId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          
          this.selectedScholasticDetail = data.scholasticDetail[0];
          this.subjectInScholastic = data.subjectList;
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  allSubjectList = [];
  getAllSubject(){
    this.allSubjectList = [];
    this.examService.getAllSubjectOfSchoolService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.allSubjectList = data;
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  getStudentDetail: any;
  getStudentDetailByStudentId(studentId){
    this.examService.getStudentDetailByStudentService(studentId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.getStudentDetail = data[0];
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  schoolDetail: any;
  getSchoolDetail(){
    this.examService.getSchoolDetailsService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.schoolDetail = data;
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  changeDuration(data){
    $("#duration"+data.subjectId).val($("#duration"+data.subjectId).val().replace(/[^0-9\.]/g,''));
    var duration = $("#duration"+data.subjectId).val();
    var examTime = $('#startTime'+data.subjectId).val();
    var convertTime = moment(examTime, ["h:mm A"]).format("HH:mm");
      if(this.formValidator.validateIsDataForNumber(examTime)){
        var examDurationInt = parseInt(duration);
        if(duration.trim() != '' && isNaN(examDurationInt) == false && examDurationInt >= 10){
          var time = convertTime.split(':');
          var m = momentJs();
          m.hours(time[0]);
          m.minutes(time[1]);
          m.minutes(m.minutes() + examDurationInt);
          $('#endTime'+data.subjectId).val(m.format('h:mm A'))
        }
      }
  }
  /*MARKS BIFURCATION START*/
  bifurcation = {
    bifurcationName:"",bifurcationType:"MARKS",bifurcationSection:[{sectionName:"",marks:"",minMarks:"",select:false,criteria:""}]
  };
  addRowInConfigBifurcation(){
    this.bifurcation.bifurcationSection.push({
      sectionName:"",marks:"",minMarks:"",select:false,criteria:""
    })
  }
  removeRowInConfigBifurcation(i) {
    this.bifurcation.bifurcationSection.splice(i,1);
  }
  validateMarks(marksData){
    marksData.marks = marksData.marks.replace(/[^0-9\.]/g,'');
  }
  validateMarksEdit(marksData){
  marksData.BifurcationMarksOrPercentage = marksData.BifurcationMarksOrPercentage.replace(/[^0-9\.]/g,'');
 }
  async validateMinMarks(marksData){
    marksData.minMarks = marksData.minMarks.replace(/[^0-9\.]/g,'');
    if(marksData.marks){
      if(parseInt(marksData.minMarks) > parseInt(marksData.marks)){
        if(this.bifurcation.bifurcationType == 'MARKS'){
          const passingMarksShouldNotBeGreaterThenTotalMarksTranslation = await firstValueFrom(this.translate.get('passingMarksShouldNotBeGreaterThenTotalMarks')); 
          customToastr(passingMarksShouldNotBeGreaterThenTotalMarksTranslation, 'error');
          marksData.minMarks = "";
          return;
        }
        else {
          const passingPercentageShouldNotBeGreaterThenTotalPercentageTranslation = await firstValueFrom(this.translate.get('passingPercentageShouldNotBeGreaterThenTotalPercentage')); 
          customToastr(passingPercentageShouldNotBeGreaterThenTotalPercentageTranslation, 'error');
          marksData.minMarks = "";
          return;
        }
      }
    }
    else {
      if(this.bifurcation.bifurcationType == 'MARKS'){
        const pleaseEnterMarksFirstTranslation = await firstValueFrom(this.translate.get('pleaseEnterMarksFirst')); 
        customToastr(pleaseEnterMarksFirstTranslation, 'error');
        marksData.minMarks = "";
        return;
      }
      else {
        const pleaseEnterPercentageFirstTranslation = await firstValueFrom(this.translate.get('pleaseEnterPercentageFirst')); 
        customToastr(pleaseEnterPercentageFirstTranslation, 'error');
        marksData.minMarks = "";
        return;
      }
    }
  }
  async validateMinMarksEdit(marksData){
    marksData.MinPassMarks = marksData.MinPassMarks.replace(/[^0-9\.]/g,'');
    if(marksData.BifurcationMarksOrPercentage){
      if(parseInt(marksData.MinPassMarks) > parseInt(marksData.BifurcationMarksOrPercentage)){
        if(this.selectedBifurcationType == 'MARKS'){
          const passingMarksShouldNotBeGreaterThenTotalMarksTranslation = await firstValueFrom(this.translate.get('passingMarksShouldNotBeGreaterThenTotalMarks')); 
          customToastr(passingMarksShouldNotBeGreaterThenTotalMarksTranslation, 'error');
          marksData.MinPassMarks = "";
          return;
        }
        else {
          const passingPercentageShouldNotBeGreaterThenTotalPercentageTranslation = await firstValueFrom(this.translate.get('passingPercentageShouldNotBeGreaterThenTotalPercentage')); 
          customToastr(passingPercentageShouldNotBeGreaterThenTotalPercentageTranslation, 'error');
          marksData.MinPassMarks = "";
          return;
        }
      }
    }
    else {
      if(this.selectedBifurcationType == 'MARKS'){
        const pleaseEnterMarksFirstTranslation = await firstValueFrom(this.translate.get('pleaseEnterMarksFirst')); 
        customToastr(pleaseEnterMarksFirstTranslation, 'error');
        marksData.MinPassMarks = "";
        return;
      }
      else {
        const pleaseEnterPercentageFirstTranslation = await firstValueFrom(this.translate.get('pleaseEnterPercentageFirst')); 
        customToastr(pleaseEnterPercentageFirstTranslation, 'error');
        marksData.MinPassMarks = "";
        return;
      }
    }
  }
  async configMarksBifurcation(){
    if(!this.formValidator.validateIsDataForNumber(this.bifurcation.bifurcationName)){
      const pleaseEnterBifurcationNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterBifurcationName')); 
      customToastr(pleaseEnterBifurcationNameTranslation, 'error');
      return;
    }
    let total_percent = 0;
    for(var i=0; i<this.bifurcation.bifurcationSection.length; i++){
      if(!this.formValidator.validateIsDataForNumber(this.bifurcation.bifurcationSection[i].sectionName)){
        const pleaseEnterBifurcationSectionNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterBifurcationSectionName')); 
        customToastr(pleaseEnterBifurcationSectionNameTranslation, 'error');
        return;
      }
      if(this.bifurcation.bifurcationType == 'PERCENTAGE'){
        if(!this.formValidator.validateIsDataForNumber(this.bifurcation.bifurcationSection[i].marks)){
          const pleaseEnterBifurcationPercentageTranslation = await firstValueFrom(this.translate.get('pleaseEnterBifurcationPercentage')); 
          customToastr(pleaseEnterBifurcationPercentageTranslation, 'error');
          return;
        }
        else {
          total_percent += parseInt(this.bifurcation.bifurcationSection[i].marks);
        }
      }
      else {
        if(!this.formValidator.validateIsDataForNumber(this.bifurcation.bifurcationSection[i].marks)){
          const pleaseEnterBifurcationMarksTranslation = await firstValueFrom(this.translate.get('pleaseEnterBifurcationMarks')); 
          customToastr(pleaseEnterBifurcationMarksTranslation, 'error');
          return;
        }
      }
      if(!this.bifurcation.bifurcationSection[i].minMarks){
        this.bifurcation.bifurcationSection[i].minMarks = null;
      }
      if(this.bifurcation.bifurcationSection[i].select){
        this.bifurcation.bifurcationSection[i].criteria = "1";
        if(!this.formValidator.validateIsDataForNumber(this.bifurcation.bifurcationSection[i].minMarks)){
          const pleaseEnterMinimumMarksInSelectedFieldTranslation = await firstValueFrom(this.translate.get('pleaseEnterMinimumMarksInSelectedField')); 
          customToastr(pleaseEnterMinimumMarksInSelectedFieldTranslation, 'error');
          return;
        }
      }
      else {
        this.bifurcation.bifurcationSection[i].criteria = "0";
      }
    }
    if(this.bifurcation.bifurcationType == 'PERCENTAGE'){
      if (total_percent != 100){
        const totalPercentShouldBe100Translation = await firstValueFrom(this.translate.get('totalPercentShouldBe100')); 
        customToastr(totalPercentShouldBe100Translation, 'error');
        return;
      }
    }
    $("#configBifurcationButton").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#configBifurcationButton").text(translatedText); });
    $("#configBifurcationCloseButton").attr("disabled",true);
    this.examService.createMarksBifurcationConfigService(this.bifurcation, this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          $("#configBifurcationButton").attr("disabled",false);
          this.translate.get('configure').subscribe((translatedText: string) => { $("#configBifurcationButton").text(translatedText); });
          $("#configBifurcationCloseButton").attr("disabled",false);
          if(data.status == true){
            const marksBifurcationConfiguredSuccessfullyTranslation = await firstValueFrom(this.translate.get('marksBifurcationConfiguredSuccessfully')); 
            customToastr(marksBifurcationConfiguredSuccessfullyTranslation, 'success');
            $("#configBifurcationCloseButton").trigger("click");
            this.marksBifurcationList();
          }
          else if(data.status == false){
           const marksBifurcationIsAlreadyExistPleaseEnterOtherNameTranslation = await firstValueFrom(this.translate.get('marksBifurcationIsAlreadyExistPleaseEnterOtherName'));
           customToastr(marksBifurcationIsAlreadyExistPleaseEnterOtherNameTranslation, 'error');
          }
          else {
            const marksBifurcationIsNotConfiguredPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('marksBifurcationIsNotConfiguredPleaseTryAgain')); 
            customToastr(marksBifurcationIsNotConfiguredPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          $("#configBifurcationButton").attr("disabled",false);
          this.translate.get('configure').subscribe((translatedText: string) => { $("#configBifurcationButton").text(translatedText); });
          $("#configBifurcationCloseButton").attr("disabled",false);
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  async updateMarksBifurcation(){
    if(!this.formValidator.validateIsDataForNumber(this.selectedBifurcationName)){
      const pleaseEnterBifurcationNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterBifurcationName'));
       customToastr(pleaseEnterBifurcationNameTranslation, 'error');
      return;
    }

    for(let i=0; i< this.bifurcationDetailArray.length; i++){

      if(!this.formValidator.validateIsDataForNumber(this.bifurcationDetailArray[i].SectionName)){
        const pleaseEnterSectionNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterSectionName')); 
        customToastr(pleaseEnterSectionNameTranslation, 'error');
        return;
      }
      if(!this.formValidator.validateIsDataForNumber(this.bifurcationDetailArray[i].BifurcationMarksOrPercentage)){
        const pleaseEnterMinNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterMinName')); 
        customToastr(pleaseEnterMinNameTranslation, 'error');
        return;
      }
    }

    let data = {
      updateBirFurcationname:this.selectedBifurcationName,
      updateSectionName:this.bifurcationDetailArray
    }
    $("#editconfigBifurcationButton").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#editconfigBifurcationButton").text(translatedText); });
    $("#editconfigBifurcationButtonClose").attr("disabled",true);
    this.examService.updateMarksBifurcationConfigService(data,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          $("#editconfigBifurcationButton").attr("disabled",false);
          this.translate.get('configure').subscribe((translatedText: string) => { $("#editconfigBifurcationButton").text(translatedText); });
          $("#editconfigBifurcationButtonClose").attr("disabled",false);
          if(data.status == true){
            const marksBifurcationUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('marksBifurcationUpdatedSuccessfully')); 
            customToastr(marksBifurcationUpdatedSuccessfullyTranslation, 'success');
            $("#editconfigBifurcationButtonClose").trigger("click");
            this.marksBifurcationList();
          }
          else if(data.status == false){
            const marksBifurcationIsAlreadyExistPleaseEnterOtherNameTranslation = await firstValueFrom(this.translate.get('marksBifurcationIsAlreadyExistPleaseEnterOtherName')); 
            customToastr(marksBifurcationIsAlreadyExistPleaseEnterOtherNameTranslation, 'error');
          }
          else {
            const marksBifurcationIsNotConfiguredPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('marksBifurcationIsNotConfiguredPleaseTryAgain')); 
            customToastr(marksBifurcationIsNotConfiguredPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          $("#editconfigBifurcationButton").attr("disabled",false);
          this.translate.get('update').subscribe((translatedText: string) => { $("#editconfigBifurcationButton").text(translatedText); });
          $("#editconfigBifurcationButtonClose").attr("disabled",false);
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  clearBifurcation(){
    this.bifurcation = {
      bifurcationName:"",bifurcationType:"MARKS",bifurcationSection:[{sectionName:"",marks:"",minMarks:"",select:false,criteria:""}]
    };
  }
  marksBifurcationListArray = [];
  marksStatus = false;
  marksDataStatus = false;
  marksListDataStatus = false;
  marksBifurcationList(){
    this.marksStatus = true;
    this.marksDataStatus = false;
    this.marksListDataStatus = false;
    this.marksBifurcationListArray = [];
    this.destroyDataTable('marksBifurcationListTable');
    this.examService.marksBifurcationListService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.marksStatus = false;
          this.marksBifurcationListArray = data;
          if(this.marksBifurcationListArray.length == 0){
            this.marksDataStatus = true;
            this.marksListDataStatus = false;
          }
          else {
            this.marksDataStatus = false;
            this.marksListDataStatus = true;
            this.initializeDataTableOrder('marksBifurcationListTable');
          }
        },
        async error =>{
          this.marksStatus = false;
          this.marksDataStatus = false;
          this.marksListDataStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  bifurcationDetailArray = [];
  selectedBifurcationName = "";
  selectedBifurcationType = "";
  marksBifurcationDetails(bifurcationDetail){
    this.bifurcationDetailArray = [];
    this.selectedBifurcationType = bifurcationDetail.BifurcationType;
    this.selectedBifurcationName = bifurcationDetail.MarksBifurcationName;
    this.examService.marksBifurcationDetailsByIdService(bifurcationDetail.pkMarksBifurcationId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.bifurcationDetailArray = data;
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  marksBifurcationDetailsForSchedule(bifurcationId){
    this.bifurcationDetailArray = [];
    this.examService.marksBifurcationDetailsByIdService(bifurcationId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.bifurcationDetailArray = data;
          this.selectedBifurcationType = data[0].BifurcationType;
          this.selectedBifurcationName = data[0].MarksBifurcationName;
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError'));
           customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  selectedBifurcationNameForDelete = "";
  selectedBifurcationIdForDelete;
  deleteMarksBifurcation(bifurcationDetail){
    this.selectedBifurcationNameForDelete = bifurcationDetail.MarksBifurcationName;
    this.selectedBifurcationIdForDelete = bifurcationDetail.pkMarksBifurcationId;
  }
  removeMarksBifurcationConfig(){
    $("#deletemarksButton").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#deletemarksButton").text(translatedText); });
    $("#cancelDeletemarksButton").attr("disabled",true);
    this.examService.removeMarksBifurcationConfigService(this.selectedBifurcationIdForDelete,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          $("#deletemarksButton").attr("disabled",false);
          this.translate.get('confirm').subscribe((translatedText: string) => { $("#deletemarksButton").text(translatedText); });
          $("#cancelDeletemarksButton").attr("disabled",false);
          if(data.status == true){
           const marksBifurcationConfigurationSuccessfullyDeletedTranslation = await firstValueFrom(this.translate.get('marksBifurcationConfigurationSuccessfullyDeleted')); 
           customToastr(marksBifurcationConfigurationSuccessfullyDeletedTranslation, 'success');
            $("#cancelDeletemarksButton").trigger("click");
            this.marksBifurcationList();
          }
          else {
           const marksBifurcationConfigurationNotDeletedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('marksBifurcationConfigurationNotDeletedPleaseTryAgain')); 
           customToastr(marksBifurcationConfigurationNotDeletedPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          $("#deletemarksButton").attr("disabled",false);
          this.translate.get('confirm').subscribe((translatedText: string) => { $("#deletemarksButton").text(translatedText); });
          $("#cancelDeletemarksButton").attr("disabled",false);
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  /*MARKS BIFURACATION END*/
  /*EXAM SETTING PART END*/
  /*SCHOLASTIC MARKS ENTRY START*/
  selectedExamName = "";
  selectedClassAndSection = "";
  selectedClassSectionIdForScholastic;
  viewScholasticDetails(data){
    this.selectedExamName = data.ExamName;
    this.selectedClassAndSection = data.classNumber+' - '+data.classDivision;
    this.selectedClassSectionIdForScholastic = data.classId;
  }
  studentScholResult = false;
  studentscholResultStatus = false;
  coScholasticList = [];
  selectedScholasticConfigName = "";
  coScholasticData = false;
  scholasticEntryStatus = false;
  subjectEntryStatus = false;
  scholasticLanguageType = "";
  getScholasticType = "";
  ExamIdForScholastic;
  getExamIdForScholasticResult;
  scholasticMarksOffcanvas(data){
    this.getScholasticType = data.ScholasticType;
    this.ExamIdForScholastic = data.ExamIdForScholastic;
    this.coScholasticList = [];
    this.studentResult = false;
    this.scholasticEntryStatus = true;
    this.subjectEntryStatus = false;
    this.studentSemResult = false;
    this.scholasticLanguageType = data.IsLanguage;
    $(".subject").removeClass('subject');
    $("#scholastic"+data.pkScholasticConfigurationId).addClass('subject');
    $("#scholasticSem"+data.pkScholasticConfigurationId).addClass('subject');
    $("#coscholasticShow"+data.pkScholasticConfigurationId).addClass('subject');
    $("#scholasticShow"+data.pkScholasticConfigurationId).addClass('subject');
    this.selectedScholasticConfigName = data.ScholasticConfigurationName;
    this.selectedField = data.ScholasticConfigurationName;
    var ExamId = this.selectedExamIdForResult;
    this.getExamIdForScholasticResult = this.selectedExamIdForResult;
    var ScholasticId = data.pkScholasticConfigurationId;
    this.examService.getCoScholasticByScholasticAndExamService(data.pkExamId,data.pkScholasticConfigurationId,data.IsLanguage,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.coScholasticData = true;
          this.coScholasticList = data;
          this.coScholasticList[0].clicked = true;
          if(this.scholasticLanguageType == 'YES'){
            this.coScholasticList[0].otherDetails[0].clicked = true;
            var pkCoScholasticConfigurationId = this.coScholasticList[0].otherDetails[0].pkCoScholasticConfigurationId;
            var EvaluationType = this.coScholasticList[0].otherDetails[0].EvaluationType;
            var gradeNameId = this.coScholasticList[0].otherDetails[0].fkScholasticGradeNameId;
            var scholasticSubjectId = this.coScholasticList[0].pkScholasticSubjectId;
          }
          else {
            pkCoScholasticConfigurationId = this.coScholasticList[0].pkCoScholasticConfigurationId;
            EvaluationType = this.coScholasticList[0].EvaluationType;
            gradeNameId = this.coScholasticList[0].fkScholasticGradeNameId;
          }
          var resultData = {
            pkExamId:ExamId,
            pkScholasticConfigurationId: ScholasticId,
            pkCoScholasticConfigurationId:pkCoScholasticConfigurationId,
            EvaluationType:EvaluationType,
            fkScholasticGradeNameId:gradeNameId,
            fkSubjectId:this.coScholasticList[0].subjectId,
            pkScholasticSubjectId: scholasticSubjectId
          };
          if(this.getScholasticType){
            this.scholasticSemesterMarksEntry(resultData);
          }
          else {
            this.getStudentListByCoScholastic(resultData);
          }

        },
        async error =>{
          this.coScholasticData = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  studentListForScholasticResult = [];
  scholasticSkillsList = [];
  coScholasticName = "";
  scholasticGradeList = [];
  scholasticEvalType = "";
  scholasticSubjectId;
  getStudentListByCoScholastic(CoSchol){
    this.scholasticGradeList = [];
    this.studentListForScholasticResult = [];
    this.scholasticSkillsList = [];
    this.studentscholResultStatus = true;
    this.studentSemResultStatus = true;
    this.studentScholResult = false;
    this.studentResultStatus = true;
    this.scholasticEvalType = CoSchol.EvaluationType;
    let examId;
    if(CoSchol.pkExamId){
      examId = CoSchol.pkExamId;
    }
    else {
      examId = this.getExamIdForScholasticResult;
    }
    $(".subject").removeClass('subject');
    $("#scholastic"+CoSchol.pkScholasticConfigurationId).addClass('subject');
    $("#scholasticSem"+CoSchol.pkScholasticConfigurationId).addClass('subject');
    $("#scholasticShow"+CoSchol.pkScholasticConfigurationId).addClass('subject');
    $("#coscholastic"+CoSchol.pkCoScholasticConfigurationId).addClass('subject');
    $("#coscholasticSem"+CoSchol.pkCoScholasticConfigurationId).addClass('subject');
    $("#coscholasticShow"+CoSchol.pkCoScholasticConfigurationId).addClass('subject');
    $("#scholasticSubject"+CoSchol.fkSubjectId).addClass('subject');
    $("#scholasticSubjectSem"+CoSchol.fkSubjectId).addClass('subject');
    $("#scholasticSubjectShow"+CoSchol.fkSubjectId).addClass('subject');
    $("#subCoScholastic"+CoSchol.fkSubjectId+'_'+CoSchol.pkCoScholasticConfigurationId).addClass('subject');
    $("#subCoScholasticShow"+CoSchol.fkSubjectId+'_'+CoSchol.pkCoScholasticConfigurationId).addClass('subject');
    $("#subCoScholasticSem"+CoSchol.fkSubjectId+'_'+CoSchol.pkCoScholasticConfigurationId).addClass('subject');
    this.coScholasticName = CoSchol.CoScholasticConfigurationName;
    var fkScholasticGradeNameId = CoSchol.fkScholasticGradeNameId;
    if(this.scholasticEvalType == 'GRADE'){
      this.examService.getScholasticGradeService(fkScholasticGradeNameId,this.academicInfo.current_academic,this.getAuthToken)
        .subscribe(
          (data: any) =>{
            this.scholasticGradeList = data;
          }
        );
    }
    if(CoSchol.pkScholasticSubjectId){
      this.scholasticSubjectId = CoSchol.pkScholasticSubjectId;
    }
    else {
      this.scholasticSubjectId = null;
    }
    this.examService.studentScholasticResultListService(examId,this.selectedClassIdForResult,CoSchol.pkScholasticConfigurationId,CoSchol.pkCoScholasticConfigurationId,this.scholasticEvalType,this.scholasticSubjectId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.studentSemResultStatus = false;
          this.studentResultStatus = false;
          this.studentscholResultStatus = false;
          this.studentScholResult = true;
          this.studentListForScholasticResult = data;
          this.scholasticSkillsList = data[0].otherDetails;
          this.coScholasticName = data[0].CoScholasticConfigurationName;
        },
        async error =>{
          this.studentSemResultStatus = false;
          this.studentResultStatus = false;
          this.studentscholResultStatus = false;
          this.studentScholResult = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  studentListForScholasticResultWithMultipleExam = [];
  scholasticGradeListForhMultipleExam = [];
  scholasticEvalTypeForMultipleExam = "";
  getStudentListByCoScholasticWithMultipleExam(CoScholMultipleExam){
    this.scholasticEvalTypeForMultipleExam = CoScholMultipleExam.EvaluationType;

    $(".subject").removeClass('subject');
    $("#scholastic"+CoScholMultipleExam.pkScholasticConfigurationId).addClass('subject');
    $("#scholasticSem"+CoScholMultipleExam.pkScholasticConfigurationId).addClass('subject');
    $("#scholasticShow"+CoScholMultipleExam.pkScholasticConfigurationId).addClass('subject');
    $("#coscholastic"+CoScholMultipleExam.pkCoScholasticConfigurationId).addClass('subject');
    $("#coscholasticSem"+CoScholMultipleExam.pkCoScholasticConfigurationId).addClass('subject');
    $("#coscholasticShow"+CoScholMultipleExam.pkCoScholasticConfigurationId).addClass('subject');
    $("#scholasticSubject"+CoScholMultipleExam.fkSubjectId).addClass('subject');
    $("#scholasticSubjectSem"+CoScholMultipleExam.fkSubjectId).addClass('subject');
    $("#scholasticSubjectShow"+CoScholMultipleExam.fkSubjectId).addClass('subject');
    $("#subCoScholastic"+CoScholMultipleExam.fkSubjectId+'_'+CoScholMultipleExam.pkCoScholasticConfigurationId).addClass('subject');
    $("#subCoScholasticShow"+CoScholMultipleExam.fkSubjectId+'_'+CoScholMultipleExam.pkCoScholasticConfigurationId).addClass('subject');
    $("#subCoScholasticSem"+CoScholMultipleExam.fkSubjectId+'_'+CoScholMultipleExam.pkCoScholasticConfigurationId).addClass('subject');
    var fkScholasticGradeNameId = CoScholMultipleExam.fkScholasticGradeNameId;
    if(this.scholasticEvalTypeForMultipleExam == 'GRADE'){
      this.examService.getScholasticGradeService(fkScholasticGradeNameId,this.academicInfo.current_academic,this.getAuthToken)
        .subscribe(
          (data: any) =>{
            this.scholasticGradeListForhMultipleExam = data;
          }
        );
    }
  }

  onlyShowMarks = false;
  semMarksEntry = false;
  scholasticSemesterMarksEntry(data){

    this.studentscholResultStatus = true;
    this.studentScholResult = false;
    this.studentResultStatus = true;
    this.scholasticEvalType = data.EvaluationType;
    this.getExamIdForScholasticResult = this.ExamIdForScholastic;
    $(".subject").removeClass('subject');
    $("#scholastic"+data.pkScholasticConfigurationId).addClass('subject');
    $("#scholasticSem"+data.pkScholasticConfigurationId).addClass('subject');
    $("#scholasticShow"+data.pkScholasticConfigurationId).addClass('subject');
    $("#scholasticSubject"+data.fkSubjectId).addClass('subject');
    $("#scholasticSubjectSem"+data.fkSubjectId).addClass('subject');
    $("#scholasticSubjectShow"+data.fkSubjectId).addClass('subject');
    $("#subCoScholasticSem"+data.fkSubjectId+'_'+data.pkCoScholasticConfigurationId).addClass('subject');
    if(this.getScholasticType == 'OLD'){
      let scholasticData = {
        pkExamId:this.ExamIdForScholastic,
        pkScholasticConfigurationId:data.pkScholasticConfigurationId,
        pkCoScholasticConfigurationId:data.pkCoScholasticConfigurationId,
        pkScholasticSubjectId:data.pkScholasticSubjectId,
        EvaluationType:data.EvaluationType,
        fkScholasticGradeNameId:data.fkScholasticGradeNameId,
        fkSubjectId:data.fkSubjectId,
      };

      this.onlyShowMarks = true;
      this.semMarksEntry = false;
      this.getStudentListByCoScholastic(scholasticData);
    }
    else if(this.getScholasticType == 'FOR_ALL_EXAM'){
      let scholasticDataForAllExam = {
        pkScholasticConfigurationId:data.pkScholasticConfigurationId,
        pkCoScholasticConfigurationId:data.pkCoScholasticConfigurationId,
        pkScholasticSubjectId:data.pkScholasticSubjectId,
        EvaluationType:data.EvaluationType,
        fkScholasticGradeNameId:data.fkScholasticGradeNameId,
        fkSubjectId:data.fkSubjectId,
        examSemesterId:this.semIdForSemResult
      };
      this.onlyShowMarks = true;
      this.semMarksEntry = false;
      this.getStudentListByCoScholasticWithMultipleExam(scholasticDataForAllExam)

    }
    else {
      this.onlyShowMarks = false;
      this.semMarksEntry = true;
      this.studentSemResultStatus = true;
      var fkScholasticGradeNameId = data.fkScholasticGradeNameId;
      if(data.pkScholasticSubjectId){
        this.scholasticSubjectId = data.pkScholasticSubjectId;
      }
      else {
        this.scholasticSubjectId = null;
      }
      this.examService.studentSemesterScholasticResultListService(this.semIdForSemResult,this.selectedClassIdForResult,data.pkScholasticConfigurationId,data.pkCoScholasticConfigurationId,this.scholasticEvalType,this.scholasticSubjectId,this.academicInfo.current_academic,this.getAuthToken)
        .subscribe(
          (data: any) =>{
            this.studentSemResultStatus = false;
            this.studentResultStatus = false;
            this.studentscholResultStatus = false;
            this.studentScholResult = true;
            this.studentListForScholasticResult = data;
            this.scholasticSkillsList = data[0].otherDetails;
            this.coScholasticName = data[0].CoScholasticConfigurationName;
            if(this.scholasticEvalType == 'GRADE'){
              this.examService.getScholasticGradeService(fkScholasticGradeNameId,this.academicInfo.current_academic,this.getAuthToken)
                .subscribe(
                  (data: any) =>{
                    this.scholasticGradeList = data;
                  }
                );
            }
          },
          async error =>{
            this.studentSemResultStatus = false;
            this.studentResultStatus = false;
            this.studentscholResultStatus = false;
            this.studentScholResult = false;
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          }
        );
    }
    /*this.examService.getStudentListForScholasticLanguageMarksEntryService(data.pkExamId,this.selectedClassIdForResult,data.pkScholasticConfigurationId,data.fkSubjectId,this.authToken)
      .subscribe(
        (data: any) =>{
          this.studentResultStatus = false;
          this.studentscholResultStatus = false;
          this.studentScholResult = true;
          this.studentListForScholasticResult = data;
        },
        error =>{
          this.studentResultStatus = false;
          this.studentscholResultStatus = false;
          this.studentScholResult = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); customToastr(internalServerErrorTranslation, 'error');
        }
      );*/
  }
  enterStudentScholasticResult(){
    var scholasticMarksDataForInsert = [];
    var scholasticMarksDataForUpdate = [];
    for(var i=0; i<this.studentListForScholasticResult.length; i++){
      for(var j=0; j<this.studentListForScholasticResult[i].otherDetails.length; j++){
        if(this.scholasticEvalType == 'MARKS'){
          var studentMarks = $("#scholasMarks"+this.studentListForScholasticResult[i].studentId+'_'+this.studentListForScholasticResult[i].otherDetails[j].pkScholasticSkillsId).val();
          //studentMarks = $("#scholasMarksSem"+this.studentListForScholasticResult[i].studentId+'_'+this.studentListForScholasticResult[i].otherDetails[j].pkScholasticSkillsId).val();
        }
        else {
          studentMarks = $("#scholasGrade"+this.studentListForScholasticResult[i].studentId+'_'+this.studentListForScholasticResult[i].otherDetails[j].pkScholasticSkillsId).val();
          //studentMarks = $("#scholasGradeSem"+this.studentListForScholasticResult[i].studentId+'_'+this.studentListForScholasticResult[i].otherDetails[j].pkScholasticSkillsId).val();
        }
        if(this.studentListForScholasticResult[i].otherDetails[j].pkScholasticExamResultId){
          scholasticMarksDataForUpdate.push({pkScholasticExamResultId:this.studentListForScholasticResult[i].otherDetails[j].pkScholasticExamResultId,
            studentId:this.studentListForScholasticResult[i].studentId,
            classId:this.selectedClassIdForResult,ExamId:this.selectedExamIdForResult,
            scholasticConfigurationId:this.studentListForScholasticResult[i].pkScholasticConfigurationId,
            CoScholasticConfigurationId:this.studentListForScholasticResult[i].pkCoScholasticConfigurationId,
            scholasticSkillsId:this.studentListForScholasticResult[i].otherDetails[j].pkScholasticSkillsId,
            scholasticSubjectId:this.scholasticSubjectId,
            ScholasticMarksOrGrade:studentMarks,ResultEntryType:this.scholasticEvalType})
        }
        else {
          scholasticMarksDataForInsert.push({pkScholasticExamResultId:this.studentListForScholasticResult[i].otherDetails[j].pkScholasticExamResultId,
            studentId:this.studentListForScholasticResult[i].studentId,
            classId:this.selectedClassIdForResult,ExamId:this.selectedExamIdForResult,
            scholasticConfigurationId:this.studentListForScholasticResult[i].pkScholasticConfigurationId,
            CoScholasticConfigurationId:this.studentListForScholasticResult[i].pkCoScholasticConfigurationId,
            scholasticSkillsId:this.studentListForScholasticResult[i].otherDetails[j].pkScholasticSkillsId,
            scholasticSubjectId:this.scholasticSubjectId,
            ScholasticMarksOrGrade:studentMarks,ResultEntryType:this.scholasticEvalType})
        }

      }
    }
    var resultData = {
      studentListForInsert:scholasticMarksDataForInsert,
      studentListForUpdate:scholasticMarksDataForUpdate
    };
    $("#scholasticMarksButton").attr('disabled',true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#scholasticMarksButton").text(translatedText); });
    $("#closeScholasticMarksButton").attr('disabled',true);
    this.examService.insertOrUpdateStudentScholasticMarksService(resultData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          $("#scholasticMarksButton").attr('disabled',false);
          this.translate.get('save').subscribe((translatedText: string) => { $("#scholasticMarksButton").text(translatedText); })
          $("#closeScholasticMarksButton").attr('disabled',false);
          if(data.status == true){
            const scholasticMarksEnteredSuccessfullyTranslation = await firstValueFrom(this.translate.get('scholasticMarksEnteredSuccessfully')); 
            customToastr(scholasticMarksEnteredSuccessfullyTranslation, 'success');
          }
          else {
            const scholasticMarksNotEnteredPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('scholasticMarksNotEnteredPleaseTryAgain')); 
            customToastr(scholasticMarksNotEnteredPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          $("#scholasticMarksButton").attr('disabled',false);
          this.translate.get('save').subscribe((translatedText: string) => { $("#scholasticMarksButton").text(translatedText); })
          $("#closeScholasticMarksButton").attr('disabled',false);
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  /*SEMESTER SCHOLASTIC MARKS ENTRY START*/
  semesterScholasticResultEntry(){
    var scholasticMarksDataForInsert = [];
    var scholasticMarksDataForUpdate = [];
    for(var i=0; i<this.studentListForScholasticResult.length; i++){
      for(var j=0; j<this.studentListForScholasticResult[i].otherDetails.length; j++){
        if(this.scholasticEvalType == 'MARKS'){
          var studentMarks = $("#scholasMarksSem"+this.studentListForScholasticResult[i].studentId+'_'+this.studentListForScholasticResult[i].otherDetails[j].pkScholasticSkillsId).val();
        }
        else {
          studentMarks = $("#scholasGradeSem"+this.studentListForScholasticResult[i].studentId+'_'+this.studentListForScholasticResult[i].otherDetails[j].pkScholasticSkillsId).val();
        }
        if(this.studentListForScholasticResult[i].otherDetails[j].pkSemesterScholasticResultId){
          scholasticMarksDataForUpdate.push({pkSemesterScholasticResultId:this.studentListForScholasticResult[i].otherDetails[j].pkSemesterScholasticResultId,
            studentId:this.studentListForScholasticResult[i].studentId,
            classId:this.classIdForSemResult,semesterExamId:this.semIdForSemResult,
            scholasticConfigurationId:this.studentListForScholasticResult[i].pkScholasticConfigurationId,
            CoScholasticConfigurationId:this.studentListForScholasticResult[i].pkCoScholasticConfigurationId,
            scholasticSkillsId:this.studentListForScholasticResult[i].otherDetails[j].pkScholasticSkillsId,
            scholasticSubjectId:this.scholasticSubjectId,
            ScholasticMarksOrGrade:studentMarks,ResultEntryType:this.scholasticEvalType})
        }
        else {
          scholasticMarksDataForInsert.push({pkSemesterScholasticResultId:this.studentListForScholasticResult[i].otherDetails[j].pkSemesterScholasticResultId,
            studentId:this.studentListForScholasticResult[i].studentId,
            classId:this.classIdForSemResult,semesterExamId:this.semIdForSemResult,
            scholasticConfigurationId:this.studentListForScholasticResult[i].pkScholasticConfigurationId,
            CoScholasticConfigurationId:this.studentListForScholasticResult[i].pkCoScholasticConfigurationId,
            scholasticSkillsId:this.studentListForScholasticResult[i].otherDetails[j].pkScholasticSkillsId,
            scholasticSubjectId:this.scholasticSubjectId,
            ScholasticMarksOrGrade:studentMarks,ResultEntryType:this.scholasticEvalType})
        }

      }
    }
    var resultData = {
      studentListForInsert:scholasticMarksDataForInsert,
      studentListForUpdate:scholasticMarksDataForUpdate
    };
    $("#SemScholasticMarksButton").attr('disabled',true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#SemScholasticMarksButton").text(translatedText); });
    $("#cancelScholasticMarksSemButton").attr('disabled',true);
    this.examService.insertOrUpdateStudentSemesterScholasticResultService(resultData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          $("#SemScholasticMarksButton").attr('disabled',false);
          this.translate.get('save').subscribe((translatedText: string) => { $("#SemScholasticMarksButton").text(translatedText); });
          $("#cancelScholasticMarksSemButton").attr('disabled',false);
          if(data.status == true){
            const scholasticMarksEnteredSuccessfullyTranslation = await firstValueFrom(this.translate.get('scholasticMarksEnteredSuccessfully')); 
            customToastr(scholasticMarksEnteredSuccessfullyTranslation, 'success');
          }
          else {
            const scholasticMarksNotEnteredPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('scholasticMarksNotEnteredPleaseTryAgain')); 
            customToastr(scholasticMarksNotEnteredPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          $("#SemScholasticMarksButton").attr('disabled',false);
          this.translate.get('save').subscribe((translatedText: string) => { $("#SemScholasticMarksButton").text(translatedText); });
          $("#cancelScholasticMarksSemButton").attr('disabled',false);
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  /*SEMESTER SCHOLASTIC MARKS ENTRY END*/
  /*SCHOLASTIC MARKS ENTRY END*/
  /*SEMESTER EXAM CONFIG START*/
  semesterConfig = {
    semesterName:"",ExamBoardId:"",bestOfTwo:"NO",studentPosition:"AVERAGE",classList:[{classId:"", scholasticType:"0",ExamList:[{ExamId:"0",percentage:"",checkClass:false,checkInputMarks:false}]}]
  };
  getExamListForSem = [{ExamId:"0"}];
  getExamList = [];
  addRowInSemExamConfig(){
    for(var i=0; i<this.semesterConfig.classList.length; i++){
      this.semesterConfig.classList[i].ExamList.push({
        ExamId:"0",percentage:"",checkClass:false,checkInputMarks:false
      });
    }
    this.getExamListForSem.push({ExamId:"0"})
  }
  removeRowInSemExamConfig(i){
    //this.semesterConfig.classList[i].ExamList.splice(i,1);
    this.semesterConfig.classList.forEach(function (item) {
      item.ExamList.splice(i,1);
    });
    this.getExamListForSem.splice(i,1);
  }
  getExamIdForSemConfig(getExamId,i){
    this.examForScholasticArray(getExamId);
    this.semesterConfig.classList.forEach(function (item) {
      item.ExamList[i].ExamId = getExamId;
    });
    this.getClassListForSemConfigByExamId(getExamId,i);
  }
  classListForCheckingSemConfig = [];
  scholasticListForCheckSemConfig = [];
  getClassListForSemConfigByExamId(ExamId,i){
    let classIdList = [];
    let scholList = [];
    this.classListForCheckingSemConfig = [];
    this.scholasticListForCheckSemConfig = [];
    this.examService.getClassIdListByExamIdService(this.getExamBoardIdForSemConfig,ExamId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.classListForCheckingSemConfig = data.classList;
          this.scholasticListForCheckSemConfig = data.scholasticList;
          for(let x = 0; x<this.classListForCheckingSemConfig.length; x++){
            classIdList.push(this.classListForCheckingSemConfig[x].fkClassId)
          }
         for(let j=0; j<this.semesterConfig.classList.length; j++){
           if(classIdList.indexOf(this.semesterConfig.classList[j].classId) == -1){
             this.semesterConfig.classList[j].ExamList[i].checkClass = true;
             this.semesterConfig.classList[j].ExamList[i].percentage = null;
           }
           else {
             this.semesterConfig.classList[j].ExamList[i].checkClass = false;
             this.semesterConfig.classList[j].ExamList[i].percentage = "";
           }
         }
         for(let k=0; k<this.scholasticListForCheckSemConfig.length; k++){
           scholList.push(this.scholasticListForCheckSemConfig[k].pkScholasticConfigurationId)
         }
         for(let m = 0; m<this.scholasticConfiguartionList.length; m++){
           if(scholList.indexOf(this.scholasticConfiguartionList[m].pkScholasticConfigurationId) == -1){
             this.scholasticConfiguartionList[m].select = true;
           }
         }
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  async semesterConfigData(){
    var classListForSemConfig = [];
    if(!this.formValidator.validateIsDataForNumber(this.semesterConfig.semesterName)){
      const pleaseEnterSemesterConfigurationNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterSemesterConfigurationName')); 
      customToastr(pleaseEnterSemesterConfigurationNameTranslation, 'error');
      return;
    }
    if(!this.formValidator.validateIsDataForNumber(this.semesterConfig.ExamBoardId)){
      const pleaseProvideExamBoardTranslation = await firstValueFrom(this.translate.get('pleaseProvideExamBoard')); 
      customToastr(pleaseProvideExamBoardTranslation, 'error');
      return;
    }
    for(var i=0; i<this.semesterConfig.classList.length; i++){
      for(var j=0; j<this.semesterConfig.classList[i].ExamList.length; j++){
        if(this.semesterConfig.classList[i].ExamList[j].ExamId == "0"){
          const pleaseProvideExamTranslation = await firstValueFrom(this.translate.get('pleaseProvideExam')); 
          customToastr(pleaseProvideExamTranslation, 'error');
          return;
        }
        if(this.semesterConfig.classList[i].ExamList[j].checkClass == false){
          if(!this.formValidator.validateIsDataForNumber(this.semesterConfig.classList[i].ExamList[j].percentage)){
            const pleaseEnterPercentageTranslation = await firstValueFrom(this.translate.get('pleaseEnterPercentage')); 
            customToastr(pleaseEnterPercentageTranslation, 'error');
            return;
          }
          if(this.semesterConfig.classList[i].scholasticType == '0'){
            const pleaseProvideScholasticTypeTranslation = await firstValueFrom(this.translate.get('pleaseProvideScholasticType')); 
            customToastr(pleaseProvideScholasticTypeTranslation, 'error');
            return;
          }
          if(this.semesterConfig.classList[i].scholasticType == 'NEW' || this.semesterConfig.classList[i].scholasticType == 'NO' || this.semesterConfig.classList[i].scholasticType == 'FOR_ALL_EXAM'){
            classListForSemConfig.push({classId:this.semesterConfig.classList[i].classId,
              ExamId:this.semesterConfig.classList[i].ExamList[j].ExamId,
              percentage:this.semesterConfig.classList[i].ExamList[j].percentage,
              scholasticType:this.semesterConfig.classList[i].scholasticType,
              ExamIdForScholastic:null
            })
          }
          else {
            classListForSemConfig.push({classId:this.semesterConfig.classList[i].classId,
              ExamId:this.semesterConfig.classList[i].ExamList[j].ExamId,
              percentage:this.semesterConfig.classList[i].ExamList[j].percentage,
              scholasticType:'OLD',
              ExamIdForScholastic:this.semesterConfig.classList[i].scholasticType
            })
          }
        }
      }
    }
    var semConfigData = {
      semesterName:this.semesterConfig.semesterName,
      ExamBoardId:this.semesterConfig.ExamBoardId,
      studentPositionBy:this.semesterConfig.studentPosition,
      bestOfTwo:this.semesterConfig.bestOfTwo,
      classList:classListForSemConfig
    };
    $("#semConfigButton").attr('disabled',true);
    $("#semConfigCloseButton").attr('disabled',true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#semConfigButton").text(translatedText); });
    this.examService.createExamSemesterConfigService(semConfigData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          $("#semConfigButton").attr('disabled',false);
          $("#semConfigCloseButton").attr('disabled',false);
          this.translate.get('configure').subscribe((translatedText: string) => { $("#semConfigButton").text(translatedText); });
          if(data.status == true){
            const semesterConfigurationCreatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('semesterConfigurationCreatedSuccessfully')); 
            customToastr(semesterConfigurationCreatedSuccessfullyTranslation, 'success');
            $("#closeSemConfig").trigger("click");
            this.getExamSemesterList();
          }
          else if(data.status == false){
            const semesterConfigurationNameIsAlreadyExistPleaseProvideOtherNameTranslation = await firstValueFrom(this.translate.get('semesterConfigurationNameIsAlreadyExistPleaseProvideOtherName')); 
            customToastr(semesterConfigurationNameIsAlreadyExistPleaseProvideOtherNameTranslation, 'error');
          }
          else {
           const semesterConfigurationNotCreatedSuccessfullyPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('semesterConfigurationNotCreatedSuccessfullyPleaseTryAgain')); 
           customToastr(semesterConfigurationNotCreatedSuccessfullyPleaseTryAgainTranslation, 'error');
          }

        },
        async error =>{
          $("#semConfigButton").attr('disabled',false);
          $("#semConfigCloseButton").attr('disabled',false);
          this.translate.get('configure').subscribe((translatedText: string) => { $("#semConfigButton").text(translatedText); });
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  closeSemConfigButton(){
    $("#closeSemConfig").trigger("click");
  }
  getExamListForSemConfig(boardId){
    this.getExamList = [];
    this.examService.getExternalExamListByBoardService(boardId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          this.getExamList = data;
          if(this.getExamList.length == 0){
            const thereAreNoAnyExamInSelectedBoardTranslation = await firstValueFrom(this.translate.get('thereAreNoAnyExamInSelectedBoard')); 
            customToastr(thereAreNoAnyExamInSelectedBoardTranslation, 'error');
          }
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  coScholasticForSemConfig(scholasticId){
    for(let i=0; i<this.semesterConfig.classList.length; i++){
      this.semesterConfig.classList[i].scholasticType = scholasticId;
    }
  }
  async selectAllPercentClass(data,m){
    let percent = data.percentage;
    if(percent){
      if(data.select){
        for(let i=0; i<this.semesterConfig.classList.length; i++){
          this.semesterConfig.classList[i].ExamList[m].percentage = percent;
        }
      }
    }
    else {
      const pleaseEnterPercentageFirstTranslation = await firstValueFrom(this.translate.get('pleaseEnterPercentageFirst')); 
      customToastr(pleaseEnterPercentageFirstTranslation, 'error');
      data.select = false;
    }
  }
  clearSemData(){
    this.semesterConfig = {
      semesterName:"",ExamBoardId:"",bestOfTwo:"NO",studentPosition:"AVERAGE",classList:[{classId:"",scholasticType:"0",ExamList:[]}]
    };
    this.semDataResult = false;
    this.classListByBoard = [];
    this.getExamList = [];
    this.examBoardArray = [];
    this.examListForStudentPosition = [];
    this.getExamListForSem = [{ExamId:"0"}];
    this.getExamBoardNameList();
    this.offcanvas.handleOffcanvasOpen('#semesterConfiguration');
  }
  async validatePercentage(i,j){
    this.semesterConfig.classList[i].ExamList[j].percentage = this.semesterConfig.classList[i].ExamList[j].percentage.replace(/[^0-9\.]/g,'');
    if(this.semesterConfig.classList[i].ExamList[j].ExamId == "0" || !this.semesterConfig.classList[i].ExamList[j].ExamId){
      const pleaseProvideExamFirstTranslation = await firstValueFrom(this.translate.get('pleaseProvideExamFirst')); 
      customToastr(pleaseProvideExamFirstTranslation, 'error');
      this.semesterConfig.classList[i].ExamList[j].percentage = "";
      return;
    }
    if(parseInt(this.semesterConfig.classList[i].ExamList[j].percentage) > parseInt("100")){
      this.semesterConfig.classList[i].ExamList[j].percentage = "";
      const percentageShouldNotBeGreaterThen100Translation = await firstValueFrom(this.translate.get('percentageShouldNotBeGreaterThen100')); 
      customToastr(percentageShouldNotBeGreaterThen100Translation, 'error');
    }
    this.semesterConfig.classList[i].ExamList[j].checkInputMarks = true;
  }
  semesterList = [];
  reportCardConfigStatus = false;
  reportCardConfigDataStatus = false;
  reportCardListDataStatus = false;
  getExamSemesterList(){
    this.reportCardConfigStatus = true;
    this.reportCardConfigDataStatus = false;
    this.reportCardListDataStatus = false;
    this.semesterList = [];
    this.destroyDataTable('reportCardConfigListTable');
    this.examService.getExamSemesterListService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.reportCardConfigStatus = false;
          this.semesterList = data;
          if(this.semesterList.length == 0){
            this.reportCardConfigDataStatus = true;
            this.reportCardListDataStatus = false;
          }
          else {
            this.reportCardConfigDataStatus = false;
            this.reportCardListDataStatus = true;
            this.initializeDataTableOrder('reportCardConfigListTable');
          }
        },
        async error =>{
          this.reportCardConfigStatus = false;
          this.reportCardConfigDataStatus = false;
          this.reportCardListDataStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  selectedSemesterName = "";
  selectedSemesterDetail = [];
  getExamSemesterDetails(data){
    this.selectedSemesterName = data.ExamSemesterName;
    this.selectedSemesterDetail = [];
    this.examService.getExamSemesterDetailByIdService(data.pkExamSemesterId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.selectedSemesterDetail = data;
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  publishMode = "SCHOOL_CLASS";
  resultPublishMode(mode){
    if(!this.resultPublishDataLevelId){
      this.resultPublishDataLevelId = null;
    }
    var resultPublish = {
      pkResultPublishLevelId:this.resultPublishDataLevelId,
      ResultPublishLevel:mode
    };
    this.examService.addOrUpdateResultPublishLevelService(resultPublish,this.academicInfo.current_academic, this.getAuthToken)
      .subscribe(
        async(data: any) =>{
          if(data.status == true){
            const resultPublishLevelSuccessfullySavedTranslation = await firstValueFrom(this.translate.get('resultPublishLevelSuccessfullySaved')); 
            customToastr(resultPublishLevelSuccessfullySavedTranslation, 'success');
          }
          else {
            const someProblemPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('someProblemPleaseTryAgain')); 
            customToastr(someProblemPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  resultPublishDataLevel = "";
  resultPublishDataLevelId = null;
  fetchResultPublishLevel(){
    this.resultPublishDataLevel = "";
    this.resultPublishDataLevelId = null;
    this.examService.fetchResultPublishLevelService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.resultPublishDataLevelId = data[0].pkResultPublishLevelId;
          this.resultPublishDataLevel = data[0].ResultPublishLevel;
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  semStatus = false;
  semDataResult = false;
  classListByBoard = [];
  getExamBoardIdForSemConfig;
  getClassListByExamBoard(boardId){
    this.semStatus = true;
    this.semDataResult = false;
    this.getExamBoardIdForSemConfig = boardId;
    this.classListByBoard = [];
    this.examService.getClassListByExamBoardService(boardId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.semStatus = false;
          this.semDataResult = true;
          this.classListByBoard = data;
          this.semesterConfig.classList = data;
          this.semesterConfig.classList.forEach(function (item) {
            item.ExamList = [{ExamId:'',percentage:'',checkClass:false,checkInputMarks:false}]
          })
        },
        async error =>{
          this.semStatus = false;
          this.semDataResult = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  semesterListByBoard = [];
  getSemesterId = 0;
  getExamBoardId;
  getSemesterListByBoard(boardId){
    this.destroyDataTable('semesterClassListTable');
    this.getSemesterId = 0;
    this.getExamBoardId = boardId;
    this.semesterListByBoard = [];
    this.examService.getSemesterListByBoardService(boardId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.semesterListByBoard = data;
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  classListForSem = [];
  semResultStatus = false;
  classListForSemDataStatus = false;
  semDataStatus = false;
  async getClassListBySemester(){
    if(this.getExamBoardId == 0){
      const pleaseSelectBoardTranslation = await firstValueFrom(this.translate.get('pleaseSelectBoard')); 
      customToastr(pleaseSelectBoardTranslation, 'error');
      return;
    }
    if(this.getSemesterId == 0){
      const pleaseSelectSemesterTranslation = await firstValueFrom(this.translate.get('pleaseSelectSemester')); 
      customToastr(pleaseSelectSemesterTranslation, 'error');
      return;
    }
    this.classListForSem = [];
    this.semResultStatus = true;
    this.classListForSemDataStatus = false;
    this.semDataStatus = false;
    this.destroyDataTable('semesterClassListTable');
    this.examService.getClassListBySemesterIdService(this.getSemesterId,this.getExamBoardId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.semResultStatus = false;
          
          this.classListForSem = data;
          if(this.classListForSem.length > 0){
            this.classListForSemDataStatus = false;
            this.semDataStatus = true;
            this.initializeDataTableOrder('semesterClassListTable');
          }
          else {
            this.classListForSemDataStatus = true;
            this.semDataStatus = false;
          }
        },
        async error =>{
          this.semResultStatus = false;
          this.classListForSemDataStatus = false;
          this.semDataStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  publishSemClassList = [];
  async getClassListBySemesterPublishedResult(){
    if(this.selectedSchoolExamBoardId == 0){
      const pleaseSelectBoardTranslation = await firstValueFrom(this.translate.get('pleaseSelectBoard')); 
      customToastr(pleaseSelectBoardTranslation, 'error');
      return;
    }
    if(this.getSemesterId == 0){
      const pleaseSelectSemesterTranslation = await firstValueFrom(this.translate.get('pleaseSelectSemester')); 
      customToastr(pleaseSelectSemesterTranslation, 'error');
      return;
    }
    this.publishSemClassList = [];
    this.semResultStatus = true;
    this.classListForSemDataStatus = false;
    this.semDataStatus = false;
    this.destroyDataTable('semesterClassListTableForReport');
    this.examService.getClassListByPublishedSemesterResultService(this.getSemesterId,this.selectedSchoolExamBoardId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.semResultStatus = false;
          this.publishSemClassList = data;
          if(this.publishSemClassList.length > 0){
            this.classListForSemDataStatus = false;
            this.semDataStatus = true;
            this.initializeDataTableOrder('semesterClassListTableForReport');
          }
          else {
            this.classListForSemDataStatus = true;
            this.semDataStatus = false;
          }
        },
        async error =>{
          this.semResultStatus = false;
          this.classListForSemDataStatus = false;
          this.semDataStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  subjectListBySem = [];
  classIdForSemResult;
  semIdForSemResult;
  examBoardIdForSemResult;
  selectedClassSemName = "";
  classNameForSemResult = "";
  scholasticListBySem = [];
  getClassSubjectBySem(data){
    this.subjectListBySem = [];
    this.scholasticListBySem = [];
    this.selectedClassSemName = data.ExamSemesterName;
    this.classNameForSemResult = data.classNumber+' - '+data.classDivision;
    this.classIdForSemResult = data.fkClassId;
    this.selectedClassIdForResult = data.fkClassId;
    this.semIdForSemResult = data.fkExamSemesterId;
    this.examBoardIdForSemResult = data.fkExamBoardId;
    this.getExamGradeConfigByExamBoard(this.examBoardIdForSemResult);
    this.offcanvas.handleOffcanvasOpen('#offcanvasSemesterResult');
    let semesterData = {
      ExamBoardId:this.examBoardIdForSemResult,
      semesterId:this.semIdForSemResult,
      classId:this.classIdForSemResult,
      ExamIdForScholastic:data.ExamIdForScholastic,
      ScholasticType:data.ScholasticType
    };
    this.examService.getSubjectListOfClassBySemIdService(semesterData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.subjectListBySem = data.subjectList;
          this.scholasticListBySem = data.scholasticList;
          let semData = {
            subjectId:this.subjectListBySem[0].subjectId,
            subject:this.subjectListBySem[0].subject,
            editableSubject:this.subjectListBySem[0].editableSubject
          };
          this.getSemesterResultBySubject(semData);
        },
       async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  subjectNameForSemResult = "";
  examListForSem = [];
  studentListForSem = [];
  studentSemResultStatus = false;
  studentSemResult = false;
  textWrappingForSemResult(name){
    if(!name){
      return name;
    }
    else if(name.length > 3){
      return $.trim(name).substring(0,3)+".."
    }else{
      return name;
    }
  }
  evalTypeForSemResult = "";
  semesterExamListArray = [];
  editableSubject = false;
  marksArray = [];
  getSemesterResultBySubject(data){
    this.editableSubject = data.editableSubject;
    this.studentSemResultStatus = true;
    this.studentSemResult = false;
    this.marksType = true;
    this.gradeType = false;
    this.coScholasticData = false;
    this.studentScholResult = false;
    this.examListForSem = [];
    this.studentListForSem = [];
    this.subjectNameForSemResult = data.subject;
    this.semesterExamListArray = [];
    let subjectId = data.subjectId;
    let studentSemesterResultDataForInsert = [];
    let studentSemesterResultDataForUpdate = [];
    $(".subject").removeClass('subject');
    $("#subjectForSem"+data.subjectId).addClass("subject");
    let semesterData = {
      ExamBoardId:this.examBoardIdForSemResult,
      semesterId:this.semIdForSemResult,
      classId:this.classIdForSemResult,
      subjectId:data.subjectId
    };
    this.examService.getSemesterExamResultBySubject(semesterData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this. studentSemResultStatus = false;
          this.studentSemResult = true;
          this.examListForSem = data.ExamList;
          this.studentListForSem = data.semesterResult;
          if(this.studentListForSem.length > 0){
            for(let z=0; z<this.studentListForSem[0].otherDetails.length; z++){
              this.semesterExamListArray.push({ExamId:this.studentListForSem[0].otherDetails[z].fkExamId,ExamName:this.studentListForSem[0].otherDetails[z].ReportCardExamName})
            }
          }
          this.evalTypeForSemResult = this.examListForSem[0].EvaluationType;
          let h = this;
          setTimeout(function () {
            for(let i = 0; i<h.studentListForSem.length; i++){
              let totalMarks = 0;
              let marksArry =[];
              let sortArray = [];
              h.marksArray = [];
              var totalPercentMaxMarks = 0;
              for(let j = 0; j<h.studentListForSem[i].otherDetails.length; j++){
                $("#examMarks"+h.studentListForSem[i].studentId+h.studentListForSem[i].otherDetails[j].fkExamId).text(h.studentListForSem[i].otherDetails[j].studentMarks);
                totalPercentMaxMarks = h.studentListForSem[i].otherDetails[j].totalPercentMaxMarks + totalPercentMaxMarks;
                $("#examPercentage"+h.studentListForSem[i].otherDetails[j].fkExamId).text(h.studentListForSem[i].otherDetails[j].Percentage);
                let percent = h.studentListForSem[i].otherDetails[j].studentMarks*100/h.studentListForSem[i].otherDetails[j].MaxMarks;
                if(h.studentListForSem[i].bestOfTwoAvg == "YES"){
                  marksArry = h.studentListForSem[i].otherDetails[j].totalMarksByPercentage;
                  h.marksArray.push(marksArry);
                  h.marksArray.sort(function (a, b) {
                    return b.totalMarksByPercentage - a.totalMarksByPercentage
                  });
                  let marks1 = 0;
                  marks1 = (parseInt(h.marksArray[0]) + parseInt(h.marksArray[1]))/2;
                  totalMarks = Math.round(marks1)
                }else{
                  totalMarks = h.studentListForSem[i].otherDetails[j].totalMarksByPercentage + totalMarks;

                }
                for(let k=0; k<h.gradeSystemArray.length; k++){
                  if(Math.round(percent) >= h.gradeSystemArray[k].MinMarks && Math.round(percent) <= h.gradeSystemArray[k].MaxMarks){
                    $("#studentSubjectGrade_"+h.studentListForSem[i].studentId+h.studentListForSem[i].otherDetails[j].fkExamId).text(h.gradeSystemArray[k].Grade);
                  }
                }
              }
              if(h.studentListForSem[i].pkSemesterResultId){
                studentSemesterResultDataForUpdate.push({pkSemesterResultId:h.studentListForSem[i].pkSemesterResultId,
                  studentId:h.studentListForSem[i].studentId,ExamBoardId:h.examBoardIdForSemResult,
                  semesterId:h.semIdForSemResult,classId:h.classIdForSemResult,subjectId:subjectId,Marks:Math.round(totalMarks)});
              }
              else {
                studentSemesterResultDataForInsert.push({studentId:h.studentListForSem[i].studentId,ExamBoardId:h.examBoardIdForSemResult,
                  semesterId:h.semIdForSemResult,classId:h.classIdForSemResult,subjectId:subjectId,Marks:Math.round(totalMarks)});
              }
            }
            let semesterResultData = {
              studentSemesterResultDataForUpdate:studentSemesterResultDataForUpdate,
              studentSemesterResultDataForInsert:studentSemesterResultDataForInsert
            };
            let studentResultData = {
              ExamBoardId:h.examBoardIdForSemResult,
              semesterId:h.semIdForSemResult,
              classId:h.classIdForSemResult,
              subjectId:subjectId
            };
            h.examService.studentSemesterResultDataStoreService(semesterResultData,h.academicInfo.current_academic,h.getAuthToken)
              .subscribe(
                (data: any) =>{
                  if(data.status){
                   let studentSemResult = [];
                   h.examService.getStudentSemesterResultService(studentResultData,h.academicInfo.current_academic,h.getAuthToken)
                     .subscribe(
                       (studentList: any) =>{
                         studentSemResult = studentList;
                         for(let x = 0; x<studentSemResult.length; x++){
                           $("#allExamMarks"+studentSemResult[x].fkStudentId).text(studentSemResult[x].Marks);
                           let overAllPercent = studentSemResult[x].Marks*100/totalPercentMaxMarks;
                           for(let m=0; m<h.gradeSystemArray.length; m++){
                             if(Math.round(overAllPercent) >= h.gradeSystemArray[m].MinMarks && Math.round(overAllPercent) <= h.gradeSystemArray[m].MaxMarks){
                               $("#allExamGrade"+studentSemResult[x].fkStudentId).text(h.gradeSystemArray[m].Grade);
                             }
                           }
                         }

                       },
                       error =>{

                       }
                     );
                   h.getClassListBySemester();
                  }
                },
                error =>{

                }
              );
          },50)

        },
       async error =>{
          this. studentSemResultStatus = false;
          this.studentSemResult = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  examScholasticArray = [];
  examListForStudentPosition = [];
  examForScholasticArray(data){
    //this.examScholasticArray = [];
    let examList = [];
    let examPositionList = [];
    for(let k=0; k<this.examScholasticArray.length; k++){
      examList.push(this.examScholasticArray[k].ExamId)
    }
    for(let j=0; j<this.examListForStudentPosition.length; j++){
      examPositionList.push(this.examListForStudentPosition[j].ExamId)
    }
    for(let i=0; i<this.getExamList.length; i++){
      if(this.getExamList[i].pkExamId == data && this.getExamList[i].IsScholasticType == 'YES'){
        if(this.examScholasticArray.length > 0){
          if(examList.indexOf(this.getExamList[i].pkExamId) == -1){
            this.examScholasticArray.push({ExamId:this.getExamList[i].pkExamId,ExamName:this.getExamList[i].ExamName})
          }
        }
       else {
          this.examScholasticArray.push({ExamId:this.getExamList[i].pkExamId,ExamName:this.getExamList[i].ExamName});
        }
      }
      if(this.getExamList[i].pkExamId == data){
        if(this.examListForStudentPosition.length > 0){
          if(examPositionList.indexOf(this.getExamList[i].pkExamId) == -1){
            this.examListForStudentPosition.push({ExamId:this.getExamList[i].pkExamId,ExamName:this.getExamList[i].ExamName})
          }
        }
        else {
          this.examListForStudentPosition.push({ExamId:this.getExamList[i].pkExamId,ExamName:this.getExamList[i].ExamName});
        }
      }
    }
  }

  /*SEMESTER EXAM CONFIG END*/
  classAndSectionList = [];
  checkSave = true;
  scholasticClassStatus = false;
  scholasticClassDataStatus = false;
  fetchClassStandardAndSection(scholasticConfigId){
    this.checkSave = true;
    this.scholasticClassDataStatus = false;
    this.scholasticClassStatus = true;
    this.classAndSectionList = [];
    this.examService.fetchClassStandardAndSectionService(scholasticConfigId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.scholasticClassStatus = false;
          this.scholasticClassDataStatus = true;
          this.classAndSectionList = data;
          for(let i=0; i<this.classAndSectionList.length; i++){
            for(let j=0; j<this.classAndSectionList[i].section.length; j++){
              if(this.classAndSectionList[i].section[j].classScholastic){
                this.checkSave = false;
                this.classAndSectionList[i].select = true;
                $("#completedMapping"+this.selectedScholasticForClassMap).removeClass('hide');
              }
              else {
                this.classAndSectionList[i].select = false;
              }
            }
          }
        },
        async error =>{
          this.scholasticClassStatus = false;
          this.scholasticClassDataStatus = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  selectAllSectionOfClass(sectionList){
    var isSel = $(".className"+sectionList[0].pkClassStandardsId).prop("checked");
    for(var i=0; i<sectionList.length; i++){
      sectionList[i].classScholastic =isSel;
    }

  }
  checkingSelectedClass(){
    var selectList = [];
    for(var i=0; i<this.classAndSectionList.length; i++){
      if(this.classAndSectionList[i].select == true){
        selectList.push({classStd: this.classAndSectionList[i].ClassStandardsId})
        for(let r=0; r<this.classAndSectionList[i].section.length; r++){
          this.classAndSectionList[i].section[r].classScholastic = true;
        }
      }
      else{
        for(let r=0; r<this.classAndSectionList[i].section.length; r++){
          this.classAndSectionList[i].section[r].classScholastic = false;
        }
      }
    }
    if(this.classAndSectionList.length == selectList.length){
      this.allClass = true;
    }
    else {
      this.allClass = false;
    }
  }
  checkingSelectSection(classDetails){
    var selectList = [];
    var selectClassList = [];
    for(var i=0; i<classDetails.length; i++){
      if(classDetails[i].classScholastic == true){
        selectList.push({classStd: classDetails[i].classId})
      }
    }
    if(classDetails.length == selectList.length){
      for(var j=0; j<this.classAndSectionList.length; j++){
        if(this.classAndSectionList[j].ClassStandardsId == classDetails[0].pkClassStandardsId){
          this.classAndSectionList[j].select = true;
        }
        if(this.classAndSectionList[j].select == false){
          this.classAndSectionList[j].select = false;
        }
        else {
          this.classAndSectionList[j].select = true;
        }
        if(this.classAndSectionList[j].select == true){
          selectClassList.push({classStd: this.classAndSectionList[j].ClassStandardsId})
        }
      }
      if(this.classAndSectionList.length == selectClassList.length){
        this.allClass = true;
      }
      else {
        this.allClass = false;
      }
    }
    else {
      for(var j=0; j<this.classAndSectionList.length; j++){
        if(this.classAndSectionList[j].ClassStandardsId == classDetails[0].pkClassStandardsId){
          this.classAndSectionList[j].select = false;
        }
      }
    }
  }

  openBrace = "{";
  closeBrace = "}";
  changeDateFormat(date){
    if(date){
      return moment(date).format("DD/MM/YYYY");
    }
    else {
      return null;
    }
  }
  selectAllClassesForScholastic(){
    var isSel = $("#selectAllClass").prop("checked");
    /*this.classAndSectionList.forEach(function (st) {
     st.select=isSel;
     });*/
    for(var i=0; i<this.classAndSectionList.length; i++){
      for(var j=0; j<this.classAndSectionList[i].section.length; j++){
        this.classAndSectionList[i].section[j].classScholastic = isSel;
        this.classAndSectionList[i].select = isSel;
      }
    }
  }
  selectedScholasticForClassMap;
  scholasticClassLink(data){
    this.selectedScholasticForClassMap = data.pkScholasticConfigurationId;
    this.allClass = false;
    $('.subject').removeClass('subject');
    $('#scholasticForMap'+data.pkScholasticConfigurationId).addClass('subject');
    this.fetchClassStandardAndSection(data.pkScholasticConfigurationId);
  }
  async saveScholasticClasses(){
    var scholasticAndClassList = [];
    for(let i = 0; i<this.classAndSectionList.length; i++){
      for(let j = 0; j<this.classAndSectionList[i].section.length; j++){
        if(this.classAndSectionList[i].section[j].classScholastic && this.classAndSectionList[i].section[j].fkScholasticConfigurationId == null){
          scholasticAndClassList.push({scholasticConfigId:this.selectedScholasticForClassMap,classId:this.classAndSectionList[i].section[j].classId})
        }
      }
    }
    if(scholasticAndClassList.length == 0){
      const pleaseSelectAtleastOneClassTranslation = await firstValueFrom(this.translate.get('pleaseSelectAtleastOneClass')); 
      customToastr(pleaseSelectAtleastOneClassTranslation, 'error');
      return;
    }
    $("#saveScholasticClassButton").attr('disabled',true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#saveScholasticClassButton").text(translatedText); });
    this.examService.mappingScholasticToClassesService(scholasticAndClassList,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          $("#saveScholasticClassButton").attr('disabled',false);
          this.translate.get('save').subscribe((translatedText: string) => { $("#saveScholasticClassButton").text(translatedText); });
          if(data.status){
            const scholasticSuccessfullyMappedWithClassesTranslation = await firstValueFrom(this.translate.get('scholasticSuccessfullyMappedWithClasses')); 
            customToastr(scholasticSuccessfullyMappedWithClassesTranslation, 'success');
            this.checkSave = false;
            $("#completedMapping"+this.selectedScholasticForClassMap).removeClass('hide');
            for(let k = 0; k<this.scholasticConfiguartionList.length; k++){
              if(this.selectedScholasticForClassMap == this.scholasticConfiguartionList[k].pkScholasticConfigurationId){
               this.scholasticConfiguartionList[k].mapped = true;
              }
            }
          }
          else {
            const scholasticIsNotMappedWithClassesPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('scholasticIsNotMappedWithClassesPleaseTryAgain')); 
            customToastr(scholasticIsNotMappedWithClassesPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          $("#saveScholasticClassButton").attr('disabled',false);
          this.translate.get('save').subscribe((translatedText: string) => { $("#saveScholasticClassButton").text(translatedText); });
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  async semesterResultPublish(data){
    if(data.pkSemesterResultStatusId){
      const resultAlreadyPublishedTranslation = await firstValueFrom(this.translate.get('resultAlreadyPublished'));
      customToastr(resultAlreadyPublishedTranslation, 'error');
      return;
    }
    let publishData = {
      ExamSemesterId:data.fkExamSemesterId,
      classId:data.fkClassId,
      ExamBoardId:data.fkExamBoardId
    };
    this.examService.semesterResultPublishService(publishData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          if(data.published && data.message == 'SEM_RESULT_PUBLISHED'){
            const semesterResultPublishedSuccessfullyTranslation = await firstValueFrom(this.translate.get('semesterResultPublishedSuccessfully')); 
            customToastr(semesterResultPublishedSuccessfullyTranslation, 'success');
            this.getClassListBySemester();
          }
          else if(!data.published && data.message == 'ALL_EXAMS_RESULT_NOT_YET_PUBLISHED'){
            const examsResultAreNotYetPublishedPleasePublishExamsResultFirstTranslation = await firstValueFrom(this.translate.get('examsResultAreNotYetPublishedPleasePublishExamsResultFirst')); 
            customToastr(examsResultAreNotYetPublishedPleasePublishExamsResultFirstTranslation, 'error');
          }
          else {
            const resultNotPublishedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('resultNotPublishedPleaseTryAgain')); 
            customToastr(resultNotPublishedPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  closeStudentReportCard(){
    this.offcanvas.handleOffcanvasOpen('#studentListForExamReport');
  }
  toggleClickForExamReport(){
    this.showStudentList = false;
    this.classListForExamReport = true;
    this.getClassListByExamAndBoard();
  }
  studentReportCardDetail: any;// = {subjectDetails:{Bifurcation:[]},EvaluationType:""};
  studentAttendance = {totalPresentDay:0,totalAttendence:0};
  showStudentList = false;
  studentMarksDetails = [];
  sameTableData = false;
  radientDefaultReportCard = false;
  firstDataTableUse = true;
  publishedExamList = [];
  publishedSemList = [];
  getPublishedExamList(boardId){
    if(boardId == 0){
      return;
    }
    else {
      this.publishedExamList = [];
      this.examService.getPublishedExamListService(boardId, this.academicInfo.current_academic, this.getAuthToken)
        .subscribe(
          async (data: any) =>{
            this.publishedExamList = data;
            if(this.publishedExamList.length == 0){
             const thereAreNoAnyPublishedResultTranslation = await firstValueFrom(this.translate.get('thereAreNoAnyPublishedResult')); 
             customToastr(thereAreNoAnyPublishedResultTranslation, 'error');
            }
          },
          async error =>{
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          }
        );
    }
  }

  getPublishedSemesterList(boardId){
    this.getSemesterId = 0;
    if(boardId == 0){
      return;
    }
    else {
      this.publishedSemList = [];
      this.examService.getPublishedSemesterListService(boardId,this.academicInfo.current_academic, this.getAuthToken)
        .subscribe(
          async (data: any) =>{
            this.publishedSemList = data;
            if(this.publishedSemList.length == 0){
              const thereAreNoAnyPublishedResultTranslation = await firstValueFrom(this.translate.get('thereAreNoAnyPublishedResult')); 
              customToastr(thereAreNoAnyPublishedResultTranslation, 'error');
            }
          },
          async error =>{
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          }
        );
    }
  }

  gurukulSchoolHigherClassReportCard = false;
  gurukulSchoolMiddleClassReportCard = false;
  gurukulSchoolPrepClassReportCard = false;
  generalReportCard = true;
  radiantSchoolExamReport = false;
  bifurLen;
  particularExamBifurcation = false;

  studentDetailForReportCard(studentId){
    this.gurukulSchoolHigherClassReportCard = false;
    this.gurukulSchoolMiddleClassReportCard = false;
    this.generalReportCard = false;
    this.gurukulSchoolPrepClassReportCard = false;
    this.radiantSchoolExamReport = false;
    this.particularExamBifurcation = false;
    if(parseInt(this.getSchoolId) == 43 && this.studentClassStdId >= 199 && this.studentClassStdId <= 203){
      this.gurukulSchoolMiddleClassReportCard = true;
    }
    else if(parseInt(this.getSchoolId) == 43 && this.studentClassStdId >= 204 && this.studentClassStdId <= 208) {
      this.gurukulSchoolHigherClassReportCard = true;
    }
    else if(parseInt(this.getSchoolId) == 43 && this.studentClassStdId >= 196 && this.studentClassStdId <= 198){
      this.gurukulSchoolPrepClassReportCard = true;
    }
    else if (parseInt(this.getSchoolId) == 21 || parseInt(this.getSchoolId) == 23) {
      this.radiantSchoolExamReport = true;
    }
    else {
      this.generalReportCard = true;
      //this.radiantSchoolExamReport = true;
    }
    var studentSubjectMarks = [];
    this.examService.studentDetailForReportCardService(this.selectedClassIdForReportCard,studentId,this.selectedExamIdForClass,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.studentReportCardDetail = data.studentResult[0];
          this.studentMarksDetails = data.studentResult;
                 if(this.examBifurcation){
                   if(this.studentReportCardDetail.EvaluationType != 'GRADE' && this.examMarks){
                     if(this.studentReportCardDetail.EvaluationType != 'MARKS' && this.examGrade){
                       if(this.studentReportCardDetail.subjectDetails.Bifurcation[0].fkMarksBifurcationId){
                         this.particularExamBifurcation = true;
                         this.bifurLen = this.studentReportCardDetail.subjectDetails.Bifurcation.length + 2;
                       }
                       else {
                         this.bifurLen = 2;
                         this.particularExamBifurcation = false;
                       }
                     }
                     else {
                       if(this.studentReportCardDetail.subjectDetails.Bifurcation[0].fkMarksBifurcationId){
                         this.particularExamBifurcation = true;
                         this.bifurLen = this.studentReportCardDetail.subjectDetails.Bifurcation.length + 1;
                       }
                       else {
                         this.bifurLen = 1;
                         this.particularExamBifurcation = false;
                       }
                     }
                   }
                   else {
                     if(this.studentReportCardDetail.EvaluationType != 'MARKS' && this.examGrade){
                       this.bifurLen = this.studentReportCardDetail.subjectDetails.Bifurcation.length + 1;
                     }
                     else {
                       this.bifurLen = this.studentReportCardDetail.subjectDetails.Bifurcation.length;
                     }
                   }
                 }
                 else {
                   if(this.studentReportCardDetail.EvaluationType != 'GRADE' && this.examMarks){
                     if(this.studentReportCardDetail.EvaluationType != 'MARKS' && this.examGrade){
                       this.bifurLen = 2;
                     }
                     else {
                       this.bifurLen = 1;
                     }
                   }
                   else {
                     if(this.studentReportCardDetail.EvaluationType != 'MARKS' && this.examGrade){
                       this.bifurLen = 1;
                     }
                     else {
                       this.bifurLen = 0;
                     }
                   }
                 }




          let bifurIdArray = [];
          for(let a=0; a<this.studentMarksDetails.length; a++){
            for(let b=0; b<this.studentMarksDetails[a].subjectDetails.Bifurcation.length; b++){
              bifurIdArray.push(this.studentMarksDetails[a].subjectDetails.Bifurcation[b].fkMarksBifurcationId)
            }
          }
          let newArray = [];
          $.each(bifurIdArray, function(i, el){
            if($.inArray(el, newArray) === -1) newArray.push(el);
          });
          if(newArray.length == 1){
            this.sameTableData = true;
            this.firstDataTableUse = false;
          }
          else {
            this.sameTableData = false;
            this.firstDataTableUse = true;
          }
          this.studentAttendance = data.attendance[0];
          studentSubjectMarks = data.studentResult[0].subjectDetails;
          var h = this;
          setTimeout(function () {
            let subjectMarks = 0;
            let totalMarks = 0;
            let overAllMarks = 0;
            let studentFullMarks = 0;
            for(let m=0; m<h.studentMarksDetails.length; m++){
              let stTotalMarks = 0;
              totalMarks = h.studentMarksDetails[m].MaxMarks;
              overAllMarks += h.studentMarksDetails[m].MaxMarks;
              for(let n=0; n<h.studentMarksDetails[m].subjectDetails.Bifurcation.length; n++){
                stTotalMarks += h.studentMarksDetails[m].subjectDetails.Bifurcation[n].marks;
                subjectMarks += h.studentMarksDetails[m].subjectDetails.Bifurcation[n].marks;
                  $(".headerMarks"+h.studentMarksDetails[m].subjectDetails.Bifurcation[n].subjectId+'_'+h.studentMarksDetails[m].subjectDetails.Bifurcation[n].fkMarksBifurcationId+'_'+h.studentMarksDetails[m].subjectDetails.Bifurcation[n].fkMarksBifurcationConfigurationId).text(h.studentMarksDetails[m].subjectDetails.Bifurcation[n].MaxMarksBifur);
                  $(".headerMarksFirst"+h.studentMarksDetails[m].subjectDetails.Bifurcation[n].subjectId+'_'+h.studentMarksDetails[m].subjectDetails.Bifurcation[n].fkMarksBifurcationId+'_'+h.studentMarksDetails[m].subjectDetails.Bifurcation[n].fkMarksBifurcationConfigurationId).text(h.studentMarksDetails[m].subjectDetails.Bifurcation[n].MaxMarksBifur);
                  $(".stBifMarks"+h.studentMarksDetails[m].subjectDetails.Bifurcation[n].subjectId+'_'+h.studentMarksDetails[m].subjectDetails.Bifurcation[n].fkMarksBifurcationId+'_'+h.studentMarksDetails[m].subjectDetails.Bifurcation[n].fkMarksBifurcationConfigurationId).text(h.studentMarksDetails[m].subjectDetails.Bifurcation[n].marks);
                  $(".stBifMarksFirst"+h.studentMarksDetails[m].subjectDetails.Bifurcation[n].subjectId+'_'+h.studentMarksDetails[m].subjectDetails.Bifurcation[n].fkMarksBifurcationId+'_'+h.studentMarksDetails[m].subjectDetails.Bifurcation[n].fkMarksBifurcationConfigurationId).text(h.studentMarksDetails[m].subjectDetails.Bifurcation[n].marks);
                  $(".subjectTotalMarks").text(h.studentMarksDetails[m].subjectDetails.Bifurcation[n].MaxMarks);
                  $(".subjectTotalMarksFirst"+h.studentMarksDetails[m].subjectDetails.Bifurcation[n].subjectId).text(h.studentMarksDetails[m].subjectDetails.Bifurcation[n].MaxMarks);
              }
              if(h.studentMarksDetails[m].subjectDetails.Bifurcation[0].studentExamAttendance == 'ABSENT'){
                $(".subjectMarks"+h.studentMarksDetails[m].subjectId).text('ABSENT');
                $("#subjectMarks_guru"+h.studentMarksDetails[m].subjectId).text('ABSENT');
                $(".subjectMarksData"+h.studentMarksDetails[m].subjectId).text('ABSENT');
                $("#subjectMarksData_guru"+h.studentMarksDetails[m].subjectId).text('ABSENT');
                $("#guru_lower_marks"+h.studentMarksDetails[m].subjectId).text('ABSENT');
              }
              else {
                //$("#subjectMarks"+h.studentMarksDetails[m].subjectId).text(stTotalMarks);
                $("#subjectMarks_guru"+h.studentMarksDetails[m].subjectId).text(stTotalMarks);
                $("#subjectMarksData_guru"+h.studentMarksDetails[m].subjectId).text(stTotalMarks);
                $("#guru_lower_marks"+h.studentMarksDetails[m].subjectId).text(stTotalMarks);
                studentFullMarks += stTotalMarks;
                $(".subjectMarksData"+h.studentMarksDetails[m].subjectId).text(stTotalMarks);
                $(".subjectMarks"+h.studentMarksDetails[m].subjectId).text(stTotalMarks);

              }
              let percentage = stTotalMarks*100/totalMarks;
              for (let j=0; j<h.gradeSystemArray.length; j++){
                if(Math.round(percentage) >= h.gradeSystemArray[j].MinMarks && Math.round(percentage) <= h.gradeSystemArray[j].MaxMarks){
                  $(".studentMarksGrade"+h.studentMarksDetails[m].subjectId).text(h.gradeSystemArray[j].Grade);
                  $("#studentMarksGrade_guru"+h.studentMarksDetails[m].subjectId).text(h.gradeSystemArray[j].Grade);
                  $(".studentMarksGradeData"+h.studentMarksDetails[m].subjectId).text(h.gradeSystemArray[j].Grade);
                  $("#studentMarksGradeData_guru"+h.studentMarksDetails[m].subjectId).text(h.gradeSystemArray[j].Grade);
                  $("#guru_lower_grade"+h.studentMarksDetails[m].subjectId).text(h.gradeSystemArray[j].Grade);
                }
              }
            }
            $(".studentTotalMarks").text(studentFullMarks+'/'+overAllMarks);
            let totalPercent = subjectMarks*100/overAllMarks;
            $(".studentTotalPercent").text(totalPercent.toFixed(2)+'%');
            for (let k=0; k<h.gradeSystemArray.length; k++){
             if(Math.round(totalPercent) >= h.gradeSystemArray[k].MinMarks && Math.round(totalPercent) <= h.gradeSystemArray[k].MaxMarks){
                $(".overAllGrade").text(h.gradeSystemArray[k].Grade);
                $(".overAllGradePoint").text(h.gradeSystemArray[k].GradePoint);
              }
             }
          },500);
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  printExamReportCard(){
    $(".hide-while-print").hide();
    //createPDF();
    var name = "";
    var DocumentContainer = document.getElementById('studentExamReportCard');
    if(this.gurukulSchoolHigherClassReportCard){
      name = $("#studentName_guru").text()+" - "+$("#fatherName_guru").text()+" - "+$("#className_guru").text();
    }
    else {
      name = $(".studentName").text()+" - "+$(".fatherName").text()+" - "+$(".className").text();
    }
    var WindowObject = window.open(DocumentContainer.innerHTML, "ReportCard","width=1500,height=1100,top=100,left=150,toolbars=no,scrollbars=yes,status=no,resizable=no");

    WindowObject.document.writeln(DocumentContainer.innerHTML);
    WindowObject.document.close();
    WindowObject.focus();
    WindowObject.open();
    WindowObject.print();
    WindowObject.close();
    $(".hide-while-print").show();
  }
  printSemesterReportCard(){
    $(".hideButton-while-print").hide();
    //createPDF();
    var DocumentContainer = document.getElementById('studentSemReportCard');
    var name = $("#semStudentName").text()+" - "+$("#semFatherName").text()+" - "+$("#semClassName").text();
    var WindowObject = window.open(DocumentContainer.innerHTML, "ReportCard","width=1500,height=1100,top=100,left=50,toolbars=no,scrollbars=yes,status=no,resizable=no");

    WindowObject.document.writeln(DocumentContainer.innerHTML);
    WindowObject.document.close();
    WindowObject.focus();
    WindowObject.open();
    WindowObject.print();
    WindowObject.close();
    $(".hideButton-while-print").show();
  }
  printOverAllResult(){
    $(".printResult").hide();
    //createPDF();
    var name = "";
    var DocumentContainer = document.getElementById('overAllResultPrintPage');
    name = $("#classNumber").text()+" - "+$("#examNameOverAll").text();
    var WindowObject = window.open(DocumentContainer.innerHTML, "Result","width=1500,height=1100,top=100,left=150,toolbars=no,scrollbars=yes,status=no,resizable=no");

    WindowObject.document.writeln(DocumentContainer.innerHTML);
    WindowObject.document.close();
    WindowObject.focus();
    WindowObject.open();
    WindowObject.print();
    WindowObject.close();
    $(".printResult").show();
  }
  selectedSemesterNameForReportCard = "";
  selectedClassForSemReport = "";
  semClassReportData = true;
  showStudentListForSem = false;
  selectedSchoolExamBoardId = 0;
  newScholasticType = false;
  oldScholasticType = false;
  forAllExamScholasticType = false;
  oldScholasticExamId;
  getClassIdForSemReport;
  semId;
  scholasticTypeReport = true;
  toggleClickForSemReport(){
    this.showStudentListForSem = false;
    this.semClassReportData = true;
    this.getClassListBySemesterPublishedResult();
  }
  nextTermCommenceId = null;
  fetchStudentListBySemesterClass(data){
    this.nextTermCommenceId = data.pkNextTermCommenceId;
    this.comments = data.comment;
    if(!data.ScholasticType || data.ScholasticType == 'NO'){
      this.scholasticTypeReport = false;
    }
    else {
      this.scholasticTypeReport = true;
    }
    if(data.ScholasticType == 'NEW'){
      this.newScholasticType = true;
      this.oldScholasticType = false;
      this.forAllExamScholasticType = false;
    }
    if(data.ScholasticType == 'OLD'){
      this.newScholasticType = false;
      this.oldScholasticType = true;
      this.forAllExamScholasticType = false;
      this.oldScholasticExamId = data.ExamIdForScholastic;
    }
    if(data.ScholasticType == 'FOR_ALL_EXAM'){

      this.newScholasticType = false;
      this.oldScholasticType = false;
      this.forAllExamScholasticType = true;
      this.semId = data.fkExamSemesterId;
    }
    this.selectedSemesterNameForReportCard = data.ExamSemesterName;
    this.selectedClassForSemReport = data.classNumber+' - '+data.classDivision;
    this.getClassIdForSemReport = data.fkClassId;
    this.semClassReportData = false;
    this.showStudentListForSem = true;
    let getStData = {
      classId:data.fkClassId,
      semId:data.fkExamSemesterId
    };
    this.getStudentListForSemByClassSection(getStData);
  }
  semesterStudentList = [];
  semStudentStatus = false;
  semStudentDataStatus = false;
  semStudentListDataTable = false;
  allSchoolSemReport = true;
  radiantSchoolSemesterReport = false;
  mgaSchoolSemReportCard = false;
  kenyaSchool = false;
  gradeValue = null;
  getStudentListForSemByClassSection(data){
    this.semesterStudentList = [];
    this.destroyDataTable('studentListTableForSem');
    this.semStudentStatus = true;
    this.semStudentDataStatus = false;
    this.allSchoolSemReport = false;
    this.semStudentListDataTable = false;
    if(this.getSchoolId == "56"){
      this.mgaSchoolSemReportCard = true;
      this.allSchoolSemReport = false;
      this.kenyaSchool = false;
      this.radiantSchoolSemesterReport = false;

    }
    else if(this.getSchoolId == "67"){
      this.mgaSchoolSemReportCard = true;
      this.allSchoolSemReport = false;
      this.kenyaSchool = true;
      this.radiantSchoolSemesterReport = false;

    }else if(this.getSchoolId == "21"){
      this.radiantSchoolSemesterReport = true;
      this.mgaSchoolSemReportCard = false;
      this.allSchoolSemReport = false;
      this.kenyaSchool = false;
    }
    else {
      this.mgaSchoolSemReportCard = false;
      this.allSchoolSemReport = true;
      this.radiantSchoolSemesterReport = false;

    }
    let studentData = {
      classId:data.classId,
      ExamBoardId:this.selectedSchoolExamBoardId,
      ExamSemesterId:this.getSemesterId
    };
    this.examService.studentListForSemesterReportCard(studentData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.semStudentStatus = false;
          this.semesterStudentList = data;
          if(this.semesterStudentList.length == 0){
            this.semStudentDataStatus = true;
            this.semStudentListDataTable = false;
          }
          else {
            this.semStudentDataStatus = false;
            this.semStudentListDataTable = true;
            this.initializeDataTableOrder('studentListTableForSem');
          }
        },
        async error =>{
          this.semStudentStatus = false;
          this.semStudentDataStatus = false;
          this.semStudentListDataTable = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }


  classTeacherRemarks = "";
  classTeacherResult = "";
  headTeacherRemarks = "";
  principalSign = "";
  schoolStamp = "";
  fetchStudentSemesterReportCardDetails(data){
    this.classTeacherRemarks = data.TeacherRemarks;
    this.classTeacherResult = data.TeacherResult;
    this.headTeacherRemarks = data.principalRemarks;
    this.principalSign = data.principalSign;
    this.schoolStamp = data.schoolStamp;
    this.offcanvas.handleOffcanvasOpen('#studentSemesterReportCard');
    this.getSchoolDetail();
    this.fetchReportCardSettings();
    this.getExamGradeConfigByExamBoard(this.selectedSchoolExamBoardId);
    if(this.newScholasticType){
      this.getNewScholasticDataByStudent(data.studentId);
    }
    else if(this.oldScholasticType){
      this.getOldScholasticDataByStudent(data.studentId);
    }
    else if(this.forAllExamScholasticType){
      this.getForAllExamScholasticDataByStudent(data.studentId);
    }
    this.getStudentSemesterReportCard(data.studentId);
  }
  studentSemesterReportCardDetails = [];
  studentSemReportCardData: any;
  semSubjectList = [];
  getSemAttendanceDetailsOfStudent: any;
  semOverAllMarks = 0;
  semBifurcationSame = false;
  semBifurcationDiff = false;
  bifurcationDataOfSem = [];
  subjectListWithBifur = [];
  totalStudentInClass = null;
  getSubjectForMGA = [];
  subjectTeacher = [];
  semOverAllGrade = null;
  studentTotalMarks = null;
  studentMarksPercentage = null;
  particularSemBifurcation = false;
  bestOfTwoAvg = false;
  totMarksForBestTwo = 0;
  overAllPercentForBestTwo = "0";
  overAllPosition = 0;
  getStudentSemesterReportCard(studentId){
    this.semSubjectList = [];
    this.subjectListWithBifur = [];
    this.studentSemesterReportCardDetails = [];
    this.studentSemReportCardData = {};
    this.getSubjectForMGA = [];
    this.subjectTeacher = [];
    this.particularSemBifurcation = false;
    this.bestOfTwoAvg = false;
    this.examService.getStudentSemesterReportCardService(this.getClassIdForSemReport,studentId,this.getSemesterId,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.studentSemReportCardData = data.SemesterResultData[0];
          this.studentSemesterReportCardDetails = data.SemesterResultData;
          this.semOverAllGrade = this.studentSemesterReportCardDetails[0].overAllGrade
          this.studentMarksPercentage  =  this.studentSemesterReportCardDetails[0].overAllPercentage
          this.getSemAttendanceDetailsOfStudent = data.Attendance[0];
          this.subjectTeacher = data.staffs;
          this.totalStudentInClass = this.semesterStudentList.length;
          let sbf = false;
          for(let i=0; i<this.studentSemesterReportCardDetails.length; i++){
            if(this.studentSemesterReportCardDetails[i].subjectDetails[0][0].fkMarksBifurcationId){
              sbf = true;
            }
          }
          if(sbf){
            this.particularSemBifurcation = true;
          }

          let bestOfTwoAvg = false;


          for(let i=0; i<this.studentSemesterReportCardDetails.length; i++){
            if(this.studentSemesterReportCardDetails[i].subjectDetails[0][0].bestOfTwoAvg == "YES"){
              bestOfTwoAvg = true;
            }
          }
          if(bestOfTwoAvg){
            this.bestOfTwoAvg = true;
          }


          let h = this;
          if(this.getSchoolId == '56'){
            for(let m=0; m<data.SemesterResultData[0].subjectDetails.length; m++){
              for(let n=0; n<data.SemesterResultData[0].subjectDetails[m].length; n++){
                this.subjectListWithBifur.push({
                  subjectId:data.SemesterResultData[0].subjectDetails[m][n].subjectId,
                  subject:data.SemesterResultData[0].subjectDetails[m][n].subject,
                  fkMarksBifurcationId:data.SemesterResultData[0].subjectDetails[m][n].fkMarksBifurcationId,
                  MarksBifurcationName:data.SemesterResultData[0].subjectDetails[m][n].MarksBifurcationName,
                  fkMarksBifurcationConfigurationId:data.SemesterResultData[0].subjectDetails[m][n].fkMarksBifurcationConfigurationId,
                  SectionName:data.SemesterResultData[0].subjectDetails[m][n].SectionName,
                  Remarks:data.SemesterResultData[0].subjectDetails[m][n].Remarks
                });
                if(data.SemesterResultData[0].subjectDetails[m].length > 1 && n == (data.SemesterResultData[0].subjectDetails[m].length - 1)){
                  this.subjectListWithBifur.push({
                    subjectId:data.SemesterResultData[0].subjectDetails[m][n].subjectId,
                    subject:data.SemesterResultData[0].subjectDetails[m][n].subject,
                    fkMarksBifurcationId:data.SemesterResultData[0].subjectDetails[m][n].fkMarksBifurcationId,
                    MarksBifurcationName:data.SemesterResultData[0].subjectDetails[m][n].MarksBifurcationName,
                    fkMarksBifurcationConfigurationId:data.SemesterResultData[0].subjectDetails[m][n].fkMarksBifurcationConfigurationId,
                    SectionName:"Total %",
                    Remarks:data.SemesterResultData[0].subjectDetails[m][n].Remarks
                  });
                }
              }

            }
          }
          else {
            for(let i=0; i<data.SemesterResultData[0].subjectDetails.length; i++){
              for(let j=0; j<data.SemesterResultData[0].subjectDetails[i].length; j++){
                if(data.SemesterResultData[0].subjectDetails[i][j].fkMarksBifurcationId != null){
                  this.subjectListWithBifur.push({
                    subjectId:data.SemesterResultData[0].subjectDetails[i][j].subjectId,
                    subject:data.SemesterResultData[0].subjectDetails[i][j].subject,
                    fkMarksBifurcationId:data.SemesterResultData[0].subjectDetails[i][j].fkMarksBifurcationId,
                    MarksBifurcationName:data.SemesterResultData[0].subjectDetails[i][j].MarksBifurcationName,
                    fkMarksBifurcationConfigurationId:data.SemesterResultData[0].subjectDetails[i][j].fkMarksBifurcationConfigurationId,
                    SectionName:data.SemesterResultData[0].subjectDetails[i][j].SectionName,
                    subjectPosition:data.SemesterResultData[0].subjectDetails[i][j].subjectPosition
                  });
                  let subLength = this.subjectListWithBifur.length-1;
                  if(data.SemesterResultData[0].subjectDetails[i].length - 1){
                    if(this.subjectListWithBifur[subLength].fkMarksBifurcationId && data.SemesterResultData[0].subjectDetails[i][j +1]){
                      if(this.subjectListWithBifur[subLength].subjectId != data.SemesterResultData[0].subjectDetails[i][j +1].subjectId){
                        this.subjectListWithBifur.push({
                          subjectId:data.SemesterResultData[0].subjectDetails[i][j].subjectId,
                          subject:data.SemesterResultData[0].subjectDetails[i][j].subject,
                          fkMarksBifurcationId:data.SemesterResultData[0].subjectDetails[i][j].fkMarksBifurcationId,
                          MarksBifurcationName:data.SemesterResultData[0].subjectDetails[i][j].MarksBifurcationName,
                          fkMarksBifurcationConfigurationId:data.SemesterResultData[0].subjectDetails[i][j].fkMarksBifurcationConfigurationId,
                          SectionName:"Total %",
                          subjectPosition:data.SemesterResultData[0].subjectDetails[i][j].subjectPosition
                          //showTotalMarks:data.SemesterResultData[0].subjectDetails[i][j].subjectId,'_',data.SemesterResultData[0].subjectDetails[i][j].fkMarksBifurcationId
                        });
                      }
                    }
                  }
                }
                else {
                  this.subjectListWithBifur.push({
                    subjectId:data.SemesterResultData[0].subjectDetails[i][j].subjectId,
                    subject:data.SemesterResultData[0].subjectDetails[i][j].subject,
                    fkMarksBifurcationId:null,
                    subjectPosition:data.SemesterResultData[0].subjectDetails[i][j].subjectPosition
                  })
                }
              }
              let b = {
                subjectId: data.SemesterResultData[0].subjectDetails[i][0].subjectId,
                subjectName: data.SemesterResultData[0].subjectDetails[i][0].subject,
                semMarks:data.SemesterResultData[0].subjectDetails[i][0].semMarks,
                subjectPosition:data.SemesterResultData[0].subjectDetails[i][0].subjectPosition
              };
              this.semSubjectList.push(b);
            }
          }
          setTimeout(function () {
            for(let z=0; z<h.subjectTeacher.length; z++){
              $("#classTeacher"+h.subjectTeacher[z].subjectId).text(h.subjectTeacher[z].staffName);
              $("#Teacher"+h.subjectTeacher[z].subjectId).text(h.subjectTeacher[z].staffName);
            }
          },100);
          let semBifurcationArray = {};
          for(let x=0; x<this.studentSemesterReportCardDetails.length; x++){
            semBifurcationArray[this.studentSemesterReportCardDetails[x].fkExamId] = [];
            for(let y=0; y<this.studentSemesterReportCardDetails[x].subjectDetails.length; y++){
              semBifurcationArray[this.studentSemesterReportCardDetails[x].fkExamId].push(this.studentSemesterReportCardDetails[x].subjectDetails[y][0].fkMarksBifurcationId);
            }
          }
          this.bifurcationDataOfSem = [];
            for(var prop in semBifurcationArray){
              for(let b=0; b<semBifurcationArray[prop].length; b++){
                var newArray = [];
                $.each(semBifurcationArray[prop], function(i, el){
                  if($.inArray(el, newArray) === -1) newArray.push(el);
                });
              }
              this.bifurcationDataOfSem.push({ExamId:prop,arrayData:newArray});
              if(newArray.length == 1){
                this.semBifurcationSame = true;
                this.semBifurcationDiff = false;
              }
              else {
                this.semBifurcationDiff = true;
                this.semBifurcationSame = false;
              }
            }
         setTimeout(function () {
           let overAllMarks = 0;
           let semesterTotalMarks = 0;
           let semExamMarks = 0;
           let bestOfsemesterTotalMarks = 0;
           for(let j=0; j<h.studentSemesterReportCardDetails.length; j++){
             $("#reportPercentage"+h.studentSemesterReportCardDetails[j].fkExamId).text(h.studentSemesterReportCardDetails[j].Percentage);
             overAllMarks += h.studentSemesterReportCardDetails[j].semTotalMarks;
             for(let m=0; m<h.studentSemesterReportCardDetails[j].subjectDetails.length; m++){
               semesterTotalMarks += h.studentSemesterReportCardDetails[j].subjectDetails[m][0].semTotalMarks;
               /*bestOfsemesterTotalMarks = h.studentSemesterReportCardDetails[j].subjectDetails[m][0].semMarks;*/
               semExamMarks = 0;
               let examSubMaxMarks = h.studentSemesterReportCardDetails[j].subjectDetails[m][0].MaxMarks;
               for(let d=0; d<h.studentSemesterReportCardDetails[j].subjectDetails[m].length; d++){
                 semExamMarks +=  h.studentSemesterReportCardDetails[j].subjectDetails[m][d].marks
               }
               for(let d=0; d<h.bifurcationDataOfSem.length; d++){
                 if(h.bifurcationDataOfSem[d].arrayData.length == 1 && h.bifurcationDataOfSem[d].ExamId == h.studentSemesterReportCardDetails[j].fkExamId){
                   $("#examSemMarks"+h.studentSemesterReportCardDetails[j].fkExamId+'_'+h.studentSemesterReportCardDetails[j].subjectDetails[m][0].subjectId).text(semExamMarks);
                   /*$(".examSemMarksAvOfBestTwo"+h.studentSemesterReportCardDetails[j].fkExamId+'_'+h.studentSemesterReportCardDetails[j].subjectDetails[m][0].subjectId).text(bestOfsemesterTotalMarks);*/
                 }
                 else if(h.bifurcationDataOfSem[d].arrayData.length != 1 && h.bifurcationDataOfSem[d].ExamId == h.studentSemesterReportCardDetails[j].fkExamId) {
                   $("#examSemMarks_v2"+h.studentSemesterReportCardDetails[j].fkExamId+'_'+h.studentSemesterReportCardDetails[j].subjectDetails[m][0].subjectId).text(semExamMarks);
                 }
               }
               let examSubPercent = semExamMarks*100/examSubMaxMarks;
               for (let k=0; k<h.gradeSystemArray.length; k++){
                 if(Math.round(examSubPercent) >= h.gradeSystemArray[k].MinMarks && Math.round(examSubPercent) <= h.gradeSystemArray[k].MaxMarks){
                   for(let d=0; d<h.bifurcationDataOfSem.length; d++){
                     if(h.bifurcationDataOfSem[d].arrayData.length == 1 && h.bifurcationDataOfSem[d].ExamId == h.studentSemesterReportCardDetails[j].fkExamId){
                       $("#examSemGrade"+h.studentSemesterReportCardDetails[j].fkExamId+'_'+h.studentSemesterReportCardDetails[j].subjectDetails[m][0].subjectId).text(h.gradeSystemArray[k].Grade);
                     }
                     else if(h.bifurcationDataOfSem[d].arrayData.length != 1 && h.bifurcationDataOfSem[d].ExamId == h.studentSemesterReportCardDetails[j].fkExamId) {
                       $("#examSemGrade_v2"+h.studentSemesterReportCardDetails[j].fkExamId+'_'+h.studentSemesterReportCardDetails[j].subjectDetails[m][0].subjectId).text(h.gradeSystemArray[k].Grade);
                     }
                   }
                 }
               }
             }
           }
           setTimeout(function () {
             let subject_total_marks = 0;
             let subject_max_marks = 0;
             for(let x=0; x<h.studentSemesterReportCardDetails.length; x++){
               let total_marks_percent = 0;
               let sub_marks = 0;
               for(let y=0; y<h.studentSemesterReportCardDetails[x].subjectDetails.length; y++){
                 let studentSubjectMarks = 0;
                 let total_marks = 0;
                 for(let z=0; z<h.studentSemesterReportCardDetails[x].subjectDetails[y].length; z++){
                   subject_total_marks += h.studentSemesterReportCardDetails[x].subjectDetails[y][z].marks;
                   studentSubjectMarks += h.studentSemesterReportCardDetails[x].subjectDetails[y][z].marks;
                   let subjectPercent = studentSubjectMarks*100/h.studentSemesterReportCardDetails[x].subjectDetails[y][z].MaxMarks;


                   if(z == 0){
                     subject_max_marks += h.studentSemesterReportCardDetails[x].subjectDetails[y][z].MaxMarks;
                     sub_marks += h.studentSemesterReportCardDetails[x].subjectDetails[y][z].MaxMarks;
                   }
                   if(h.studentSemesterReportCardDetails[x].subjectDetails[y][z].fkMarksBifurcationId){
                     let studentMarks = h.studentSemesterReportCardDetails[x].subjectDetails[y][z].marks;
                     let marks = (studentMarks*100)/h.studentSemesterReportCardDetails[x].subjectDetails[y][z].MaxMarksBifur;
                     $("#MGAMarksWithBifur"+h.studentSemesterReportCardDetails[x].subjectDetails[y][z].fkExamId+'_'+h.studentSemesterReportCardDetails[x].subjectDetails[y][z].subjectId+'_'+h.removeSpace(h.studentSemesterReportCardDetails[x].subjectDetails[y][z].SectionName)).text(studentMarks);
                     if(h.studentSemesterReportCardDetails[x].subjectDetails[y][z].sectionName == 'Total %'){
                       $("#Remarks"+h.studentSemesterReportCardDetails[x].subjectDetails[y][z].subjectId).text(h.studentSemesterReportCardDetails[x].subjectDetails[y][z].Remarks);
                     }
                   }
                   else {
                     $("#Remarks"+h.studentSemesterReportCardDetails[x].subjectDetails[y][z].subjectId).text(h.studentSemesterReportCardDetails[x].subjectDetails[y][z].Remarks);
                     $("#MGAMarks"+h.studentSemesterReportCardDetails[x].subjectDetails[y][z].fkExamId+'_'+h.studentSemesterReportCardDetails[x].subjectDetails[y][z].subjectId).text(Math.round(subjectPercent))
                   }
                   let marks = 0;
                   if(h.studentSemesterReportCardDetails[x].subjectDetails[y].length > 1){
                     if(z == h.studentSemesterReportCardDetails[x].subjectDetails[y].length-1){
                       marks = Math.round(subjectPercent);
                     }
                   }
                   else {
                     marks = Math.round(subjectPercent);
                   }
                   total_marks_percent = total_marks_percent + marks;
                   h.overAllPosition =  h.studentSemesterReportCardDetails[0].position;
                   let mean_points = total_marks_percent/h.studentSemesterReportCardDetails[x].subjectDetails.length;
                   let subject_Marks = h.studentSemesterReportCardDetails[x].subjectDetails.length*100;
                   $("#MGAsemAllMarks"+h.studentSemesterReportCardDetails[x].subjectDetails[y][z].subjectId).text(h.studentSemesterReportCardDetails[x].subjectDetails[y][z].semMarks);
                   $("#MGASubjectMarksWithBifur"+h.studentSemesterReportCardDetails[x].subjectDetails[y][z].fkExamId+'_'+h.studentSemesterReportCardDetails[x].subjectDetails[y][z].subjectId).text(Math.round(subjectPercent));
                   $(".totalMarks"+h.studentSemesterReportCardDetails[x].fkExamId).text(total_marks_percent);
                   let total_percent = total_marks_percent*100/sub_marks;
                   $(".totalPercentForAllSub"+h.studentSemesterReportCardDetails[x].fkExamId).text(total_percent.toFixed(2)+'%');
                   $("#subject_total_marks"+h.studentSemesterReportCardDetails[x].fkExamId).text(' / '+subject_Marks);
                   $("#meanPoints"+h.studentSemesterReportCardDetails[x].fkExamId).text((mean_points).toFixed(2));
                 }
               }
             }
             $("#total_marks").text(subject_total_marks);
             h.studentTotalMarks = subject_total_marks;
             h.studentMarksPercentage = subject_total_marks*100/subject_max_marks;
             setTimeout(function () {
               let student_Bifur_marks = "0";
               let student_total_marks = 0;

               for(let m=0; m<h.subjectListWithBifur.length; m++){
                 let each_column_marks = 0;
                 let student_sub_marks = "0";
                 for(let i=0; i<h.studentSemesterReportCardDetails.length; i++){
                   //for(let j=0; j<h.studentSemesterReportCardDetails[i].subjectDetails[0].length; j++){
                   let fields_value = "0";
                   if(h.subjectListWithBifur[m].fkMarksBifurcationId && h.subjectListWithBifur[m].SectionName != 'Total %'){
                     fields_value = $("#subjectMarks_"+h.subjectListWithBifur[m].subjectId+h.removeSpace(h.subjectListWithBifur[m].SectionName)+'_'+(i+1)).text();
                   }
                   else if(h.subjectListWithBifur[m].fkMarksBifurcationId && h.subjectListWithBifur[m].SectionName == 'Total %'){
                     fields_value = $("#subjectMarks_"+h.subjectListWithBifur[m].subjectId+'mainSubject'+'_'+(i+1)).text();
                   }
                   else {
                     fields_value = $("#getSubjectMarks_"+h.subjectListWithBifur[m].subjectId+'_'+(i+1)).text();
                   }
                   each_column_marks = (each_column_marks) + parseInt(fields_value);
                   if(m == (h.subjectListWithBifur.length -1)){
                     student_sub_marks = $(".totalMarks"+h.studentSemesterReportCardDetails[i].fkExamId).text();
                     student_total_marks += parseInt(student_sub_marks);
                   }
                 }
                 let get_exam = h.studentSemesterReportCardDetails.length;
                 let average_value = (each_column_marks/get_exam);
                 student_total_marks = student_total_marks/get_exam;
                 if(h.subjectListWithBifur[m].fkMarksBifurcationId && h.subjectListWithBifur[m].SectionName != 'Total %'){
                   $("#MGAAllBifurMarks"+h.subjectListWithBifur[m].subjectId+'_'+h.removeSpace(h.subjectListWithBifur[m].SectionName)).text(Math.round(average_value));
                 }
                 else if(h.subjectListWithBifur[m].fkMarksBifurcationId && h.subjectListWithBifur[m].SectionName == 'Total %'){
                   $("#MGAAllExamMarks"+h.subjectListWithBifur[m].subjectId).text(Math.round(average_value));
                 }
                 else {
                   $("#MGASubjMarks"+h.subjectListWithBifur[m].subjectId).text(Math.round(average_value));
                 }
                // }
               }
               $("#student_total_marks").text(Math.round(student_total_marks));
               //$("#student_overAll_marks").text(Math.round(student_total_marks));
             },500)



           },500);
           h.semOverAllMarks = overAllMarks;
           let subjectMarks = 0;
           h.totMarksForBestTwo = 0;
           for(let n=0; n<h.semSubjectList.length; n++){
             let totalPercent = h.semSubjectList[n].semMarks*100/overAllMarks;
             subjectMarks += h.semSubjectList[n].semMarks;
             h.totMarksForBestTwo += h.semSubjectList[n].semMarks;
             for (let k=0; k<h.gradeSystemArray.length; k++){

               if(Math.round(totalPercent) >= h.gradeSystemArray[k].MinMarks && Math.round(totalPercent) <= h.gradeSystemArray[k].MaxMarks){
                  $("#semEvaluation"+h.semSubjectList[n].subjectId).text(h.gradeSystemArray[k].Grade);
               }
             }
           }
           let overAllPercent = subjectMarks*100/semesterTotalMarks;
           h.overAllPercentForBestTwo = (subjectMarks/h.semSubjectList.length).toFixed(2)+'%';
           for (let k=0; k<h.gradeSystemArray.length; k++){
            if (h.gradeValue == null) {
              h.gradeValue = (h.gradeSystemArray[k].MinMarks + '% - ' + h.gradeSystemArray[k].MaxMarks + '% = ' + h.gradeSystemArray[k].Grade);
            } else if (!h.gradeValue.includes(h.gradeSystemArray[k].MinMarks + '% - ' + h.gradeSystemArray[k].MaxMarks + '% = ' + h.gradeSystemArray[k].Grade)) {
              h.gradeValue = (h.gradeValue + ', ' + h.gradeSystemArray[k].MinMarks + '% - ' + h.gradeSystemArray[k].MaxMarks + '% = ' + h.gradeSystemArray[k].Grade);
            }
             if(Math.round(overAllPercent) >= h.gradeSystemArray[k].MinMarks && Math.round(overAllPercent) <= h.gradeSystemArray[k].MaxMarks){
              h.semOverAllGrade = h.gradeSystemArray[k].Grade;
              $("#semOverAllGrade").text(h.gradeSystemArray[k].Grade);
               $("#semOverAllGradePoint").text(h.gradeSystemArray[k].GradePoint);
             }
           }
         },50);
          setTimeout(function () {
            for(let i=0; i<h.studentSemesterReportCardDetails.length; i++){
              for(let j=0; j<h.studentSemesterReportCardDetails[i].subjectDetails.length; j++){
                for(let k=0; k<h.studentSemesterReportCardDetails[i].subjectDetails[j].length; k++){
                  let marks_id = h.studentSemesterReportCardDetails[i].subjectDetails[0][0].fkMarksBifurcationId;
                  if(h.studentSemesterReportCardDetails[i].subjectDetails[j][k].fkMarksBifurcationId == marks_id && h.studentSemesterReportCardDetails[i].subjectDetails[j][k].fkMarksBifurcationId != null){
                    if(h.studentSemesterReportCardDetails[i].subjectDetails[j][k].studentExamAttendance == 'ABSENT'){
                      $("#marksBifurcation_"+h.studentSemesterReportCardDetails[i].fkExamId+'_'+h.studentSemesterReportCardDetails[i].subjectDetails[j][k].subjectId+'_'+h.studentSemesterReportCardDetails[i].subjectDetails[j][k].fkMarksBifurcationId+'_'+h.studentSemesterReportCardDetails[i].subjectDetails[j][k].fkMarksBifurcationConfigurationId).text('ABSENT');
                    }
                    else {
                      $("#marksBifurcation_"+h.studentSemesterReportCardDetails[i].fkExamId+'_'+h.studentSemesterReportCardDetails[i].subjectDetails[j][k].subjectId+'_'+h.studentSemesterReportCardDetails[i].subjectDetails[j][k].fkMarksBifurcationId+'_'+h.studentSemesterReportCardDetails[i].subjectDetails[j][k].fkMarksBifurcationConfigurationId).text(h.studentSemesterReportCardDetails[i].subjectDetails[j][k].marks);
                    }
                  }
                }
              }
            }
          },100)
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  removeSpace(sectionName){
    if(sectionName){
      let name = sectionName.replace(/ /g, '_');
      return name
    }
  }
  studentSemesterScholasticDetails = [];
  show_sem_scholastic = false;
  getNewScholasticDataByStudent(studentId){
    this.studentSemesterScholasticDetails = [];
    this.show_sem_scholastic = false;
    let scholasticData = {
      classId:this.getClassIdForSemReport,
      SemesterId:this.getSemesterId,
      studentId:studentId,
      ExamBoardId:this.selectedSchoolExamBoardId
    };
    this.examService.getNewScholasticResultForSemReportCardByStudentService(scholasticData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.studentSemesterScholasticDetails = data;
          if(data.length > 0){
            this.show_sem_scholastic = true;
          }
          else {
            this.show_sem_scholastic = false;
          }
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError'));
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  getOldScholasticDataByStudent(studentId){
    this.studentSemesterScholasticDetails = [];
    this.show_sem_scholastic = false;
    let scholasticData = {
      classId:this.getClassIdForSemReport,
      ExamId:this.oldScholasticExamId,
      studentId:studentId,
      ExamBoardId:this.selectedSchoolExamBoardId
    };
    this.examService.fetchAllScholasticConfigDetailsService(scholasticData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.studentSemesterScholasticDetails = data;
          if(data && data.length > 0){
            this.show_sem_scholastic = true;
          }
          else {
            this.show_sem_scholastic = false;
          }
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  co_ScholasticArray = [];
  studentSemesterScholasticDetailsForAllExam = [];
  getForAllExamScholasticDataByStudent(studentId){
    this.studentSemesterScholasticDetailsForAllExam = [];
    this.show_sem_scholastic = true;
    let scholasticData = {
      classId:this.getClassIdForSemReport,
      studentId:studentId,
      ExamBoardId:this.selectedSchoolExamBoardId,
      SemId:this.semId
    };
    this.co_ScholasticArray=[];
    this.examService.fetchAllScholasticConfigDetailsForAllExamService(scholasticData,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          if(data && data.length > 0){
          this.studentSemesterScholasticDetailsForAllExam = data;
          let x = this.studentSemesterScholasticDetailsForAllExam[0].coScholasticDetail;
          for(let i=0; i<x.length; i++){
            this.co_ScholasticArray.push({coScholasticId:x[i][0].pkCoScholasticConfigurationId,
              coScholasticName:x[i][0].CoScholasticConfigurationName,
              skillsList:[], examId:null,ExamName:null
            });
            for(let y = 0; y<data.length; y++){
              this.co_ScholasticArray.push({coScholasticId:x[i][0].pkCoScholasticConfigurationId,
                coScholasticName:x[i][0].CoScholasticConfigurationName,
                skillsList:[],examId:data[y].ExamId,ExamName:data[y].ExamName
              });
            }

          }

          for(let k=0; k<this.co_ScholasticArray.length; k++){
           // if(this.co_ScholasticArray[k].examId == null){
              for(let l=0; l<x.length; l++){
                for(let m=0; m<x[l].length; m++){
                  if(m == 0){
                    if(this.co_ScholasticArray[k].coScholasticId == x[l][m].pkCoScholasticConfigurationId){
                      this.co_ScholasticArray[k].skillsList.push({
                        skillsId:x[l][m].pkScholasticSkillsId,skillsName:x[l][m].ScholasticSkillsName
                      })
                    }

                  }
                  else {
                    if(this.co_ScholasticArray[k].coScholasticId == x[l][m][0].pkCoScholasticConfigurationId){
                      this.co_ScholasticArray[k].skillsList.push({
                        skillsId:x[l][m][0].pkScholasticSkillsId,skillsName:x[l][m][0].ScholasticSkillsName
                      })
                    }

                  }

                }
              }
            //}
          }
          setTimeout(function () {
            for(let i=0; i<data.length; i++){
              for(let j=0; j<data[i].coScholasticDetail.length; j++){
                for(let k=0; k<data[i].coScholasticDetail[j].length; k++){
                  if(k==0){
                    if(data[i].coScholasticDetail[j][k].EvaluationType == 'GRADE'){
                      $("#skillsMarks"+data[i].coScholasticDetail[j][k].pkCoScholasticConfigurationId+'_'+data[i].ExamId+'_'+data[i].coScholasticDetail[j][k].pkScholasticSkillsId).text(data[i].coScholasticDetail[j][k].Grade);
                    }
                    else {
                      $("#skillsMarks"+data[i].coScholasticDetail[j][k].pkCoScholasticConfigurationId+'_'+data[i].ExamId+'_'+data[i].coScholasticDetail[j][k].pkScholasticSkillsId).text(data[i].coScholasticDetail[j][k].ScholasticMarksOrGrade);
                    }
                  }
                  else {
                    if(data[i].coScholasticDetail[j][k][0].EvaluationType == 'GRADE'){
                      $("#skillsMarks"+data[i].coScholasticDetail[j][k][0].pkCoScholasticConfigurationId+'_'+data[i].ExamId+'_'+data[i].coScholasticDetail[j][k][0].pkScholasticSkillsId).text(data[i].coScholasticDetail[j][k][0].Grade);
                    }
                    else {
                      $("#skillsMarks"+data[i].coScholasticDetail[j][k][0].pkCoScholasticConfigurationId+'_'+data[i].ExamId+'_'+data[i].coScholasticDetail[j][k][0].pkScholasticSkillsId).text(data[i].coScholasticDetail[j][k][0].ScholasticMarksOrGrade);
                    }
                  }
                }
              }
            }
          },100)
            this.show_sem_scholastic = true;
          }
          else {
            this.show_sem_scholastic = false;
          }
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  teacherRemarks(data,status){
    let principal = null;
    let teacher = null;
    let result = null;
    if(status == 'PRINCIPAL'){
      principal = data.principalRemarks
    }
    else if (status == 'TEACHER'){
     teacher = data.TeacherRemarks;
    }
    else {
      result = data.TeacherResult;
    }
    let studentDetails = {
      classId:this.getClassIdForSemReport,
      studentId:data.studentId,
      ExamBoardId:this.selectedSchoolExamBoardId,
      semesterId:this.getSemesterId,
      TeacherRemarkId:data.pkSemesterResultTeacherRemarksId,
      TeacherRemarks:teacher,
      TeacherResult:result,
      principalRemarks:principal
    };
    this.examService.TeacherRemarksEntryByStudentForSemesterService(studentDetails,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          if(data.status){
            const entrySuccessfullyInsertedTranslation = await firstValueFrom(this.translate.get('entrySuccessfullyInserted')); 
            customToastr(entrySuccessfullyInsertedTranslation, 'success');
            let stData = {
              classId:this.getClassIdForSemReport
            };
            this.getStudentListForSemByClassSection(stData);
          }
          else {
            const someProblemPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('someProblemPleaseTryAgain')); 
            customToastr(someProblemPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  /*REPORT CARD CONFIGURATION*/
  examMarks = 0;
  examGrade = 0;
  examGradePoint = 0;
  semMarks = 0;
  semGrade = 0;
  semGradePoint = 0;
  examBifurcation = 0;
  semBifurcation = 0;
  examAttendance = 0;
  semAttendance = 0;
  ReportCardSettingId = null;
  reportDataButton = false;
  manageReportButton(){
    this.reportDataButton = true;
  }
  examBifurcationTrue(){
    this.examBifurcation = 1;
  }
  examBifurcationFalse(){
    this.examBifurcation = 0;
  }
  semBifurcationTrue(){
    this.semBifurcation = 1;
  }
  semBifurcationFalse(){
    this.semBifurcation = 0;
  }
  examAttendanceTrue(){
    this.examAttendance = 1;
  }
  examAttendanceFalse(){
    this.examAttendance = 0;
  }
  semAttendanceTrue(){
    this.semAttendance = 1;
  }
  semAttendanceFalse(){
    this.semAttendance = 0;
  }
  manageReportCardSetting(){
    if(this.examMarks){
      this.examMarks = 1;
    }
    else {
      this.examMarks = 0;
    }
    if(this.examGrade){
      this.examGrade = 1;
    }
    else {
      this.examGrade = 0;
    }
    if(this.examGradePoint){
      this.examGradePoint = 1;
    }
    else {
      this.examGradePoint = 0;
    }
    if(this.semMarks){
      this.semMarks = 1;
    }
    else {
      this.semMarks = 0;
    }
    if(this.semGrade){
      this.semGrade = 1;
    }
    else {
      this.semGrade = 0;
    }
    if(this.semGradePoint){
      this.semGradePoint = 1;
    }
    else {
      this.semGradePoint = 0;
    }
    let reportCardData = {
      examMarks: this.examMarks,
      examGrade: this.examGrade,
      examGradePoint: this.examGradePoint,
      examAttendance: this.examAttendance,
      examBifurcation: this.examBifurcation,
      semMarks: this.semMarks,
      semGrade: this.semGrade,
      semGradePoint: this.semGradePoint,
      semAttendance: this.semAttendance,
      semBifurcation: this.semBifurcation,
      ReportCardSettingId: this.ReportCardSettingId
    };
    $("#reportCardSaveButton").attr('disabled',true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#reportCardSaveButton").text(translatedText); });
    this.examService.manageReportCardSettingsService(reportCardData,this.academicInfo.current_academic, this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          $("#reportCardSaveButton").attr('disabled',false);
          this.translate.get('save').subscribe((translatedText: string) => { $("#reportCardSaveButton").text(translatedText); });
          if(data.status){
            const reportCardSettingSuccessfullySavedTranslation = await firstValueFrom(this.translate.get('reportCardSettingSuccessfullySaved')); 
            customToastr(reportCardSettingSuccessfullySavedTranslation, 'success');
            this.fetchReportCardSettings();
            this.reportDataButton = false;
          }
          else {
            $("#reportCardSaveButton").attr('disabled',false);
            this.translate.get('save').subscribe((translatedText: string) => { $("#reportCardSaveButton").text(translatedText); });
            const reportCardSettingNotSavedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('reportCardSettingNotSavedPleaseTryAgain')); 
            customToastr(reportCardSettingNotSavedPleaseTryAgainTranslation, 'error');
          }
        }
      );
  }
  fetchReportCardSettings(){
    this.reportDataButton = false;
    this.examMarks = 0;
    this.examGrade = 0;
    this.examGradePoint = 0;
    this.semMarks = 0;
    this.semGrade = 0;
    this.semGradePoint = 0;
    this.examBifurcation = 0;
    this.semBifurcation = 0;
    this.examAttendance = 0;
    this.semAttendance = 0;
    this.ReportCardSettingId = null;
    this.examService.fetchReportCardSettingsService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          if(data && data.length > 0){
          this.examMarks = data[0].ExamMarks;
          this.examGrade = data[0].ExamGrade;
          this.examGradePoint = data[0].ExamGradePoint;
          this.examBifurcation = data[0].ExamBifurcation;
          this.examAttendance = data[0].ExamAttendance;
          this.semMarks = data[0].SemMarks;
          this.semGrade = data[0].SemGrade;
          this.semGradePoint = data[0].SemGradePoint;
          this.semBifurcation = data[0].SemBifurcation;
          this.semAttendance = data[0].SemAttendance;
          this.ReportCardSettingId = data[0].pkReportCardSettingId;
          }
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  /*Exam Prediction Tab Start*/

  // READING CSV FILE FROM S3 AND PARSING IT......

  csvModelRead() {

    this.http.get(this.csvURL1).subscribe(
      (data: any) => this.extractData(data),
      err => this.handleError(err)
    );
    this.csvPedictionRead();
  }

  private extractData(res) {
    this.lines = [];
    this.preddata = [];
    this.value = [];
    this.name = [];
    this.section = [];
    this.gender = [];
    this.year = [];
    this.tarr = [];
    this.grade = [];
    this.data1=[];
    this.csvData=[];
    this.year2014=[];
    this.year2015=[];
    this.year2016=[];
    this. graphCount2014 = {
      count:0,count1:0,count2:0,count3:0,count4:0
    };
    this.graphCount2015 = {
      count:0,count1:0,count2:0,count3:0,count4:0
    };
    this.graphCount2016 = {
      count:0,count1:0,count2:0,count3:0,count4:0
    };

    var csvData = res['_body'] || '';
    var allTextLines = csvData.split(/\r\n|\n/);
    var headers = allTextLines[0].split(',');

    for (var i = 1; i < (allTextLines.length - 1); i++) {
      this.data1 = allTextLines[i].split(',');
      for (var j = 0; j < headers.length; j++) {
        this.tarr.push(this.data1[j]);
      }
      this.lines.push(this.tarr);
    }

    this.csvData = this.lines;

    for (var i = 0; i < this.tarr.length; i += 5) {
      this.name.push(this.tarr[i]);
    }
    for (var i = 1; i < this.tarr.length; i += 5) {
      this.section.push(this.tarr[i]);
    }
    for (var i = 2; i < this.tarr.length; i += 5) {
      this.gender.push(this.tarr[i])
    }
    for (var i = 3; i < this.tarr.length; i += 5) {
      this.year.push(this.tarr[i]);
    }
    for (var i = 4; i < this.tarr.length; i += 5) {
      this.grade.push(this.tarr[i]);
    }
    let name3=[];
    for(var i=0;i<this.tarr.length;i++)
    {

      if(this.year[i]==2014 && this.grade[i]==1)
      {
        this.graphCount2014.count++;
      }
      else if(this.year[i]==2014 && this.grade[i]==2)
      {
        this.graphCount2014.count1++;
      }
      else if(this.year[i]==2014 && this.grade[i]==3)
      {
        this.graphCount2014.count2++;
      }
      else if(this.year[i]==2014 && this.grade[i]==4)
      {
        this.graphCount2014.count3++;
      }
      else if(this.year[i]==2014 && this.grade[i]==5)
      {
        this.graphCount2014.count4++;
      }
    }
    for(var i=0;i<this.tarr.length;i++)
    {
      if(this.year[i]==2015 && this.grade[i]==1)
      {
        this.graphCount2015.count++;
      }
      else if(this.year[i]==2015 && this.grade[i]==2)
      {
        this.graphCount2015.count1++;
      }
      else if(this.year[i]==2015 && this.grade[i]==3)
      {
        this.graphCount2015.count2++;
      }
      else if(this.year[i]==2015 && this.grade[i]==4)
      {
        this.graphCount2015.count3++;
      }
      else if(this.year[i]==2015 && this.grade[i]==5)
      {
        this.graphCount2015.count4++;
      }
    }

    for(var i=0;i<this.tarr.length;i++)
    {
      if(this.year[i]==2016 && this.grade[i]==1)
      {

        this.graphCount2016.count++;
      }
      else if(this.year[i]==2016 && this.grade[i]==2)
      {
        this.graphCount2016.count1++;
      }
      else if(this.year[i]==2016 && this.grade[i]==3)
      {
        this.graphCount2016.count2++;

      }
      else if(this.year[i]==2016 && this.grade[i]==4)
      {
        this.graphCount2016.count3++;
      }
      else if(this.year[i]==2016 && this.grade[i]==5)
      {
        this.graphCount2016.count4++;
      }
    }
    for(var i=0;i<this.year.length;i++)
    {
      if(this.year[i]==2014)
      {
        this.year2014[i]=this.year[i];
      }
      else if (this.year[i]==2015)
      {
        this.year2015[i]=this.year[i];
      }
      else if(this.year[i]==2016){
        this.year2016[i]=this.year[i];
      }
    }
  }
  private handleError(error:any)
  {
    let errMsg = (error.message) ? error.message :
      error.status ? '${error.status}-${error.statusText}' : 'Server.error';
    return errMsg;
  }

  csvPedictionRead() {

    this.http.get(this.csvURL).subscribe(
      (data: any) => this.extractPredictionData(data),
      err => this.handlePredictionError(err)
    );
  }

  private extractPredictionData(res) {
    this.prelines = [];
    this.predata = [];
    this.prevalue = [];
    this.prename = [];
    this.presection = [];
    this.pregender = [];
    this.preyear = [];
    this.pretarr = [];
    this.pregrade = [];
    this.precsvData=[];
    this.preyear2014=[];
    this.preyear2015=[];
    this.preyear2016=[];
    this.graphCountPredict = {
      count:0,count1:0,count2:0,count3:0,count4:0
    };



    var csvPredData = res['_body'] || '';
    var allTextLines1 = csvPredData.split(/\r\n|\n/);
    var headers1 = allTextLines1[0].split(',');

    for (var i = 1; i < (allTextLines1.length - 1); i++) {
      this.predata = allTextLines1[i].split(',');
      for (var j = 0; j < headers1.length; j++) {
        this.pretarr.push(this.predata[j]);
      }
      this.prelines.push(this.pretarr);
    }

    this.precsvData = this.prelines;

    for (var i = 0; i < this.pretarr.length; i += 5) {
      this.prename.push(this.pretarr[i]);
    }
    for (var i = 1; i < this.pretarr.length; i += 5) {
      this.presection.push(this.pretarr[i]);
    }
    for (var i = 2; i < this.pretarr.length; i += 5) {
      this.pregender.push(this.pretarr[i]);
    }
    for (var i = 3; i < this.pretarr.length; i += 5) {
      this.preyear.push(this.pretarr[i]);
    }
    for (var i = 4; i < this.pretarr.length; i += 5) {
      this.pregrade.push(this.pretarr[i]);
    }

    for(var i=0;i<this.preyear.length;i++)
    {
      if(this.preyear[i]==2014)
      {
        this.preyear2014[i]=this.preyear[i];
      }
      else if (this.preyear[i]==2015)
      {
        this.preyear2015[i]=this.preyear[i];
      }
      else if (this.preyear[i]==2017){
        this.preyear2017[i]=this.preyear[i];
      }
    }

    for(var i=0;i<this.tarr.length;i++)
    {
      if(this.preyear[i]==2017 && this.pregrade[i]==1)
      {
        this.graphCountPredict.count++;
      }
      else if(this.preyear[i]==2017 && this.pregrade[i]==2)
      {
        this.graphCountPredict.count1++;
      }
      else if(this.preyear[i]==2017 && this.pregrade[i]==3)
      {
        this.graphCountPredict.count2++;
      }
      else if(this.preyear[i]==2017 && this.pregrade[i]==4)
      {
        this.graphCountPredict.count3++;
      }
      else if(this.preyear[i]==2017 && this.pregrade[i]==5)
      {
        this.graphCountPredict.count4++;
      }
    }

    this.chartData();
  }
  private handlePredictionError(error:any)
  {
    let errMsg = (error.message) ? error.message :
      error.status ? '${error.status}-${error.statusText}' : 'Server.error';
    return errMsg;
  }


  // Graph
  bar_ChartData = [];
  chartData(){
    this.bar_ChartData = [
      ['Year', 'Marks Below 33%', 'Marks > 33% to 50%','Marks > 50% to 70%','Marks > 70% to 80%','Marks > 80% to 100%'],
      ['2014-15',this.graphCount2014.count,this.graphCount2014.count1,this.graphCount2014.count2,this.graphCount2014.count3,this.graphCount2014.count4],
      ['2015-16',this.graphCount2015.count,this.graphCount2015.count1,this.graphCount2015.count2,this.graphCount2015.count3,this.graphCount2015.count4],
      ['2016-17',this.graphCount2016.count,this.graphCount2016.count1,this.graphCount2016.count2,this.graphCount2016.count3,this.graphCount2016.count4],
      ["(Prediction) 2017-18",
        this.graphCountPredict.count,this.graphCountPredict.count1,this.graphCountPredict.count2,this.graphCountPredict.count3,this.graphCountPredict.count4]];

  }
  private bar_ChartOptions= {
    title: 'Prediction Of Marks Of Upcoming Year Students Based On Previous Year Results',
    textStyle: {
      fontSize: 8,
    },
    chartArea: {width: '53%'},
    isStacked: true,
    is3D: true,
    bars:'vertical',
    tooltip:{isHtml:false},
    bar: {groupWidth: '78%'},
    colors: ['#e8312b', '#f3631d', '#f2d922', '#a1f322', '#43c51d'],
    hAxis: {
      title: 'Number Of Students',
      minValue: 0,
      textStyle: {
        bold: true,
        ticks: {mirror: true},
        fontSize: 12,
        color: '#4d4d4d'
      },
      titleTextStyle: {
        bold: true,
        fontSize: 14,
        color: '#4d4d4d'
      }
    },
    vAxis: {
      title: 'Year',
      textStyle: {
        fontSize: 14,
        bold: true,
        color: '#848484'
      },
      titleTextStyle: {
        fontSize: 14,
        bold: true,
        color: '#848484'
      }
    },

  };
  selectedRowStudentList = [];
  selectedDataYear="";
  selectedMarks=""
  itemSelected(event) {
    if(event){
      this.selectedRowStudentList = [];
      let rowData = event.row;
      let columnData = event.column;
      let yearData;
      this.selectedDataYear = "";
      this.selectedMarks = "";
      if(rowData == 0){
        yearData = 2014;
        this.selectedDataYear = '2014-15';
      }
      else if (rowData == 1){
        yearData = 2015;
        this.selectedDataYear = '2015-16';
      }
      else if (rowData == 2){
        yearData = 2016;
        this.selectedDataYear = '2016-17';
      }
      else if (rowData == 3){
        yearData = 2017;
        this.selectedDataYear = '2017-18';
      }
      if(columnData==1)
      {
        this.selectedMarks="Below 33%";
      }
      else if (columnData==2)
      {
        this.selectedMarks="> 33% to 50%";
      }
      else if (columnData==3)
      {
        this.selectedMarks="> 50% to 70%";
      }
      else if (columnData==4)
      {
        this.selectedMarks="> 70% to 80%";
      }
      else if (columnData==5)
      {
        this.selectedMarks="> 80% to 100%";
      }

      if(rowData != 3){
        for (let i = 0; i < this.tarr.length; i++) {

          if(this.year[i]==yearData && this.grade[i]==columnData)
          {
            this.selectedRowStudentList.push({studentName:this.name[i],section:this.section[i]});

          }
        }
      }
      else {
        for (let i = 0; i < this.pretarr.length; i++) {

          if(this.preyear[i]==yearData && this.pregrade[i]==columnData)
          {
            this.selectedRowStudentList.push({studentName:this.prename[i],section:this.presection[i]});
          }
        }
      }
      $("#examPred").modal("show");
    }

  }

  /*Exam Prediction Tab END*/

  isValidToken(){
    var isValidToken = false;
    var isValidSchool = 0;
    this.loginservice.isValidToken(localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          isValidToken = data.isValid;
          if(isValidToken==true){
            this.loginservice.isValidSchoolId(localStorage.getItem('schoolinfo'))
              .subscribe(
                (data: any) => {
                  isValidSchool = data.schoolExist;
                  this.getSchoolId = localStorage.getItem('schoolinfo');
                  if(isValidSchool!=1){
                    this.router.navigate(['/login']);
                  }else{
                    this.scriptInit();
                    this.initializeAcademicData();

                  }
                },
                error =>
                  () => {}
              );
          }else{
            this.router.navigate(['/login']);
          }
        },
        error =>
          () => {

          }
      );
  }

  scriptInit(){
    ///$(".after").empty();
    //$("#device-breakpoints").remove();
    //$(".after").append("<script>function momentJs(){return moment();};function customToastr(message,type,title){toastr.options.hideDuration = 0;toastr.clear();toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';toastr[type](message, title || '');return 0;}	</"+"script><script  async src='assets/js/core/timepicker/timepicker.js'></script>");
  }
  hideDatePicker(){
    $(".dateExam").datepicker(function () {
      $(this).hide();
    });
}
  ngOnInit() {
    this.loginMode = localStorage.getItem('loginMode');
    this.scriptLoader.loadScript($,"DASHBOARD")
    if(!this.loginMode){
      this.loginMode = 'WEB_ADMIN';
    }
    if(this.loginMode == 'WEB_ADMIN'){
      this.academicInfo.current_tab = 'EXAM_MANAGEMENT';
    }
    else if(this.loginMode == 'STAFF'){
      this.academicInfo.current_tab = 'TODAY';
    }
    /*$(".after").empty();
    $("#device-breakpoints").remove();
    $(".after").append("<script>function momentJs(){return moment();}function customToastr(message,type,title){toastr.options.hideDuration = 0;toastr.clear();toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';toastr[type](message, title || '');return 0;}	</"+"script><script async src='assets/js/libs/bootstrap-datepicker/bootstrap-datepicker.js'></script><script src='https://cdn.datatables.net/1.10.15/js/jquery.dataTables.min.js'></script><script async src='assets/js/core/timepicker/timepicker.js'></script>");
    var h = this;
    $.getScript("assets/js/libs/bootstrap-datepicker/bootstrap-datepicker.js", function (data, textStatus, jqXHR) {
      if(this.loginMode == 'STAFF'){
        this.currentStatus = true;
        $.getScript( "https://cdn.datatables.net/1.10.15/js/jquery.dataTables.min.js", function( data, textStatus, jqxhr ) {
          h.isValidToken();
        });
      }
      else{
        h.isValidToken();
      }
    });*/
    this.isValidToken();


  /*Data for start date and end Date*/
  var h = this;
    $('#startDate').change(function () {
      $(this).datepicker("hide");
    });
    $('#endDate').change(function () {
      $(this).datepicker("hide");
    });
    $("#examTime").on('changeTime',function () {
      var startTime = $("#examTime").val();
      var convertTime = moment(startTime, ["h:mm A"]).format("HH:mm");
      for(var i=0; i<h.subjectListArray.length; i++){
        $("#startTime"+h.subjectListArray[i].subjectId).val($("#examTime").val());
        var examDurationInt = parseInt(h.examDuration);
        if(isNaN(examDurationInt) == false && examDurationInt >= 10){
          var time = convertTime.split(':');
          var m = momentJs();
          m.hours(time[0]);
          m.minutes(time[1]);
          m.minutes(m.minutes() + examDurationInt);
          $('#endTime'+h.subjectListArray[i].subjectId).val(m.format('h:mm A'))
        }
      }
    });
    /*$('#classExamStartDate').change(function () {
      var classExamDate;
      var classExamStartDate;
      classExamStartDate =  $('#classExamStartDate').val();
      var est = classExamStartDate;
      var classExamEndDate =  $('#classExamEndDate').val();
      classExamStartDate = h.datepipe.transform(classExamStartDate, 'dd/MM/yyyy');
      var exDate = classExamStartDate;
      var d = classExamStartDate.split("/");
      classExamDate = d[2]+"-"+h.getProperDate(d[1])+"-"+h.getProperDate(d[0])+"T"+"00:00:00";
      for(var i=0; i<h.subjectListArray.length; i++){
        $( "#examDate"+h.subjectListArray[i].subjectId ).attr( "data-date-start-date", function( i, est ) {
          return est ;
        });
        $( "#examDate"+h.subjectListArray[i].subjectId ).attr( "data-date-end-date", function( i, classExamEndDate ) {
          return classExamEndDate ;
        });
        var examDate = h.datepipe.transform(classExamDate, 'EEE MMM d, y');
        $("#examDate"+h.subjectListArray[i].subjectId).val(examDate);
        classExamDate = new Date((new Date(classExamDate)).getTime() + (60*60*24*1000));
        classExamDate = classExamDate.getFullYear()+"-"+(h.getProperDate(classExamDate.getMonth()+ 1))+"-"+h.getProperDate(classExamDate.getDate())+"T"+"00:00:00";
      }
      $(this).datepicker("hide");
    });*/
    $(".updateDate").datepicker({
      autoclose:true
    });

     this.langChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      $.fn.dataTable.ext.errMode = 'none';
            this.destroyDataTable('examListTable');
                this.destroyDataTable('classDetailTable');
                 this.destroyDataTable('currentExamScheduleTable');
            this.destroyDataTable('boardExamListTable')
            this.destroyDataTable('upcomingExamScheduleTable')
                this.destroyDataTable('completedExamScheduleTable')
                              this.destroyDataTable('sectionListTable')
                              this.destroyDataTable('semesterClassListTable');
                               this.destroyDataTable('classListTable');
                               this.destroyDataTable('semesterClassListTableForReport');
this.destroyDataTable('studentListTableForSem');
this.destroyDataTable('scholasticListTable');
this.destroyDataTable('ScholasticConfigListTable');
this.destroyDataTable('marksBifurcationListTable');
this.destroyDataTable('reportCardConfigListTable');
this.destroyDataTable('showStudentMarksTable');
this.destroyDataTable('studentsResultTable');
            

this.initializeDataTableOrder('completedExamScheduleTable');
this.initializeDataTableWithOutPaging('studentsResultTable')
this.initializeDataTableOrder('semesterClassListTable')
this.initializeDataTableOrder('boardExamListTable');
this.initializeDataTableOrder('upcomingExamScheduleTable');
            this.initializeDataTableOrder('examListTable');
                 this.initializeDataTableOrder('classDetailTable')
                             this.initializeDataTable('currentExamScheduleTable');
                              this.initializeDataTable('sectionListTable');
                               this.initializeDataTable('classListTable');
                               this.initializeDataTableOrder('semesterClassListTableForReport');
this.initializeDataTableOrder('studentListTableForSem');
this.initializeDataTableOrder('scholasticListTable');
this.initializeDataTableOrder('ScholasticConfigListTable');
this.initializeDataTableOrder('marksBifurcationListTable');
this.initializeDataTableOrder('reportCardConfigListTable');
this.initializeDataTableOrder('showStudentMarksTable');
                             
      })
  }
  academicList = [];
  school_academic_id;

  initializeAcademicData(){
    this.feeService.fetchAcademicList()
      .subscribe(
        (data: any) => {
          if (data.errorcode) {

          }
          else {
            data = data.academicList;
            this.academicList = [];
            if(data && data.length > 0){
              this.academicInfo.academicList = data;
              let index_of_current = null;
              for(let i=0;i<this.academicInfo.academicList.length; i++){
                this.academicInfo.academicList[i].current = false;
                this.academicInfo.academicList[i].notstarted = false;
                this.academicInfo.academicList[i].completed = false;
                if (this.academicInfo.academicList[i].InActive == 0) {
                  index_of_current = i;
                  this.academicInfo.academicList[i].current = true;
                  this.academicInfo.current_academic = this.academicInfo.academicList[i].pkAcademicId;
                  this.academicInfo.year = this.academicInfo.academicList[i].Year;
                  this.school_academic_id = this.academicInfo.current_academic;
                  this.academicInfo.current_academic_state = this.academicInfo.academicList[i].current ? 'RUNNING' : this.academicInfo.academicList[i].completed ? 'COMPLETED' : 'NOT_STARTED'
                }
                else if (this.academicInfo.academicList[i].InActive == 1) {
                  let sDate = new Date(this.academicInfo.academicList[i].StartDate);
                  let eDate = new Date(this.academicInfo.academicList[i].EndDate);
                  if (eDate < new Date()) {
                    this.academicInfo.academicList[i].completed = true;
                  }
                  else {
                    this.academicInfo.academicList[i].notstarted = true;
                  }
                }
              }
              if(index_of_current != null){
                let _index_of_current = index_of_current == 0 ? 0 : index_of_current-1;
                this.academicInfo.academicList = this.academicInfo.academicList.slice(_index_of_current,index_of_current+2);
              }
            }
            if(this.loginMode == 'WEB_ADMIN'){
              this.getSchoolName();
              //this.examCategoryList();
              //this.countOfExamAndCategory();
              $("#examoverview").addClass("active");
              this.examListConfiguration();
            }
            else if(this.loginMode == 'STAFF'){
              $("#open_today_exam_list").trigger("click");
              $("#currentExamSchedule").addClass("active");
              this.getCurrentDateExamSchedule();
            }
          }
        },
        error => {

        }
      );
  }

  academicChanged(){
    for(let i=0;i<this.academicInfo.academicList.length; i++){
      if(this.academicInfo.academicList[i].pkAcademicId == this.academicInfo.current_academic){
        this.academicInfo.year = this.academicInfo.academicList[i].Year;
        this.academicInfo.current_academic_state = this.academicInfo.academicList[i].current ? 'RUNNING' : this.academicInfo.academicList[i].completed ? 'COMPLETED' : 'NOT_STARTED'
      }
    }
    if(this.academicInfo.current_tab == 'EXAM_MANAGEMENT'){
      this.examListConfiguration();
    }
    else if(this.academicInfo.current_tab == 'TODAY'){
      this.getCurrentDateExamSchedule();
    }
    else if(this.academicInfo.current_tab == 'SETTING_RESULT_PUBLISH_TYPE'){
      this.fetchResultPublishLevelType();
    }
    else if(this.academicInfo.current_tab == 'UPCOMING'){
      this.fetchClassStandardList();
      this.selectedClassStandardId = 0;
      this.upcomingDataStatus = false;
      this.upcomingListDataTable = false;
      this.upcomingExamScheduleList = [];
    }
    else if(this.academicInfo.current_tab == 'COMPLETED'){
      this.selectClassStdIdOfComplete = 0;
      this.completedDataStatus = false;
      this.completedListDataTable = false;
      this.fetchClassStandardList();
      this.completedExamScheduleList = [];
    }
    else if(this.academicInfo.current_tab == 'RESULT'){
      this.getExamBoardNameList();
      this.semesterListByBoard = [];
      this.classListForSem = [];
      this.ExamListByBoard = false;
      this.sectionListByClass = false;
      this.semDataStatus = false;
    }
    else if(this.academicInfo.current_tab == 'REPORT'){
      this.getExamBoardNameList();
      this.publishedExamList = [];
      this.classListDataTable = false;
      this.classListArray = [];
      this.showStudentList = false;
      this.studentList = [];
      this.classListForExamReport = true;
      this.selectedExamBoard = 0;
      this.selectedExamIdForClass = 0;
    }
    else if(this.academicInfo.current_tab == 'SEM_REPORT'){
      this.getExamBoardNameList();
      this.semClassReportData = true;
      this.showStudentListForSem = false;
      this.publishedSemList = [];
      this.selectedSchoolExamBoardId = 0;
      this.getSemesterId = 0;
    }
    else if(this.academicInfo.current_tab == 'REPORT_SETTING'){
      this.fetchReportCardSettings();
    }
    else if(this.academicInfo.current_tab == 'SETTING'){
      this.fetchScholasticList();
    }
    else if(this.academicInfo.current_tab == 'SETTING_SCHOLASTIC_CONFIG'){
      this.fetchScholasticConfigurationList();
    }
    else if(this.academicInfo.current_tab == 'SETTING_SCHOLASTIC_MAP'){
      this.fetchScholasticConfigurationList();
      this.classAndSectionList = [];
    }
    else if(this.academicInfo.current_tab == 'SETTING_BIFURCATION'){
      this.marksBifurcationList();
    }
    else if(this.academicInfo.current_tab == 'SETTING_SEM_CONFIG'){
      this.getExamSemesterList();
    }
    else if(this.academicInfo.current_tab == 'SETTING_RESULT_PUBLISH'){
      this.fetchResultPublishLevel();
    }
    else if(this.academicInfo.current_tab == 'PREDICTION'){
      this.callUrl();
      this.csvModelRead();
    }

  }
studentSemesterResults(){
    let studentSemesterResult = [];
    for(let i=0; i<this.studentListForSem.length; i++){
      let remarks = null;
      if(this.studentListForSem[i].Remarks){
        remarks = this.studentListForSem[i].Remarks
      }
      else {
        remarks = null;
      }
      studentSemesterResult.push({
        semesterId:this.studentListForSem[i].pkSemesterResultId,
        Remarks:remarks
      })
    }
    $("#saveSemExamResultButton").attr("disabled", true);
    $("#cancelSemExamResultButton").attr("disabled", true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#saveSemExamResultButton").text(translatedText); })
    this.examService.studentSemesterResultsService(studentSemesterResult,this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#saveSemExamResultButton").attr("disabled", false);
          $("#cancelSemExamResultButton").attr("disabled", false);
          this.translate.get('save').subscribe((translatedText: string) => { $("#saveSemExamResultButton").text(translatedText); });
          if (data.status == true) {
            const semesterResultSuccessfullySavedTranslation = await firstValueFrom(this.translate.get('semesterResultSuccessfullySaved')); 
            customToastr(semesterResultSuccessfullySavedTranslation, 'success');
          }
          else {
            const semesterResultNotSavedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('semesterResultNotSavedPleaseTryAgain')); 
            customToastr(semesterResultNotSavedPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          $("#saveSemExamResultButton").attr("disabled", false);
          $("#cancelSemExamResultButton").attr("disabled", false);
          this.translate.get('save').subscribe((translatedText: string) => { $("#saveSemExamResultButton").text(translatedText); });
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  comments = "";
  enterCommence(data){
    let commenceDetails = {
      classId:data.fkClassId,
      semesterId:this.getSemesterId,
      comments:data.comment,
      commentsId:data.pkNextTermCommenceId,
      current_academic:this.academicInfo.current_academic
    };
    if(this.formValidator.validateIsDataForNumber(data.comment)){
      this.examService.enterSchoolCommenceService(commenceDetails,this.getAuthToken)
        .subscribe(
          async (data: any) =>{
            if(data.status){
              const commenceEnteredSuccessfullyTranslation = await firstValueFrom(this.translate.get('commenceEnteredSuccessfully')); 
              customToastr(commenceEnteredSuccessfullyTranslation, 'success');
              this.getClassListBySemesterPublishedResult();
            }
            else {
              const commenceNotEnteredSuccessfullyPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('commenceNotEnteredSuccessfullyPleaseTryAgain')); 
              customToastr(commenceNotEnteredSuccessfullyPleaseTryAgainTranslation, 'error');
            }
          },
          async error =>{
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          }
        );
    }
  }
  generateReportCard(){
    this.isGenerateReport = true
    let SemDetails = {
      classId:this.getClassIdForSemReport,
      semesterId:this.getSemesterId,
      ExamBoardId:this.selectedSchoolExamBoardId,
      current_academic:this.academicInfo.current_academic
    };
    this.examService.generateReportCardService(SemDetails,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          this.isGenerateReport = false;
          if(data.status){
            const reportCardGeneratedSuccessfullyTranslation = await firstValueFrom(this.translate.get('reportCardGeneratedSuccessfully')); 
            customToastr(reportCardGeneratedSuccessfullyTranslation, 'success');
          }else{
            const failedToGenerateReportCardPleaseTryAfterSomeTimeTranslation = await firstValueFrom(this.translate.get('failedToGenerateReportCardPleaseTryAfterSomeTime')); 
            customToastr(failedToGenerateReportCardPleaseTryAfterSomeTimeTranslation, 'error');
          }
        },
        async error =>{
          this.isGenerateReport = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  examResultSettingId = null;
  fetchResultPublishLevelType(){
    this.examService.fetchExamPublishResultTypeService(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) =>{
          if(data.length > 0){
            this.examResultSettingId = data[0].pkExamPublishTypeId;
            this.resultPublishTypePercent = data[0].Percentage_status;
            this.resultPublishTypeMarks = data[0].Mark_status;
          }
          else {
            this.examResultSettingId = null;
            this.resultPublishTypePercent = true;
            this.resultPublishTypeMarks = true;
          }

        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  publishTypePercent = 1;
  publishTypeMarks = 1;

  async updateExamSettingsPercentAndMarkStatus(){

    if(this.resultPublishTypePercent == false && this.resultPublishTypeMarks == false){
      const atLeastAnyOneShouldBeEnableTranslation = await firstValueFrom(this.translate.get('atLeastAnyOneShouldBeEnable')); 
      customToastr(atLeastAnyOneShouldBeEnableTranslation, 'error');
      this.fetchResultPublishLevelType();
      return;
    }
    if(this.resultPublishTypePercent == true){
      this.publishTypePercent = 1
    }
    else if(this.resultPublishTypePercent == false){
      this.publishTypePercent = 0
    }

    if(this.resultPublishTypeMarks == true){
      this.publishTypeMarks = 1
    }
    else if(this.resultPublishTypeMarks == false){
      this.publishTypeMarks = 0
    }
    let settingData = {
      examResultSettingId:this.examResultSettingId,
      resultPublishTypePercent:this.publishTypePercent,
      resultPublishTypeMarks:this.publishTypeMarks,
      current_academic:this.academicInfo.current_academic
    };
    this.examService.updateExamPublishResultPercentTypeService(settingData,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          if(data.status == true){
            this.fetchResultPublishLevelType();
            const publishTypeSavedSuccessfullyTranslation = await firstValueFrom(this.translate.get('publishTypeSavedSuccessfully')); 
            customToastr(publishTypeSavedSuccessfullyTranslation, 'success');
          }
          else{
            const publishTypeNotSavedTranslation = await firstValueFrom(this.translate.get('publishTypeNotSaved')); 
            customToastr(publishTypeNotSavedTranslation, 'error');
          }
        },
        async error =>{
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }


  //=======================================================
  //      EXAM REMARKS AND COMMENCE ENTRY
  //=======================================================

  teacherRemarksForExams(data,status){
    let principal = null;
    let teacher = null;
    if(status == 'PRINCIPAL'){
      principal = data.PrincipalRemarks
    }
    else {
      teacher = data.TeacherRemarks;
    }

    let studentDetails = {
      classId:data.classId,
      studentId:data.studentId,
      ExamBoardId:this.selectedExamBoard,
      ExamId:this.getExamIdForReportCard,
      RemarksId:data.pkExamTeacherRemarksId,
      TeacherRemarks:teacher,
      PrincipalRemarks:principal,
      current_academic:this.academicInfo.current_academic
    };
    if(this.formValidator.validateIsDataForNumber(teacher) || this.formValidator.validateIsDataForNumber(principal)){
      this.examService.TeacherRemarksEntryForExamsService(studentDetails,this.getAuthToken)
        .subscribe(
          async (data: any) =>{
            if(data.status){
              const remarksEnteredSuccessfullyTranslation = await firstValueFrom(this.translate.get('remarksEnteredSuccessfully')); 
              customToastr(remarksEnteredSuccessfullyTranslation, 'success');
              let examData = {
                pkExamId:this.getExamIdForReportCard,
                ExamName:this.getExamNameForExam,
                classId:this.selectedClassIdForReportCard,
                IsScholasticType:this.IsScholasticTypeExam,
                classNumber:this.classNumberForExam,
                classDivision:this.classDivision,
                commence:this.examCommence
              };
              this.getStudentListByClassSection(examData);
            }
            else {
              const remarksNotEnteredSuccessfullyPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('remarksNotEnteredSuccessfullyPleaseTryAgain')); 
              customToastr(remarksNotEnteredSuccessfullyPleaseTryAgainTranslation, 'error');
            }
          },
          async error =>{
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          }
        );
    }
  }

  nextExamCommence(data){
    let commenceData = {
      current_academic:this.academicInfo.current_academic,
      ExamId:data.pkExamId,
      classId:data.classId,
      commence:data.commence,
      commenceId:data.pkExamClassCommenceId
    };
    if(this.formValidator.validateIsDataForNumber(commenceData.commence)){
      this.examService.schoolExamCommenceEntryService(commenceData,this.getAuthToken)
        .subscribe(
          async (data: any) =>{
            if(data.status){
              const examCommenceSuccessfullyEnteredTranslation = await firstValueFrom(this.translate.get('examCommenceSuccessfullyEntered')); 
              customToastr(examCommenceSuccessfullyEnteredTranslation, 'success');
              this.getClassListByExamAndBoard();
            }
            else {
              const commenceNotEnteredSuccessfullyPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('commenceNotEnteredSuccessfullyPleaseTryAgain')); 
              customToastr(commenceNotEnteredSuccessfullyPleaseTryAgainTranslation, 'error');
            }
          },
          async error =>{
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          }
        );
    }
  }

  //==========================================================================================
  //                DELETE MARKS ENTRY START
  //==========================================================================================
  deleteStatus = true;
  semesterMarksEntry = false;
  resultPublished = false;
  marksDeleteData = {state:"",resultPercentage:null,current_academic:this.academicInfo.current_academic,
    classId:null,ExamId:null,scheduleId:null
  };
  deleteExamMarksModel(state,status){
    this.semesterMarksEntry = false;
    this.resultPublished = false;
    if(state == 'SECTION'){
      if(status.PublishResultStatus == "PUBLISHED"){
        this.resultPublished = true;
        this.deleteStatus = false;
      }
      else if(status.semesterResultAvailable){
        this.semesterMarksEntry = true;
        this.deleteStatus = false;
      }
      else {
        this.deleteStatus = true;
      }
    }
    else {
      if(this.resultPublishStatus){
        this.resultPublished = true;
        this.deleteStatus = false;
      }
      else if(this.semesterMarksAvailability){
        this.semesterMarksEntry = true;
        this.deleteStatus = false;
      }
      else {
        this.deleteStatus = true;
      }
    }
    if(state == 'SECTION'){
      this.marksDeleteData = {
        current_academic:this.academicInfo.current_academic,
        ExamId:status.pkExamId,
        classId:status.classId,
        scheduleId:status.pkExamScheduleId,
        state:state,
        resultPercentage:status.resultPercentage
      }
    }
    else {
      this.marksDeleteData = {
        current_academic:this.academicInfo.current_academic,
        classId:this.selectedClassIdForResult,
        ExamId:this.selectedExamIdForResult,
        scheduleId:this.examScheduleId,
        state:state,
        resultPercentage:null
      }
    }
  }
  async deleteEnteredExamMarks(){
    if(this.marksDeleteData.state == 'SECTION' && (this.marksDeleteData.resultPercentage == 0 || this.marksDeleteData.resultPercentage == '0')){
      const resultsAreNotAvailableTranslation = await firstValueFrom(this.translate.get('resultsAreNotAvailable')); 
      customToastr(resultsAreNotAvailableTranslation, 'success');
      $("#closeDeleteMarksEntryButton").trigger('click');
      return;
    }
    $("#deleteMarksEntryButton").attr('disabled',true);
    $("#closeDeleteMarksEntryButton").attr('disabled',true);
    this.examService.deleteEnteredExamMarksService(this.marksDeleteData,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          $("#deleteMarksEntryButton").attr('disabled',false);
          $("#closeDeleteMarksEntryButton").attr('disabled',false);
          if(data.status){
            if(this.marksDeleteData.state == 'SECTION'){
              this.selectClassSection(this.marksDeleteData.ExamId);
            }
            else {
              this.selectClassSection(this.marksDeleteData.ExamId);
              $("#enterStatusShow"+this.selectedSubjectIdForResult).addClass('hide');
              this.resultDeclare(this.selectedSubjectIdForResult,this.marksDeleteData.scheduleId,this.selectedField,this.editableExamSubject);
            }
            const studentsResultAreDeletedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentsResultAreDeletedSuccessfully')); 
            customToastr(studentsResultAreDeletedSuccessfullyTranslation, 'success');
            $("#closeDeleteMarksEntryButton").trigger('click');
          }
          else {
            const studentsResultAreNotDeletedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('studentsResultAreNotDeletedPleaseTryAgain')); 
            customToastr(studentsResultAreNotDeletedPleaseTryAgainTranslation, 'success');
          }
        },
        async error =>{
          $("#deleteMarksEntryButton").attr('disabled',false);
          $("#closeDeleteMarksEntryButton").attr('disabled',false);
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }




  //==========================================================================================
  //                DELETE MARKS ENTRY END
  //==========================================================================================
}